const resourcesConfig = {
  hi: {
    home: "Home",
    navHome: "होम",
    navBookings: "बुकिंग",
    navAccount: "खाता",
    rewardClub: "Reward Club",
    getGuestMobileNumber: `To register, Please provide your Mobile number`,
    enterNumberToLogin: "अपना मोबाइल नंबर दर्ज करें",
    rewardCondition:
      "मैं Qwiky से जानकारी और ऑफ़र प्राप्त करने के लिए सहमत हूँ।",
    verifyMobileNumber: "मोबाइल नंबर की पुष्टि करें",
    recoverMobileNumber: "मोबाइल नंबर पुनर्प्राप्त करें",
    enterOtpSentOn: "OTP दर्ज करें जो {phoneNumber} पर भेजा गया है",
    invalidPhoneNumberMessage: "कृपया एक वैध मोबाइल नंबर दर्ज करें।",
    tncError: "आगे बढ़ने के लिए कृपया नियम और शर्तों से सहमत हों।",
    emptyOtpMessage: "कृपया ओटीपी दर्ज करें",
    guestProfile: "यूजर प्रोफाइल",
    provideDetails: "कृपया अपनी जानकारी प्रदान करें",
    provideMissingDetails:
      "एक आखिरी चीज, कृपया आगे बढ़ने के लिए ये विवरण प्रदान करें",
    provideDetailsForNewUser:
      "हमारे रिवॉर्ड क्लब में शामिल होने के लिए, कृपया निम्नलिखित विवरण प्रदान करें",
    notProvided: "Not Provided",
    nameFieldLabel: "नाम",
    phoneNumberLabel: "वेरिफिकेशन के लिए OTP भेजा जाएगा।",
    emailFieldLabel: "ईमेल आईडी",
    birthDateFieldLabel: "जन्म तिथि",
    anniversaryDateFieldLabel: "विवाह की सालगिरह",
    birthdayReward:
      "आपका जन्मदिन हमारे लिए भी खास है। {br} अपने जन्मदिन के महीने के लिए एक रोमांचक पुरस्कार प्राप्त करें",
    anniversaryReward:
      "हमारे साथ अपनी सालगिरह का जश्न मनाएं! {br} अपनी शादी की सालगिरह को अविस्मरणीय बनाने के लिए एक विशेष पुरस्कार का आनंद लें",
    birthDayAndAnniversaryReward:
      "आपके विशेष दिन हमारे लिए भी खास हैं। {br} अपने जन्मदिन और सालगिरह के लिए एक विशेष पुरस्कार प्राप्त करें",
    hello: "नमस्ते",
    selectOutlet: "कृपया उन आउटलेट(ों) का चयन करें जहाँ आप अधिक बार जाते हैं",
    invalidNameMessage: "कृपया एक मान्य नाम दर्ज करें",
    invalidEmailMessage: "कृपया एक मान्य ईमेल दर्ज करें",
    invalidDate: "कृपया एक मान्य तिथि दर्ज करें",
    invalidDateOfBirthMessage: "कृपया एक मान्य जन्म तिथि दर्ज करें",
    invalidDateOfAnniversaryMessage:
      "कृपया एक मान्य विवाह की सालगिरह की तिथि दर्ज करें",
    perferredOutletError: "कृपया अपने पसंदीदा आउटलेट का चयन करें।",
    emptyOutletList: "कोई आउटलेट नहीं मिला!",
    getStartedCTAText: "आरंभ करें",
    proceedCTAText: "आगे बढ़ें",
    signupCTAText: "साइन अप करें",
    loginCTAText: "लॉगिन करें",
    recoverAccountCTAText: "खाता पुनर्प्राप्त करें",
    doneCTAText: "हो गया",
    guestUserNameText: "अतिथि उपयोगकर्ता",
    continueAsGuestText: "अतिथि के रूप में जारी रखें",
    saveCTAText: "सहेजें",
    updateCTAText: "अपडेट करें",
    resendOtp: "OTP फिर से भेजें",
    locations: "स्थान",
    locationDetail: "स्थान विवरण",
    getDirection: "मार्ग प्राप्त करें",
    call: "कॉल",
    today: "आज",
    languageSettingTitle: "भाषा",
    languageSettingDescription: "ऐप की भाषा चुनें",
    hindiLanguage: "हिंदी",
    englishLanguage: "English",
    changeLanguageLabel: "भाषा बदलें",
    selectLanguageTitle: "भाषा चुनें",
    languageOptions: [
      { code: "hi", label: "हिंदी", compactLabel: "हि", englishLabel: "Hindi", symbol: "अ" },
      { code: "en", label: "English", compactLabel: "EN", englishLabel: "English", symbol: "A" },
      { code: "bn", label: "বাংলা", compactLabel: "বা", englishLabel: "Bengali", symbol: "ব" },
    ],
    slotLabel: "{date}, {timeRange}",
    "use-card-balance": "{outletCashCardTitle} बैलेंस का उपयोग करें",
    "recharge-card-balance": "{outletCashCardTitle} रिचार्ज करें",
    "card-name": "{outletCashCardTitle}",
    closed: "बंद",
    errorInfo: {
      OTP_INVALID: {
        title: "OTP वेरिफ़ाई नहीं हुआ",
        message: "ऐसा लगता है कि आपने गलत ओटीपी दर्ज किया है।",
      },
    },
    rewardsClubText: "Rewards Club",
    rewardProgramDescription:
      "A rewards club that is all about you. Some pep talk about the rewards program that goes into multiple lines covering about 50 words.",
    getAppRewardsClubDescriptionText1: "Earn points for every rupee spent",
    getAppRewardsClubDescriptionText2: "Redeem points for exciting rewards",
    getAppDownloadRewardsClubAppText: "Download app to join Rewards Club",
    getAppRewardClubBenefits: "Benefits of Rewards Club",
    getAppRewardClubOtherBenefits: "Other Benefits",
    rewardsText: "Rewards",
    couponsText: "Old Coupons",
    rewardsDetailsText: "Reward Details",
    name: "नाम",
    emailId: "ईमेल आईडी",
    mobileNo: "मोबाइल नंबर",
    dob: "जन्म तिथि",
    dateOfBirthAddedToast: "जन्म तिथि जोड़ी गई!",
    dateOfAnniversaryAddedToast: "विवाह की सालगिरह जोड़ी गई!",
    notification: "सूचनाएँ",
    appNotification: "ऐप सूचना",
    sms: "एसएमएस",
    whatsapp: "व्हाट्सएप",
    email: "ईमेल",
    rewardPointHistory: "इनाम अंक इतिहास",
    history: "इतिहास",
    rewardProgram: "इनाम कार्यक्रम",
    settings: "सेटिंग्स",
    profile: "प्रोफ़ाइल",
    shareThisApp: "इस ऐप को साझा करें",
    followUsOn: "हमारा अनुसरण करें",
    logOut: "लॉग आउट करें",
    login: "लॉग इन",
    logoutText: "लॉग आउट",
    confirmLogoutMessage: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
    logoutAllDevices: "सभी डिवाइस से लॉग आउट करें",
    deleteAccount: "खाता हटाएँ",
    pointEarned: "अंक अर्जित किए",
    pointAdjusted: "अंक समायोजित किए",
    appPermissions: "ऐप अनुमतियाँ",
    communication: "संचार",
    preferredChannelText: "मार्केटिंग संदेश प्राप्त करने के लिए पसंदीदा चैनल",
    offersText: "ऑफर",
    getCouponCTA: "कूपन प्राप्त करें",
    noBrandDealDescription: "ऐसा लगता है कि इस समय कोई ऑफर नहीं है",
    noBrandRewardDescription: "ऐसा लगता है कि इस समय कोई इनाम नहीं है",
    howThisWorks: "यह कैसे काम करता है",
    howItWorks: "यह कैसे काम करता है",
    getCouponOnSubscribe: "आपको इस इनाम को इकट्ठा करने पर एक कूपन कोड मिलेगा",
    showCouponBeforeOrder:
      "अपने आदेश देने से पहले रेस्तरां में जाएं और कूपन कोड दिखाएं",
    redeemCouponAtBillGeneration:
      "रेस्तरां बिल जनरेशन के समय आपके कूपन को भुना देगा",
    offerDetailsText: "ऑफर विवरण",
    applicableForNewCustomers: "पहली बार के ग्राहकों के लिए लागू",
    maximumDiscountText: "अधिकतम छूट ₹{maxValue}",
    alreadyHaveCoupon: "आपके पास पहले से एक कूपन कोड है",
    visitRestaurantToReedem: "भुनाने के लिए रेस्तरां पर जाएं",
    useCouponOnNextOrder: "अपने अगले आदेश पर इस कूपन का उपयोग करें",
    instantDealText: "तत्काल सौदा",
    viewDetailsText: "विवरण देखें",
    couponStreakText: "कूपन स्ट्रीक",
    couponApplicableOn: "कूपन लागू होता है",
    viewOnMap: "मानचित्र पर देखें",
    redeemedCouponAndSavedText:
      "आपने इस कूपन को भुना लिया है और {symbol}{discountAmount} बचाया है",
    redeemedCouponAndAvailedText:
      "आपने इस कूपन को भुना लिया है और मुफ्त {applicableItem} का लाभ उठाया है",
    locked: "लॉक किया गया",
    unlockCouponAfterText: "इस कूपन को {orderCount} आदेशों के बाद अनलॉक करें",
    redeemed: "भुना लिया गया",
    expired: "समय सीमा समाप्त",
    rewardExpiredOnText: "इनाम की समय सीमा समाप्त हो गई {expiredDate}",
    willUnlockOnText: "यह कूपन {unlockDate} को अनलॉक होगा",
    couponCodeLocked: "कूपन कोड लॉक किया गया",
    showCouponToAvail: "ऑफर का लाभ उठाने के लिए इस कूपन कोड को दिखाएं",
    yourCouponCode: "आपका कूपन कोड",
    goToRewardsPageCTA: "इनाम पृष्ठ पर जाएं",
    couponAdded: "कूपन को क्लेम किए गए इनाम में जोड़ा गया",
    howToRedeem: "कूपन कैसे भुनाएं",
    visitRestaurantShowCoupon:
      "रेस्तरां पर जाएं और अपने आदेश देने से पहले कूपन कोड दिखाएं",
    restaurantWillRedeem:
      "रेस्तरां आपके कूपन को भुना देगा और लागू {offerType} प्रदान करेगा",
    deleteYourAccount: "अपना खाता हटाएं",
    areYouSure: "क्या आप वाकई सुनिश्चित हैं?",
    allInformationWillBeLost:
      "आपके खाते से संबंधित सभी जानकारी हमेशा के लिए खो जाएगी।",
    otpSent: "OTP भेजा गया",
    resendOtpCaps: "फिर से OTP भेजें",
    points: "अंक",
    rewardPointsText: "R E W A R D {br} P O I N T S",
    rewardPointsSpentDescription: "{rewardPoints} {currencyName} उपलब्ध हैं",
    unlockRewardMilestoreDescription:
      "इनाम को {pointPrice} अंकों तक पहुँचने पर अनलॉक करें",
    viewOldCoupons: "पुराने कूपन देखें",
    viewMoreText: "और देखें",
    myRewards: "मेरे इनाम",
    myRewardsDescription: "अपने एकत्रित इनाम को अगले आदेश पर भुनाएं",
    noRewardsText: "इस समय कोई इनाम नहीं है",
    redeemableRewardsText: "आपके सभी भुनाने योग्य इनाम यहाँ दिखाए जाएंगे",
    excitingOffers: "रोमांचक ऑफ़र",
    excitingOffersDescription:
      "हमारे पास आपकी अगली यात्रा के लिए कुछ रोमांचक ऑफ़र हैं। यह सीमित समय के लिए है, अपने कूपन को समाप्त होने से पहले प्राप्त करें।",
    pointsRedeemed: "अंक भुनाए गए",
    pointsUsed: "अंक का उपयोग किया गया",
    pointsEarnedForSpending: "खर्च की गई राशि {currencySymbol} {netAmount}",
    claimedReward: "क्लेम किया गया इनाम - {sourceName}",
    noDataToShow: "दिखाने के लिए कोई डेटा नहीं",
    viewRewards: "इनाम देखें",
    claimRewards: "इनाम प्राप्त करें",
    loginCTA: "लॉगिन करें",
    loginRequiredTitle: "लॉगिन आवश्यक",
    viewOffers: "ऑफर देखें",
    dealRedeemedPopupTitle: "कूपन पहले ही भुना लिया गया",
    dealRedeemedPopupDescription:
      "नमस्ते {username},{br}  आपने पहले ही {redeemDate} को कूपन भुना लिया है और {amount} की छूट प्राप्त की है। हमारे पास एक कूपन है जिसमें आपकी रुचि हो सकती है।",
    dealAlreadyRedeemedItemFreeDescription:
      "नमस्ते {username},{br} आपने पहले ही {redeemDate} को कूपन भुना लिया है और मुफ्त आइटम का लाभ उठाया है। हमारे पास एक कूपन है जिसमें आपकी रुचि हो सकती है।",
    dealAlreadySubscribedDescription:
      "नमस्ते {username},{br} आपने पहले ही {subscribedDate} को इस कूपन का दावा किया है। कृपया कूपन कोड देखने के लिए क्लेम किए गए इनाम अनुभाग की जांच करें",
    lastUpdatedText: "अंतिम अपडेट",
    redeemOn: "भुना लिया गया {redeemTime} को",
    expiredOn: `समय सीमा समाप्त {expireTime} को`,
    validTill: "समय सीमा {expireTime} तक",
    validFromTo: "समय सीमा {redeemableTime} - {expireTime} तक",
    validFrom: "समय सीमा {redeemableTime} से",
    validOn: "समय सीमा {time} को",
    added: "जोड़ा गया",
    deducted: "घटाया गया",
    pointsText: "अंक",
    actionText: "क्रिया",
    activityDetails: "गतिविधि विवरण",
    dateAndTime: "तारीख और समय",
    billNo: "बिल संख्या",
    billAmount: "बिल राशि",
    outlet: "आउटलेट",
    claimedRewardText: "क्लेम किया गया {br} इनाम",
    earnPointOneSpend: "हर खर्च पर अंक अर्जित करें",
    earnPoints: "अंक अर्जित करें",
    unlockRewards: "इनाम अनलॉक करें और प्राप्त करें",
    unlockRewardsPromotion: "इनाम अनलॉक करें",
    redeem: "भुनाएं",
    redeemEarnedRewardsOnNextVisit:
      "कूपन कोड दिखाएं और अपनी एकत्रित इनाम को अपनी अगली यात्रा पर भुनाएं।",
    redeemEarnedRewardsOnNextVisitPromotion:
      "अपनी अगली यात्रा पर अपने अर्जित इनाम भुनाएं।",
    getBirthdayRewards: "जन्मदिन के इनाम प्राप्त करें",
    getAnniversaryRewards: "विवाह वर्षगांठ के इनाम प्राप्त करें",
    addBirthday: "जन्मदिन जोड़ें",
    addAnniversary: "विवाह वर्षगांठ जोड़ें",
    manyMoreOffers: "और भी कई ऑफ़र",
    reasonToVisitUsAgain:
      "हम सुनिश्चित करते हैं कि आपके पास हमें फिर से देखने का हमेशा एक कारण हो।",
    birthdayRewardCardTitle:
      "अपने जन्मदिन के महीने के लिए रोमांचक इनाम प्राप्त करें",
    anniversaryRewardCardTitle:
      "अपने विवाह वर्षगांठ के महीने के लिए रोमांचक इनाम प्राप्त करें",
    claimBirthdayRewardText: "जन्मदिन का इनाम",
    claimAnniversaryRewardText: "विवाह वर्षगांठ का इनाम",
    birthdayRewardsText: "जन्मदिन के इनाम",
    welcomeRewardText: "स्वागत इनाम",
    welcomeRewardDescription: "आपका इनाम बस एक टैप दूर है",
    redeemRewardPointsText: "इनाम एकत्र करें {currencyName} के साथ",
    pointsAvailable: "{rewardPoints} {currencyName} उपलब्ध हैं",
    birthdayRewardsTitle:
      "अपने जन्मदिन के महीने के लिए विभिन्न पुरस्कारों में से चुनें",
    birthdayRewardDetails: "जन्मदिन के इनाम का विवरण",
    claimCTAText: "इसे प्राप्त करें",
    birthdayRewardAvailableDate: "उपलब्ध {startDate} - {endDate} से",
    anniversaryRewardAvailableDate: "उपलब्ध {startDate} - {endDate} से",
    active: "सक्रिय",
    noActiveRewardText: "इस समय कोई सक्रिय इनाम नहीं है",
    noInactiveRewardText: "इस समय कोई भुना हुआ / समाप्त इनाम नहीं है",
    redeemedOrExpired: "भुना हुआ / समाप्त",
    greeterContent: "तुम्हारे लौटने पर खुशी हुई",
    notTakenRewards: `आपने अभी तक कोई इनाम नहीं लिया है`,
    invalidOTPMessage: "आपके द्वारा दर्ज किया गया ओटीपी गलत है",
    showThisCodeToRedeem:
      "इस कूपन को दिखाएँ{br} अपनी अगली ऑर्डर पर भुनाने के लिए",
    cretingSomethingExciting:
      "हम कुछ रोमांचक बना रहे हैं !!! {br} कृपया बाद में जांचें",
    swipeToClaimReward: "क्लेम करने के लिए स्वाइप करें",
    joinRewardClubLink: "अभी तक सदस्य नहीं हैं? {joinRewardsClub}",
    joinRewardsClub: "इनाम क्लब में शामिल हों",
    alreadyAMember: "Already a Member? {login}",
    welcomeRewardsText: "स्वागत इनाम",
    welcomeRewardDetails: "स्वागत इनाम का विवरण",
    welcomeRewardsTitle: "विभिन्न पुरस्कारों में से चुनें",
    anniversaryRewardsText: "विवाह वर्षगांठ के इनाम",
    anniversaryRewardDetails: "विवाह वर्षगांठ के इनाम का विवरण",
    anniversaryRewardsTitle:
      "अपने विवाह वर्षगांठ के महीने के लिए विभिन्न पुरस्कारों में से चुनें",
    claimRewardCTAText: "इनाम एकत्र करें",
    greetingSubtitle: " ",
    greetingTitle: " ",
    joiningRewardText: "जुड़ने का इनाम",
    joiningReward:
      "हम अपने मेहमानों का स्वागत करना जानते हैं। इनाम क्लब में शामिल होने पर एक विशेष इनाम प्राप्त करें।",
    accountAlreadyExists: "खाता मौजूद है। कृपया लॉग इन करें।",
    accountNotExists: "खाता मौजूद नहीं है। कृपया साइन अप करें।",
    welcomeOnboard: "स्वागत है,{br} {name}",
    viewOtherBenefits: "अन्य लाभ देखें",
    collectPoint: "हर {unit} {spend} पर {earn} अंक एकत्र करें।",
    collectPointWithCurrency:
      "हर {unit} {spend} पर {earn} {currencyName} एकत्र करें।",
    collectPointInPer:
      "बिल के मूल्य का {earn}{unit} {currencyName} के रूप में अर्जित करें",
    collectPointWithFixedAndMinSpend:
      "हर ऑर्डर पर {minSpend} के न्यूनतम ऑर्डर के साथ {earn} अंक अर्जित करें",
    collectPointinFixed:
      "हर ऑर्डर पर बिना किसी न्यूनतम ऑर्डर मूल्य के {earn} अंक अर्जित करें",
    collectMaxPointInPer:
      "बिल के मूल्य का अधिकतम {earn}{unit} {currencyName} के रूप में अर्जित करें",
    earnPointOnSelectedItems:
      "हर बार जब आप {tag} खरीदते हैं तो {earn} {currencyName} अर्जित करें",
    spendAndEarnPoint:
      "हर बार जब आप खर्च करते हैं, तो आप अंक एकत्र करते हैं। {unit} {spend} खर्च = {earn} अंक।",
    minRedeemPoints:
      "जब आप {minRedeemPrice} अंक तक पहुँचते हैं, तो आप विभिन्न पुरस्कारों में से चुन सकते हैं। अपने पसंदीदा पुरस्कार को एकत्र करें।",
    minRedeemPointsPromotion:
      "जब आप {minRedeemPrice} अंक तक पहुँचते हैं, तो आप विभिन्न पुरस्कारों में से चुन सकते हैं।",
    unlockRewardOn:
      "जब आप {minRedeemPrice} अंक तक पहुँचते हैं, तो पुरस्कार अनलॉक करें।",
    useEarnPoints: "अपने अगले ऑर्डर पर अर्जित अंकों का उपयोग करें",
    useEarnPointsWithCurrency:
      "अपने ऑर्डर के लिए {currencyName} के साथ भुगतान करें",
    userEarnPointInPer:
      "इन सिक्कों का उपयोग करके अपने बिल के {spend}{unit} तक भुगतान करें",
    okGotIt: "ठीक है, समझ गया",
    knowMore: "और जानें",
    dealSubscribedPopupTitle: "कूपन पहले ही दावा किया गया है",
    rewardApplicableOn: "कूपन लागू होता है",
    nearbyOutlets: "नजदीकी आउटलेट",
    limitedOutletCouponTnC:
      "कूपन सीमित आउटलेट पर लागू होता है। कृपया नीचे दी गई सूची देखें",
    singleUseCouponTnC: "यह एक एकल उपयोग कूपन है",
    offerNotClubbedCouponTnC:
      "यह ऑफ़र किसी अन्य ऑफ़र के साथ नहीं जोड़ा जा सकता है",
    redemptionCouponTnC: "कूपन का विमोचन रेस्तरां के विवेकाधीन है",
    minimumOrderValueCouponTnC:
      "न्यूनतम ऑर्डर राशि {currencySymbol}{minOrderValue} है। यह करों और अन्य शुल्कों से मुक्त होना चाहिए।",
    newlyLaunchedOutlets: "नए लॉन्च किए गए आउटलेट",
    limitedOutletCouponTnC2: "कूपन सीमित आउटलेट पर लागू होता है।",
    nextOfferActivateCouponTnC:
      "अगला ऑफ़र पिछले कूपन के विमोचन के {couponApplicableAfter} के बाद सक्रिय होगा।",
    maximumDiscountCouponTnC:
      "प्रति आदेश अधिकतम छूट {currencySymbol}{maxValue} है",
    orderModeApplicabilityCouponTnC: "केवल {orderModes} आदेशों पर लागू होता है",
    getOffer: "प्राप्त करें {offer}",
    limitedTimeOffersText: "सीमित समय के लिए ऑफ़र",
    appUpdateTitle: "{brandName} ऐप को अपडेट करने की आवश्यकता है",
    appUpdateDescription:
      "इस ऐप का उपयोग करने के लिए, आपको इस ऐप को नवीनतम संस्करण में अपडेट करना होगा।",
    appUpdatePrimaryCTA: "अपडेट करें",
    recentlyVisitedOutlets: "हाल ही में देखे गए आउटलेट",
    orderTitle: "ऑर्डर",
    yourOrder: "आपका ऑर्डर",
    coupons: "कूपन",
    promoCode: "प्रोमो कोड",
    coins: "सिक्के",
    additionalDetails: "अतिरिक्त विवरण",
    proceedToPayCTAText: "भुगतान करने के लिए आगे बढ़ें",
    selectDeliveryLocation: "डिलीवरी स्थान चुनें",
    cartHeaderTitle: "कार्ट",
    itemTotalText: "आइटम कुल",
    discountText: "छूट",
    additionalDiscount: "अतिरिक्त छूट",
    freeItemText: "मुफ्त आइटम",
    taxesText: "कर",
    toPayText: "भुगतान करने के लिए",
    amountText: "{currencySymbol}{amount}",
    discountAmountText: "- {currencySymbol}{amount}",
    offerItemText: "ऑफ़र आइटम",
    offerItemsText: "ऑफ़र आइटम",
    freeText: "मुफ्त",
    userAccessBlocked: "उपयोगकर्ता पहुंच अवरुद्ध",
    gotToHomeCTA: "मुख्य पृष्ठ पर जाएं",
    userAccessBlockedDescription:
      "यह पुरस्कार एकत्र नहीं किया जा सकता। {br} इस खाते से संबंधित मोबाइल नंबर को प्रशासन द्वारा अवरुद्ध कर दिया गया है।",
    mobileNumberBlocked: "यह मोबाइल नंबर प्रशासन द्वारा अवरुद्ध है।",
    offerCollectedMultipleTimes:
      "यह ऑफ़र {perGuestMax} बार एकत्र किया जा सकता है।",
    offerAlreadyRedeemedMultipleTimes:
      "आपने पहले ही इस ऑफ़र का कई बार विमोचन किया है, कृपया विवरण देखने के लिए अधिक > इतिहास पर जाएं",
    addAmountToApplyCoupon: "इस कूपन को लागू करने के लिए और Rs {amount} जोड़ें",
    orderPlaced: "ऑर्डर दिया गया",
    orderConfirmed: "ऑर्डर की पुष्टि की गई",
    orderPartiallyConfirmed: "ऑर्डर आंशिक रूप से पुष्टि की गई",
    orderReady: "ऑर्डर तैयार है",
    orderServed: "ऑर्डर परोसा गया",
    orderCancelled: "ऑर्डर रद्द कर दिया गया",
    orderFailed: "ऑर्डर विफल",
    receivedOrderConfirmShortly:
      "हमने आपका ऑर्डर प्राप्त कर लिया है और इसे जल्द ही पुष्टि करेंगे",
    startedPreparingOrder:
      "हमने आपके ऑर्डर की तैयारी शुरू कर दी है। यह {preparationTime} तक तैयार होगा",
    startedPreparingOrderWithoutTime: "हमने आपके ऑर्डर की तैयारी शुरू कर दी है",
    someItemCancelled: "कुछ आइटम रद्द कर दिए गए हैं",
    orderServedEnjoyMeal: "आपका ऑर्डर परोसा गया है। अपने भोजन का आनंद लें!",
    orderUnavailable:
      "क्षमा करें, आपका ऑर्डर इस समय उपलब्ध नहीं है। काटी गई राशि 7 कार्य दिवसों के भीतर वापस कर दी जाएगी।",
    transactionFailed:
      "लेनदेन विफल: यदि कोई धन काटा गया है, तो इसे 7 कार्य दिवसों के भीतर वापस कर दिया जाएगा।",
    viewCancelledItems: "रद्द किए गए आइटम देखें",
    orderId: "ऑर्डर आईडी",
    orderNo: "ऑर्डर संख्या",
    dateTime: "तारीख और समय",
    discount: "छूट",
    total: "कुल",
    orderDetails: "ऑर्डर विवरण",
    paymentDetails: "भुगतान विवरण",
    refundDetails: "रिफंड विवरण",
    applyRewardCoupon: "कूपन लागू करें / {currencyName}",
    applyCouponText: "कूपन लागू करें",
    emptyMenuListPlaceholder:
      "खोज मानदंडों से मेल खाने वाले कोई परिणाम नहीं हैं। मेनू देखने के लिए कृपया खोज साफ़ करें।",
    emptyApplicableMenuListPlaceholder: "इस समय कोई आइटम उपलब्ध नहीं हैं।",
    tableNumber: "टेबल {number}",
    scanQrCode: "स्कैन {br} क्यूआर कोड",
    outletReadMode: "हम इस समय ऑनलाइन ऑर्डर स्वीकार नहीं कर रहे हैं",
    outletDeactiveMode: "हम इस समय ऑनलाइन ऑर्डर स्वीकार नहीं कर रहे हैं",
    outletClosedMode: "हम आज के लिए बंद हैं",
    outletNotOpenMode: "हम आज के लिए अभी तक खुले नहीं हैं",
    notAcceptionOrdersText:
      "हम इस समय {serviceType} ऑर्डर स्वीकार नहीं कर रहे हैं",
    accountDeletionStarted: "खाता हटाने की प्रक्रिया शुरू हो गई है",
    recoverAccountText:
      "यदि आप अपने खाते को पुनर्प्राप्त करना चाहते हैं, तो बस पुनर्प्राप्त करें बटन पर टैप करें और ओटीपी के साथ सत्यापित करने के लिए चरणों का पालन करें। किसी भी सहायता के लिए, कृपया हमसे support@qwiky.in पर संपर्क करें।",
    outOfRestaurantScopeErrorDescription:
      "ऐसा लगता है कि यह क्यूआर {brandId} से संबंधित नहीं है।{br} कृपया एक मान्य {brandId} का क्यूआर कोड स्कैन करें।",
    aboutUs: "हमारे बारे में",
    orders: "ऑर्डर",
    menu: "मेनू",
    recommended: "सिफारिश की गई",
    cameraAccessError: "ऐसा लगता है कि कैमरा एक्सेस अवरुद्ध है",
    enterManualCode: "कृपया क्यूआर कोड के नीचे उल्लिखित रेस्तरां कोड दर्ज करें",
    scanQRCodeText: "क्यूआर कोड स्कैन करें",
    undetectScanCode: "स्कैन करने में असमर्थ",
    enterCodeCTA: "कोड दर्ज करें",
    nonFudrQRCodeText: "कृपया एक {brandId} क्यूआर कोड स्कैन करें",
    enterCodeError:
      "गलत रेस्तरां कोड। कृपया कोड की जांच करें और पुनः प्रयास करें।",
    invalidCodeError: "कृपया मान्य रेस्तरां कोड दर्ज करें।",
    scanCodeText: "कोड स्कैन करें",
    viewMenuCTA: "मेनू देखें",
    pickupTimePopupTitle: "पिकअप समय",
    pickupTimePopupDescription:
      "कृपया हमें अपने अनुमानित आगमन समय के बारे में बताएं। इससे हमें आपकी बेहतर सेवा करने में मदद मिलेगी।",
    selectCityTitle: "शहर चुनें",
    viewCartCTA: "कार्ट देखें",
    menuCategoriesTitle: "मेनू खोजें",
    lastUpdatedTime: "अंतिम अपडेट {time}",
    collectReward: "इनाम एकत्र करें",
    itemDetailsTitle: "आइटम विवरण",
    pickupOrderInstruction:
      "आपको इस ऑर्डर को {br} {restaurantName} से पिकअप करना होगा",
    couponApplied: "कूपन लागू किया गया",
    itemsInCartPopupTitle: "कार्ट में आइटम",
    itemsInCartChangeOutletPopupDescription:
      "यदि आप आउटलेट बदलते हैं तो आप अपनी कार्ट में आइटम खो देंगे",
    itemsInCartChangeModePopupDescription:
      "यदि आप मोड बदलते हैं तो आप अपनी कार्ट में आइटम खो देंगे",
    changeOutletCTA: "आउटलेट बदलें",
    changeModeCTA: "मोड बदलें",
    collectRewardsDescription:
      "आप अपने {currencyName} का उपयोग करके इनाम एकत्र कर सकते हैं।{br} इनाम पृष्ठ पर जाएं और इनाम एकत्र करें",
    updateAppTitle: "ऐप अपडेट उपलब्ध है",
    updateAppDescription:
      "ऐप का एक नया संस्करण उपलब्ध है। सर्वोत्तम अनुभव के लिए अभी अपडेट करें।",
    updateAppCTA: "ऐप अपडेट करें",
    selectOptional: "वैकल्पिक",
    selectOne: "एक चुनें",
    repeatCustomizationPopupTitle: "अंतिम अनुकूलन दोहराएँ?",
    getDirections: "मार्ग निर्देश प्राप्त करें",
    orderCTA: "ऑर्डर करें",
    outletTimings: "समय",
    multipleCustomizationsPopupTitle: "एकाधिक अनुकूलन",
    multipleCustomizationsPopupCTA: "कार्ट पर जाएं",
    multipleCustomizationsPopupDescription:
      "इस आइटम में कई अनुकूलन जोड़े गए हैं। आइटम हटाने के लिए कार्ट पर जाएं?",
    multipleCustomizationsBogoPopupDescription:
      "इस आइटम में कई अनुकूलन जोड़े गए हैं। नीचे चयनित आइटम सूची से इस आइटम को हटाएं।",
    noOrdersToShow: "कोई ऑर्डर दिखाने के लिए नहीं",
    orderingComingSoon: "ऑर्डरिंग जल्द ही आ रहा है",
    nonExistSubdomainFallbackTitle: "इस पेज तक नहीं पहुँचा जा सकता",
    nonExistSubdomainFallbackDescription:
      "ऐसा लगता है कि कुछ त्रुटि हुई है। कृपया कुछ समय बाद प्रयास करें",
    nonExistSubdomainFallbackCTA: "फिर से प्रयास करें",
    nonVeg: "नॉन वेज",
    pureVeg: "प्योर वेज",
    customizable: "अनुकूलन योग्य",
    orderRunning: "{count} ऑर्डर चल रहा है",
    orderAgain: "फिर से ऑर्डर करें",
    moreDetails: "अधिक विवरण",
    selectOutletManuallyCTA: "मैन्युअल रूप से आउटलेट चुनें",
    locationPermissionDenialTitle:
      "आपके डिवाइस का स्थान निर्धारित करने में असमर्थ।",
    locationPermissionDenialDescriptionAndroid:
      "सर्वश्रेष्ठ अनुभव के लिए, कृपया डिवाइस के स्थान तक पहुंच की अनुमति दें। सेटिंग्स पर जाएं > {brandName} ऐप > स्थान तक पहुंच की अनुमति दें",
    locationPermissionDenialDescriptionIOS:
      "सर्वश्रेष्ठ अनुभव के लिए, कृपया डिवाइस के स्थान तक पहुंच की अनुमति दें। सेटिंग्स पर जाएं > {brandName} ऐप > स्थान तक पहुंच की अनुमति दें",
    locationPermissionDenialDescriptionBrowser:
      "सर्वश्रेष्ठ अनुभव के लिए, कृपया डिवाइस के स्थान तक पहुंच की अनुमति दें।",
    addCTA: "जोड़ें",
    viewCTA: "देखें",
    earnPointsPopupTitle: "इनाम कार्यक्रम",
    helpFaqTitle: "सहायता और समर्थन",
    helpSupportTitle: "हम आपकी कैसे मदद कर सकते हैं?",
    supportDescription:
      "हमारी सहायता टीम हर दिन सुबह 7 बजे से रात 9 बजे तक उपलब्ध है।",
    helpSupportMail: "support@qwiky.in",
    pointsRefreshedToast: "{currencyName} सफलतापूर्वक अपडेट किया गया",
    pointsRefreshDelayInMS: 1000,
    refundTxnInitiated:
      "₹{totalRefundAmount} का रिफंड {initiateDate} को शुरू किया गया",
    refundTxnProcessed:
      "₹{totalRefundAmount} का रिफंड {processedDate} को संसाधित किया गया",
    someItemCancelledPostPaidOrder: "इस ऑर्डर में कुछ आइटम रद्द कर दिए गए थे",
    someItemCancelledPrePaidOrder:
      "इस ऑर्डर में कुछ आइटम रद्द कर दिए गए थे। बैलेंस राशि 3-5 कार्य दिवसों में वापस की जाएगी",
    dineInMinDistanceInMeter: 1000,
    selfPickupMinDistanceInKM: 10,
    notAtOutlet: "आउटलेट पर नहीं",
    tooFarFromOutet: "आउटलेट से बहुत दूर",
    outletOutOfRangeDescription:
      "ऐसा लगता है कि आप आउटलेट से बहुत दूर हैं। कृपया सुनिश्चित करें कि आप सही आउटलेट पर ऑर्डर कर रहे हैं",
    okUnderstandCTA: "ठीक है, मैं समझ गया",
    loaderTimeoutInMilliSeconds: 5000,
    repeatLast: "पिछला दोहराएँ",
    addNew: "नया जोड़ें",
    howToRedeemText: "कैसे रिडीम करें",
    collectRewardOnlineInstruction:
      "इनाम प्राप्त करें, ऐप से ऑर्डर करें और कार्ट पृष्ठ पर कूपन लागू करें",
    collectRewardOfflineInstruction:
      "इनाम प्राप्त करें, रेस्तरां पर जाएं और ऑर्डर देते समय रेस्तरां से कूपन लागू करने के लिए कहें।\nरेस्तरां को कूपन को रिडीम करने के लिए ओटीपी उत्पन्न करने के लिए आपके पंजीकृत मोबाइल नंबर की आवश्यकता होगी।",
    orDivider: "--OR--",
    subscribeMembershipOnlineInstruction:
      "सदस्यता लें, ऐप से ऑर्डर करें और कार्ट पृष्ठ पर कूपन लागू करें",
    subscribeMembershipOfflineInstruction:
      "सदस्यता लें, रेस्तरां पर जाएं और ऑर्डर देते समय रेस्तरां से कूपन लागू करने के लिए कहें।\nरेस्तरां को कूपन को रिडीम करने के लिए ओटीपी उत्पन्न करने के लिए आपके पंजीकृत मोबाइल नंबर की आवश्यकता होगी।",
    emptyVariations: "वर्तमान चयन इस समय उपलब्ध नहीं है",
    streakItemSequenceTitle: "{sequence} ऑर्डर",
    rewardPointEarnedTextWithCurrency: `{rewardPoints} {currencyName} {br} इस ऑर्डर पर अर्जित`,
    rewardPointEarnedText: `{rewardPoints} {br} इस ऑर्डर पर अर्जित`,
    useRewardPoint: "उपयोग करें {currencyName}",
    rewardPointUsed:
      "{redeemablePoints} {currencyName} का उपयोग किया जाएगा {br} उपलब्ध - {balancePoints} अंक",
    availablePointToUse:
      "उपलब्ध - {balancePoints} अंक {br} {redeemablePoints} {currencyName} का उपयोग किया जाएगा",
    zeroPointAvailable: "उपलब्ध - {balancePoints} अंक",
    pointDiscountText: "छूट ({currencyName})",
    savedOnOrder: "आप इस ऑर्डर पर {currencySymbol}{amount} बचाएंगे",
    youWillSave: "आप {currencySymbol}{amount} बचाएंगे",
    rewardPointsTitle: "{currencyName}",
    okGotItCTA: "ठीक है, मैं समझ गया",
    billAmountPaidWithPoints:
      "अपने अर्जित अंकों को अपने अगले ऑर्डर पर रिडीम करें। {billAmount}% बिल राशि का भुगतान {currencyName} का उपयोग करके किया जा सकता है",
    maxRedeemablePointsPer:
      "एक ऑर्डर पर उपलब्ध {currencyName} का अधिकतम {maxValue}% उपयोग किया जा सकता है",
    maxRedeemablePoints:
      "प्रत्येक ऑर्डर पर {maxValue} {currencyName} की सीमा लागू होती है",
    vipPassTitle: "{vipPass}",
    vipPassSubtitle: "विभिन्न प्रकार के {vipPass} में से चुनें।",
    vipMaxDiscount: "अधिकतम छूट ₹{maxValue} प्रति ऑर्डर",
    vipPassDetailsText: "{vipPass} विवरण",
    swipeToBuy: "खरीदने के लिए स्वाइप करें",
    redeemPointOnNextOrder:
      "अपने अर्जित अंकों को अपने अगले ऑर्डर पर रिडीम करें। {percentage}% बिल राशि का भुगतान रिवॉर्ड पॉइंट्स के माध्यम से किया जा सकता है।",
    rewardPointToMoney: "{point} {currencyName} = {currencySymbol}{amount}",
    passDetails: "पार्श्व विवरण",
    noMembershipDescription: "ऐसा लगता है कि आपने अभी तक कोई पास नहीं लिया है",
    vipPassActiveDays: "मान्य {activeDays} दिन",
    membershipValidity: "मान्य {membershipExpirationTime} तक",
    renew: "नवीनीकरण",
    membershipPuschased: "खरीदा गया - {activationTime}",
    membershipConclulded: "समाप्त - {expireTime}",
    renewMembershipText:
      "{vipPass} समाप्त हो गया है। अपने पास को नवीनीकरण करें और फिर से लाभ उठाते रहें",
    membershipCouponUsed: "{totalUsed} कूपन का उपयोग किया गया",
    backToHomeCTA: "होम पर वापस जाएं",
    stopAndBuy: "वर्तमान पास को रोकें और इस पास को खरीदें",
    buyThisPass: "इस पास को खरीदें",
    stopAndBuyVIPDescription:
      "यदि आप इस पास को खरीदते हैं, तो आपके वर्तमान सक्रिय {vipPass} के शेष लाभ बंद कर दिए जाएंगे",
    vipPassBuyErrorMessage:
      "यदि आप इस पास को खरीदते हैं, तो आपके वर्तमान सक्रिय {vipPass} के शेष लाभ बंद कर दिए जाएंगे",
    couponRedeemedOn: "रिडीम किया गया {expireTime} पर",
    couponValidity: "मान्य {expireTime} तक",
    noCouponToShow: "दिखाने के लिए कोई कूपन नहीं है",
    membershipCouponPerGuestMax:
      "पास {perGuestMax} ऑर्डर के लिए मान्य है {activeDays} दिन",
    recaptchaBranding:
      "यह साइट reCAPTCHA द्वारा सुरक्षित है और Google {privacyPolicyLink} और {tncLink} लागू होते हैं",
    recaptchaPrivacyPolicy: "गोपनीयता नीति",
    recaptchaTnC: "नियम और शर्तें",
    savedByUsingRewardPoint:
      "आपने इस ऑर्डर पर {point} {currencyName} का उपयोग करके ₹{amount} बचाए",
    rewardPoints: "इनाम अंक",
    loyaltyPoints: "निष्ठा अंक",
    redeemPoints: "अंक भुनाएं",
    membershipAlreadySubscribedTitle: "पास पहले से सक्रिय है",
    membershipAlreadySubscribedDescription:
      "ऐसा लगता है कि आप जिस पास की सदस्यता लेना चाहते हैं वह पहले से आपके खाते के लिए सक्रिय है",
    stayHereCTA: "यहां रहें",
    passName: "पास का नाम",
    purchasedOn: "खरीदा गया",
    validTillText: "मान्य {expireTime} तक",
    amount: "राशि",
    paymentMode: "भुगतान मोड",
    paymentStatus: "भुगतान स्थिति",
    transactionOn: "लेनदेन पर",
    referenceId: "संदर्भ आईडी",
    refundMode: "रिफंड मोड",
    refundStatus: "रिफंड स्थिति",
    remark: "टिप्पणी",
    initiatedOn: "शुरू किया गया",
    processedOn: "प्रोसेस किया गया",
    paymentFailed: "भुगतान विफल",
    passPaymentFailedDescription:
      "इस पास के लिए भुगतान प्राप्त नहीं हुआ है। यदि कोई राशि काटी गई है, तो उसे 7 कार्य दिवसों के भीतर वापस कर दिया जाएगा।",
    updateRewardProgramTitle: "हमने अपने {br} इनाम कार्यक्रम को अपडेट किया है",
    seeWhatsNewCTA: "नया क्या है देखें",
    rewardPointRedeemRule:
      "अपने बिल का {maxEarn}{unit} तक का भुगतान {currencyName} से करें। {earn} {currencyName} = {currency}{spend}",
    updateRewardProgramTnC:
      "आपके वर्तमान इनाम अंक {currencyName} में परिवर्तित किए जाएंगे। {br} {br} सभी एकत्रित पुरस्कार भुनाने के लिए उपलब्ध होंगे",
    unlimitedOrders: "सभी",
    minCartValueForPointsRedemption:
      "इस ऑर्डर पर {currencyName} लागू करने के लिए, कम से कम {currencySymbol}{minOrderValue} (टैक्स से पहले) का ऑर्डर ज़रूरी है।",
    minCartValueForPointsRedemptionRewardDetails:
      "{currencyName} can be applied on orders above {currencySymbol}{minCartValueForPointsRedemption}",
    deliveryLocation: "डिलीवरी स्थान",
    selectLocation: "स्थान चुनें",
    addressDetails: "पता विवरण",
    deliveryLocationTitle: "कृपया अपने स्थान की पुष्टि करें",
    addressLine: "घर / फ्लैट / मंजिल संख्या",
    landmark: "अपार्टमेंट / सड़क / क्षेत्र",
    addressMaxLength: 200,
    saveAs: "सहेजें",
    office: "कार्यालय",
    other: "अन्य",
    notdeliverableText: "क्षमा करें, हम इस स्थान पर डिलीवरी नहीं कर रहे हैं",
    selectDeliveryAddress: "डिलीवरी पता चुनें",
    deleteYourAddress: "पता हटाएं",
    dontDelete: "DON'T DELETE",
    delete: "DELETE",
    areYouSureAddress: "क्या आप सुनिश्चित हैं, आप इस पते को हटाना चाहते हैं",
    placeHolderTitle: "जैसे. जॉन का स्थान",
    deliveringAt: "डिलीवरी हो रही है",
    deliveredAt: "डिलीवर किया गया",
    orderOutforDelivery: "डिलीवरी के लिए बाहर",
    orderDelivered: "ऑर्डर डिलीवर किया गया",
    orderoutDescription: "{rider} डिलीवरी के लिए बाहर है और जल्द ही वहां होगा",
    orderoutEtaDescription:
      "{rider} डिलीवरी के लिए बाहर है और {time} तक वहां होगा",
    orderoutDescriptionDefault:
      "Our rider is out for delivery and will be there soon",
    orderDeliveredDescription: "Your order has been delivered Enjoy your meal!",
    orderReadyforDispatch: "Your order is ready and will be dispatched shortly",
    orderReadyforPickup:
      "Your order is ready{br}Please collect it from the counter",
    deliverTo: "डिलीवरी करें",
    membershipExpiredTitle: "आपका {vipPassTitle} समाप्त हो गया है।",
    getNewPassCTA: "नया पास प्राप्त करें",
    membershipExpiredDescription: "नया पास लें और छूट का आनंद लेते रहें।",
    discountSavedUsingMembership:
      "आपने इस पास का उपयोग {totalUsed} बार किया है और {currencySymbol}{totalDiscount} की बचत की है।",
    whereYouAt: "आप कहाँ हैं?",
    chooseOutlet: "उस आउटलेट का चयन करें जहाँ आप भुगतान कर रहे हैं।",
    selectBrand: "ब्रांड चुनें",
    payingAtOutlet: "भुगतान कर रहे हैं - {outletName}",
    totalPayable: "कुल देय",
    willSaveAmount: "आप {currency}{amount} की बचत कर रहे हैं",
    billPaid: "बिल का भुगतान किया गया",
    billCanPaidWithPoints:
      "{billAmount}% बिल का भुगतान {currencyName} से किया जा सकता है",
    everySpendEarnPoint:
      "हर {unit}{spend} खर्च करने पर, आप {earn} {currencyName} कमाते हैं",
    spotlightTitle: "स्पॉटलाइट",
    mapMarkerDeliveryText: "सटीक स्थान पर पिन को स्थानांतरित करें",
    noSavedAddressText: "कोई सहेजा गया पता नहीं मिला",
    redirectingToPG: "रीडायरेक्ट कर रहे हैं {br} भुगतान गेटवे",
    doNotCloseApp: "कृपया एप्लिकेशन बंद न करें",
    processingPayment: "भुगतान संसाधित कर रहे हैं",
    processingPaymentDescription:
      "हम आपके भुगतान को संसाधित कर रहे हैं, {br} कृपया एप्लिकेशन बंद न करें",
    currentLevelTagText: "वर्तमान स्तर",
    tierEligibilityVisit:
      "इस स्तर तक पहुँचने के लिए {duration} {durationUnit} के भीतर {minSpend} बार जाएँ",
    tierEligibilitySpend:
      "इस स्तर तक पहुँचने के लिए {duration} {durationUnit} के भीतर {currency}{minSpend} खर्च करें",
    tierEligibilityOrder:
      "इस स्तर तक पहुँचने के लिए {duration} {durationUnit} के भीतर {minSpend} बार ऑर्डर करें",
    tierEligibilityPoint:
      "इस स्तर तक पहुँचने के लिए {duration} {durationUnit} के भीतर {minSpend} अंक अर्जित करें",
    tierProgramPromotionTNC:
      "हर खरीद पर {currencyName} कमाएँ और उन्हें अपने बिल भुगतान के लिए भुनाएँ। प्रत्येक {currencyName} का मूल्य {currency}1 है, जिससे आप खर्च करते समय बचत कर सकते हैं।{br}{br}अतिरिक्त लाभ और सुविधाओं को अनलॉक करने के लिए टियर स्तरों के माध्यम से चढ़ें",
    viewTierLevelsCTA: "टियर स्तर देखें",
    additionalBenefits: "अतिरिक्त लाभ",
    tierLevelsPopupTitle: "टियर स्तर",
    myBenefitsTabLabel: "मेरे लाभ",
    levelTabLabel: "स्तर",
    faqsTabLabel: "अक्सर पूछे जाने वाले प्रश्न",
    enterAmountShownOnBill: "बिल पर दिखाया गया राशि दर्ज करें",
    coinsCantBeClubbedWithCoupon:
      "{currencyName} को कूपनों के साथ नहीं जोड़ा जा सकता है",
    nextText: "अगला",
    billDetails: "बिल विवरण",
    totalBillAmount: "कुल बिल राशि",
    coinUsed: "उपयोग किया गया सिक्का",
    totalSaving: "कुल बचत",
    selectOutletText: "आउटलेट चुनें",
    noOutletForSelectedCity: "चुने गए शहर के लिए कोई आउटलेट नहीं",
    amountSaveOnBill: "{currency}{amount} आपके बिल पर बचत की गई",
    amountPaid: "भुगतान की गई राशि",
    transactionId: "लेन-देन आईडी",
    cancelPayment: "भुगतान रद्द करें",
    exitPayEarnConfirmationMsg:
      "क्या आप सुनिश्चित हैं कि आप बिल का भुगतान नहीं करना चाहते और {currencyName} कमाना नहीं चाहते?",
    doNotPayCTA: "भुगतान न करें",
    outletSize: 100,
    earnCoinInPercentage:
      "बिल के मूल्य का {earn}{unit} {currencyName} के रूप में अर्जित करें",
    tryAgainCTA: "फिर से प्रयास करें",
    tooFarFromOutetDescription:
      "ऐसा लगता है कि आप आउटलेट से बहुत दूर हैं। कृपया सुनिश्चित करें कि आप सही आउटलेट पर भुगतान कर रहे हैं",
    nearbyOutletDistanceInMeter: "20",
    annualSpend: "वार्षिक खर्च {currency}{amount}",
    tierTitle: "{title} स्तर लाभ",
    loyaltyCardTierTitle: "{title} स्तर",
    applyOffersOnNextPage: "अगले पृष्ठ पर सिक्के / कूपन लागू करें",
    swipeToPayAmount: "स्वाइप करें और भुगतान करें {currency}{amount}",
    termsAndConditions: "शर्तें और नियम",
    inTheTier: "In the {currentTier} level,",
    coinsEarned: "{amount} {currencyName} अर्जित किया गया",
    transactionDetails: "लेन-देन विवरण",
    cookingRequest: "खाना बनाने का अनुरोध",
    readOnlyMenuServiceTitle: "पिकअप",
    paymentFailedDescription:
      "हम आपके भुगतान को संसाधित करने में असमर्थ हैं। यदि कोई राशि काटी गई है, तो इसे 2-3 कार्य दिवसों में वापस कर दिया जाएगा",
    backToCartCTA: "कार्ट पर वापस जाएं",
    paymentSuccess: "भुगतान सफल",
    userLocationSearchPlaceholder: "स्थानीयता या सड़क के नाम से खोजें",
    allOutlets: "सभी आउटलेट",
    doNotRemove: "हटाएँ मत",
    remove: "हटाएँ",
    switchRewardWarningTitle: "लागू {type} हटा दिया जाएगा",
    switchRewardWarningDesc:
      "यदि आप टैब बदलते हैं, तो आपके बिल पर लागू {type} हटा दिया जाएगा।",
    coinsText: "सिक्के",
    couponText: "कूपन",
    paymentProcessingInSeconds: "90",
    rewardProgramDetails: "इनाम कार्यक्रम विवरण",
    bookTable: "टेबल बुक करें",
    tableOutlet: "उस आउटलेट का चयन करें जहाँ आप टेबल बुक करना चाहते हैं",
    helpAndSupport: "सहायता और समर्थन",
    termsOfService: "सेवा की शर्तें",
    privacyPolicy: "गोपनीयता नीति",
    privacyPolicyAndTermsOfServiceDescription:
      "आगे बढ़ने पर, मैं {brand} की {br}{privacyPolicy} और {termsOfService} से सहमत हूँ।",
    privacyPolicyAndTermsOfServiceDescriptionInternal:
      "आगे बढ़ने पर, मैं {brand} की {br}{privacyPolicy} और {termsOfService} से सहमत हूँ।",
    invalidGroupSizeMessage: "कृपया मान्य समूह आकार दर्ज करें",
    cancelBooking: "बुकिंग रद्द करें",
    dontCancel: "रद्द न करें",
    guests: "मेहमान",
    whenAreYouVisiting: "आप कब आ रहे हैं?",
    noSlotsAvailable: "कोई स्लॉट उपलब्ध नहीं है",
    customCaps: "कस्टम",
    callOutlet: "आउटलेट को कॉल करें",
    callOutletCaps: "आउटलेट को कॉल करें",
    forLargeParties: "बड़े समूहों के लिए",
    tableBooked: "टेबल बुक किया गया",
    bookingCancelled: "बुकिंग रद्द कर दी गई",
    forGroupSize: "के लिए {groupSize}",
    payAndEarn: "भुगतान करें और कमाएँ",
    bookingDetails: "बुकिंग विवरण",
    bookings: "बुकिंग",
    addOnMinSelection: "आवश्यक | किसी भी {minSelection} विकल्प का चयन करें",
    addOnMinSelectionMultiple:
      "आवश्यक | किसी भी {minSelection} विकल्पों का चयन करें",
    addOnMinAndMaxSelection:
      "आवश्यक | किसी भी {minSelection} से {maxSelection} विकल्पों का चयन करें",
    addOnMaxSelection: "वैकल्पिक | अधिकतम {maxSelection} विकल्प का चयन करें",
    addOnMaxSelectionMultiple:
      "वैकल्पिक | अधिकतम {maxSelection} विकल्पों का चयन करें",
    maxLimitWarningAddon: "आपने इस आइटम के लिए अधिकतम सीमा तक पहुँच गया है",
    minRequiredWarningAddon:
      "आपको {category} से कम से कम {minSelection} आइटम का चयन करना होगा",
    pleaseDoNotCloseApplication: "कृपया एप्लिकेशन बंद न करें",
    alreadyTooManyBooking: "पहले से ही बहुत सारी बुकिंग हैं",
    have5ActiveBookings:
      "आपके पास पहले से ही 5 सक्रिय बुकिंग हैं। एक मेहमान के पास 5 से अधिक सक्रिय बुकिंग नहीं हो सकती हैं। कृपया किसी अन्य खाते से बुक करें।",
    sameSlotBooking: "बुकिंग पहले से मौजूद है",
    sameSlotBookingDescription:
      "इस टाइम स्लॉट के लिए पहले से ही बुकिंग मौजूद है। कृपया किसी दूसरे स्लॉट में बुकिंग करने का प्रयास करें।",
    updateProfileTitle: "प्रोफ़ाइल अपडेट करें",
    updateProfileDescription:
      "कृपया जारी रखने के लिए अपनी प्रोफ़ाइल अपडेट करें",
    updateProfileCTA: "अपडेट करें",
    selectItem: "चुनें",
    itemsAddedInCart: "कार्ट में जोड़े गए आइटम",
    customizationPopupAddItemCTA: "ADD Item | {currency}{amount}",
    continueCTA: "जारी रखें",
    bogoItemPlaceholderText: "{stack} आइटम",
    bogoOfferPageTitle: "खरीदें {buyQuantity} प्राप्त करें {getQuantity} ऑफ़र",
    bogoItemsTitle: "खरीदें {buyQuantity} प्राप्त करें {getQuantity} आइटम",
    missedPointsOnOrder: "आपने इस ऑर्डर पर {br} इनाम अंक अर्जित किए होते",
    earnedPointsOnOrder:
      "आपने इस ऑर्डर पर {br} इनाम अंक अर्जित किए हैं {br} रिडीम करने के लिए ऐप डाउनलोड करें",
    orderFromAppToEarnPoints: "ऐप से ऑर्डर करें और हर ऑर्डर पर अंक अर्जित करें",
    orderFromAppToRedeemPoints:
      "अपने अंकों को रिडीम करने के लिए ऐप से ऑर्डर करें",
    downLoadAppCTA: "ऐप डाउनलोड करें",
    downloadAppToManageProfileTitle:
      "प्रोफ़ाइल प्रबंधित करने के लिए ऐप डाउनलोड करें",
    downloadAppToManageProfileDescription:
      "आप हमारे ऐप पर अपनी प्रोफ़ाइल प्रबंधित कर सकते हैं और बहुत सी अन्य चीजें कर सकते हैं",
    swipeToBookTable: "टेबल बुक करने के लिए स्वाइप करें",
    bogoOfferInstruction:
      "इनाम अर्जित करने के लिए, ऐप पर मेनू खोलें, ‘ऑफर बैनर’ पर टैप करें, अपनी पसंद के आइटम चुनें। कूपन स्वचालित रूप से लागू होगा।",
    bogoCouponTnC: "एक ऑर्डर पर अधिकतम {getQuantity} आइटम मुफ्त होंगे",
    bogoCouponPerTnC: "एक ऑर्डर पर अधिकतम {getQuantity} आइटम पर छूट होगी",
    bogoCouponMenuValidation: "चुने हुए आइटम पर मान्य",
    bogoCouponCTA: "आइटम चुनें",
    bookingId: "बुकिंग आईडी",
    offerExistInCart: "ऑफर पहले से ही कार्ट में जोड़ा गया है",
    offerExistInCartDescription:
      "आपकी कार्ट में निम्नलिखित आइटम ऑफर का हिस्सा हैं",
    removeItemsCTA: "आइटम हटाएँ",
    goToCartCTA: "कार्ट पर जाएँ",
    applyCouponCTA: "इस कूपन को लागू करें",
    offerRemovePopupTitle: "लागू कूपन हटा दिया जाएगा",
    offerRemovePopupDescription:
      "यदि आप इस आइटम को हटाते हैं, तो आपका नीचे लागू कूपन भी हटा दिया जाएगा।",
    offerRemovePopupCTA: "हटाएँ",
    offerRemovePopupSecondaryCTA: "हटाएँ नहीं",
    offerNotApplicableTitle: "{preText} इस समय लागू नहीं होता",
    offerNotApplicableDescription: "इस समय लागू नहीं होता",
    offerNotApplicableTitle2: "ऑफर इस समय लागू नहीं होता",
    viewOfferDetails: "ऑफर विवरण देखें",
    viewDetailsCTA: "विवरण देखें",
    rateYourExperienceCTA: "अपने अनुभव को रेट करें",
    yourRatingText: "आपकी रेटिंग",
    feedbackVisibleTimeInMinutes: "30",
    submitFeedbackCTA: "फीडबैक सबमिट करें",
    orderFeedbackTitle: "ऑर्डर फीडबैक",
    viewOrderText: "ऑर्डर देखें",
    foodRatingQuestion: "खाना कैसा था?",
    overallRatingQuestion: "आपका अनुभव कैसा था?",
    serviceRatingQuestion: "सेवा कैसी थी?",
    ambienceRatingQuestion: "महौल कैसा था?",
    feedbackSuccessText:
      "हमें अपना प्यार दिखाने के लिए बहुत-बहुत धन्यवाद। हम यह पक्का करेंगे कि आपकी अगली विज़िट भी ज़बरदस्त हो।",
    feedbackSuccessBadText:
      "आपके ईमानदार फीडबैक के लिए धन्यवाद। हम आपकी अपेक्षाओं पर खरा नहीं उतरने के लिए क्षमा चाहते हैं। हमारी टीम इस पर विस्तार से चर्चा करने के लिए आपसे संपर्क करेगी।",
    weLoveYoutooText: "हम आपसे भी प्यार करते हैं",
    weAreImporvingText: "हम सुधार कर रहे हैं",
    weAreSorryText: "हमें खेद है",
    enjoyCouponText: "इस कूपन का आनंद लें आपकी अगली विज़िट पर",
    tellUsMore: "हमें और बताएं (वैकल्पिक)",
    lastOrderListSize: "1",
    lastOrderPreviousDays: "3",
    collectOrder: "अपने ऑर्डर को काउंटर से प्राप्त करें",
    deliveryChargesTitle: "डिलीवरी चार्ज",
    deliveryDiscount: "डिलीवरी छूट",
    orderHistoryPopupTitle: "ऑर्डर इतिहास",
    orderHistoryPopupSubtitle:
      "अपने ऑर्डर इतिहास को देखने के लिए ऐप डाउनलोड करें",
    orderHistoryPopupDesciption:
      "आप अपने ऑर्डर इतिहास को देख सकते हैं और हमारे ऐप पर और भी बहुत कुछ कर सकते हैं।",
    orderHistoryPopupCTA: "ऐप डाउनलोड करें",
    selfPickupLabel: "स्वयं पिकअप",
    switchText: "स्विच करें",
    addMoreItemsTitle: "और आइटम जोड़ें",
    goToMenuCTA: "मेनू पर जाएँ",
    minBillAmountTnc:
      "Minimum bill of {currencySymbol}{minBillValue} is required for delivery orders {br} Please add some more items in your cart",
    paymentPollInterval: [0, 5, 10, 15, 20, 20, 20, 20, 20, 15, 5, 5],
    viewAllRatingsCTA: "सभी रेटिंग्स देखें",
    featuredItemsTitle: "विशेष आइटम",
    swipeToPlaceOrder: "बुकिंग करने के लिए स्वाइप करें",
    rateYourLastExperience: "अपने पिछले अनुभव को रेट करें",
    swipeToPay: "भुगतान करने के लिए स्वाइप करें",
    nearby: "नजदीकी",
    outletDistanceDisplayThresoldInKm: "1",
    nearbyOutletThresoldInMeter: "50",
    addToCartCTA: "कार्ट में जोड़ें",
    availRewardWithPoints:
      "इस इनाम का लाभ उठाने के लिए {pointPrice} रिवॉर्ड पॉइंट्स का उपयोग करें",
    rewardDetails: "इनाम विवरण",
    pointsDeducted: "{pointPrice} पॉइंट्स काटे जाएंगे",
    appApplicableOnly: "केवल ऐप ऑर्डर पर लागू होता है",
    swipeToCollectReward: "इनाम प्राप्त करने के लिए स्वाइप करें",
    excludeReservationStatus: "PENDING",
    checkedInText: "CHECKED IN",
    FoodImagePlaceholderUrl:
      "https://assets.fudr.in/assets/images/food-image-placeholder.png",
    maximumDiscountText2: "Upto ₹{maxValue}",
    knowMoreCTA: "और जानें",
    selectItemCTA: "आइटम चुनें",
    applyOfferCTA: "ऑफर लागू करें",
    offerText: "ऑफर",
    rewardText: "इनाम",
    couponAlreadyTaken:
      "आप पहले ही अपने {currencyName} के साथ कूपन ले चुके हैं",
    dayValidationError: "{preText} केवल {applicableWeekdays} पर लागू होता है",
    timeValidationError:
      "{preText} केवल {startTime} से {endTime} के बीच उपलब्ध है",
    dateValidationError: "{preText} {activationTime} से उपलब्ध है",
    rewardValidationTitle: "{preText} इस समय लागू नहीं होता है",
    trackOrder: "ऑर्डर ट्रैक करें",
    offerAlreadyAppliedTitle: "{preText} पहले ही लागू किया जा चुका है",
    removeOfferCTA: "हटाएँ {preText}",
    amountValidationError:
      "यह {preText} न्यूनतम ऑर्डर राशि {currencySymbol}{minOrderValue} पर लागू होता है",
    amountValidationErrorTitle: "और आइटम जोड़ें",
    expireValidationDateError: "यह {preText} {expireDate} को समाप्त हो गया है",
    expireValidationError: "यह {preText} समाप्त हो गया है",
    expireValidationErrorTitle: "ऑफर समाप्त हो गया",
    useRewardPointToGetDiscount:
      "अपने बिल पर छूट पाने के लिए {currencyName} का उपयोग करें",
    billAmountPaidWithPoints2:
      "{currency Name} से {bill Amount}% तक भुगतान करें",
    howToRedeemTitle: "कैसे भुनाएं",
    applyPointsOnCart: "कार्ट पृष्ठ पर {currencyName} लागू करें",
    okCTA: "ठीक है",
    itemNotAvailableTitle: "आइटम उपलब्ध नहीं है",
    itemNotAvailableDescription:
      "यह आइटम इस समय उपलब्ध नहीं है। {br} असुविधा के लिए क्षमा करें",
    couponAppliedText: "{displayTitle} ऑफर इस ऑर्डर पर लागू किया गया",
    appliedCouponCTAText: "YAY!",
    reviewOnSocialText:
      "कृपया हमें सोशल चैनलों पर समीक्षा करें और अपने अनुभव के बारे में दुनिया को बताएं",
    reviewOnGoogeText: "गूगल पर समीक्षा करें",
    reviewOnTripadvisorText: "ट्रिपएडवाइजर पर समीक्षा करें",
    homeAddressTitle: "घर",
    workAddressTitle: "काम",
    otherAddressTitle: "अन्य",
    nearbyOutletsSize: "5",
    viewMoreOutlets: "और आउटलेट देखें",
    menuSearchPlaceholder: "मेनू में खोजें",
    menuSearchTitle: "मेनू खोजें",
    specialInstructions: "खाना बनाने के अनुरोध जोड़ें",
    swipeToOrderCTAText: "बुकिंग करने के लिए स्वाइप करें",
    swipeToPayCTAText: "भुगतान करने के लिए स्वाइप करें",
    emptyNameMessage: "कृपया अपना नाम दर्ज करें",
    emptyGenderMessage: "कृपया लिंग चुनें",
    emptyEmailMessage: "कृपया अपना ईमेल दर्ज करें",
    emptyDOBMessage: "कृपया एक तारीख दर्ज करें",
    emptyAnniversaryDateMessage: "कृपया एक तारीख दर्ज करें",
    namePlaceHolder: "आपका नाम",
    emailPlaceHolder: "आपका ईमेल आईडी",
    otpPlaceHolder: "ओटीपी",
    phoneNumberPlaceHolder: "मोबाइल नंबर",
    doaPlaceHolder: "dd-mm-yyyy",
    doaSecondaryPlaceHolder: "आपकी वर्षगांठ की तारीख",
    dobPlaceHolder: "dd-mm-yyyy",
    dobSecondaryPlaceHolder: "आपकी जन्मतिथि",
    signUpRequiredFields: ["name"],
    pointPrice: "{pointPrice} पॉइंट्स",
    lockedItemDealCTA: "आइटम देखें",
    unlockedItemDealCTA: "आइटम चुनें",
    promoCodePlaceholder: "प्रोमो कोड दर्ज करें",
    applyPromoCodeCTA: "आवेदन करें",
    promoCodeNotFoundDescription:
      "आपने जो कोड डाला है, वह गलत है या उसकी समय-सीमा समाप्त हो गई है।",
    promoCodeNotFoundTitle: "प्रोमो कोड नहीं मिला",
    promoOfferTitle: "प्रोमो ऑफर",
    tncTitle: "नियम और शर्तें",
    promoCodeTitle: "क्या आपके पास प्रोमो कोड है?",
    loyaltyPassTitle: "लॉयल्टी पास",
    applyCTAText: "आवेदन करें",
    unlockYourReward:
      "{name}, आप {displayTitle} को अनलॉक करने के लिए बस एक कदम दूर हैं",
    unlockYourRewardDescrption: "इस ऑफ़र का दावा करने के लिए अभी पंजीकरण करें",
    verifyAndUnlockOffer: "ऑफर अनलॉक करें",
    grabOfferTitle:
      "आप इस ऑफ़र का दावा करने के लिए एक कदम दूर हैं। इसे अभी प्राप्त करें!",
    demoOfferTnC:
      "यह ऑफ़र एक डेमो है, जो विशेष रूप से विज़ुअलाइज़ेशन के उद्देश्य से प्रदान किया गया है।",
    otpVerificationTitle: "ओटीपी सत्यापन",
    orderConfirmationDemoTitle: "डेमो पूरा करने के लिए धन्यवाद!",
    orderConfirmationDemoDescription: "हमें उम्मीद है कि आपको यह आकर्षक लगा।",
    orderNowCTA: "अभी ऑर्डर करें",
    rewardProgramSubtext: " ",
    dealListOrderPriority: ["loyalty", "deal", "promo"],
    enterReferralCode: "क्या आपके पास रेफरल कोड है? {cta}",
    referralCodeFieldLabel: "रेफरल कोड",
    referralCodePlaceHolder: "रेफरल कोड दर्ज करें",
    enterReferralCodeCTA: "कोड दर्ज करें",
    invalidReferralCodeTitle: "अमान्य रेफरल कोड",
    invalidReferralCodeDescription:
      "आपने जो रेफरल कोड डाला है, वह गलत है। कृपया एक मान्य कोड दर्ज करें",
    referrals: "मेरे रेफरल",
    referralsTitle: "रेफरल",
    referralTabTitle: "मेरे रेफरल",
    referralCardTitle: "रेफर और कमाएं",
    referralPopupTitle: "रेफर और कमाएं",
    howReferralWorksTitle: "यह कैसे काम करता है",
    referralCodeTnc: "अपने रेफरल कोड को अपने दोस्तों के साथ साझा करें",
    referralPointCardRule:
      "अपने रेफरल कोड को अपने दोस्तों के साथ साझा करें और जब वे अपना पहला ऑर्डर देते हैं तो {rewardPoints} अंक प्राप्त करें",
    referralCouponCardRule:
      "अपने रेफरल कोड को अपने दोस्तों के साथ साझा करें और जब वे अपना पहला ऑर्डर देते हैं तो {dealName} प्राप्त करें",
    referralPointRule:
      "आपको ‘{rewardPoints}’ अंक प्राप्त होंगे जब आपका मित्र अपना पहला ऑर्डर देता है",
    referralCouponRule:
      "आपको ‘{dealName}’ पुरस्कार प्राप्त होगा जब आपका मित्र अपना पहला ऑर्डर देता है",
    gainerPointRule:
      "उन्हें आपके रेफरल लिंक के साथ साइन अप करने पर ‘{rewardPoints}’ अंक प्राप्त होंगे",
    gainerCouponRule:
      "उन्हें आपके रेफरल लिंक के साथ साइन अप करने पर ‘{dealName}’ पुरस्कार प्राप्त होगा",
    referralMilestonePointRule:
      "{threshold} सफल रेफ़रल पर {reward Points} पॉइंट्स पाएं।",
    referralMilestoneCouponRule:
      "{threshold} सफल रेफ़रल पर {dealName} प्राप्त करें",
    referralMilestonePointMaxThresholdRule:
      "{maxThreshold} सफल रेफ़रल पर {rewardPoints} पॉइंट्स प्राप्त करें",
    referralMilestoneCouponMaxThresholdRule:
      "{maxThreshold} सफल रेफ़रल पर {dealName} प्राप्त करें",
    referralRewardKnowMoreCTA: "अधिक जानें",
    referralCodewhatsappShareMessage:
      "हे, मैं {brand Name} ऐप इस्तेमाल कर रहा हूँ। मेरा रेफरल कोड {referral Code} इस्तेमाल करें।",
    referralCodewhatsappShareMessagNew:
      "Craving something amazing? I use {brandName} to order all my favorites. Use my referral code {referralCode} when you sign up and you'll get a special discount. Don't miss out on the best food deals! Get the app: {appLink}",
    signupDetailsTitle: "एक आखिरी बात",
    unlockCouponTitle: "आपने {br} {displayTitle} कूपन अनलॉक किया है",
    unlockFallbackCouponTitle:
      "{displayTitle} कूपन नए मेहमानों के लिए है, हम आपको {fallbackDisplayTitle} कूपन देने के लिए खुश हैं!",
    unlockCouponDescription:
      "हमने आपको यह कूपन DM किया है। {br} इसे अपने अगले ऑर्डर पर रिडीम करें",
    couponCodeText: "कूपन कोड - {couponCode}",
    noOfferApplicableTitle: "क्षमा करें, यह ऑफ़र लागू नहीं है",
    noOfferApplicableDescription:
      "हालांकि, हमारे ऐप पर हमारे लॉयल्टी प्रोग्राम से रोमांचक पुरस्कारों के साथ हम आपको कवर कर चुके हैं!",
    goBackCTA: "वापस जाएं",
    changeCTA: "बदलें",
    referralMilestoneProgress: "{completed}/{total} रेफरल पूरे हुए",
    genderFields: ["पुरुष", "महिला", "अन्य"],
    unlockFallbackOfferTitle:
      "{displayTitle} केवल नए सदस्यों के लिए है। हालाँकि, हम आपको एक विशेष ट्रीट के साथ कवर कर चुके हैं!",
    unlockOfferTitle: "आपने {br} {displayTitle} अनलॉक किया है",
    getBrandAppCTA: "{brandName} ऐप पर जाएं",
    offerAlreadyRedeemed: "ऑफर सफलतापूर्वक रिडीम किया गया",
    unlockMoreOfferOnApp:
      "और ऑफ़र अनलॉक करें और पुरस्कार अर्जित करें {br} अभी ऐप प्राप्त करें!",
    getMoreOffers: "और ऑफ़र प्राप्त करें!",
    offerExpiredTitle: "क्षमा करें, यह ऑफ़र समाप्त हो गया है।",
    getDealTitleCTA: "प्राप्त करें {dealTitle}",
    rewardPointEarnedTextWithoutCurrency: `{rewardPointsText} {br} इस ऑर्डर पर अर्जित किया गया`,
    cartAdditionalSupportText:
      "कीमतों में कंटेनर शुल्क शामिल हैं (पेय पदार्थों और ऐड-ऑन पर लागू नहीं होते हैं)",
    orderingAtTitle: "ऑर्डर कर रहे हैं",
    pleaseSelectAnOutlet: "कृपया एक आउटलेट चुनें",
    searchForOutlet: "आउटलेट के लिए खोजें",
    sessionExpiryLoginTitle: "यह सुनिश्चित करें कि यह आप हैं",
    sessionExpiryLoginDescription:
      "आपको निष्क्रियता के कारण लॉगआउट कर दिया गया है। कृपया अपने पंजीकृत मोबाइल नंबर से फिर से लॉगिन करें",
    sessionExpiryPopoverTitle: "आपका सत्र समाप्त हो गया है",
    sessionExpiryPopoverDescription:
      "सुरक्षित रूप से आगे बढ़ने के लिए कृपया दोबारा लॉग इन करें।",
    sessionExpiryPopoverCTA: "दोबारा लॉग इन करें",
    tierUpgradeBenefitText: "उच्च स्तर पर चढ़ें और और भी बड़े लाभ अनलॉक करें!",
    isExternalLoyaltyEnabled: false,
    applyOfferOnCart: "ऑर्डर देते समय कार्ट पेज पर इस ऑफ़र को अप्लाई करें।",
    viewOfferDetailsCTA: "विवरण देखें",
    runningOrderFetchStatuses: ["UNATTENDED", "CONFIRMED"],
    minOrderValueOfferTnc:
      "ऑफर न्यूनतम आदेश पर उपलब्ध है {currencySymbol}{minOrderValue}",
    refundSupportInfo: "",
    displayMenuItemImages: true,
    referralRewardTitle: "रेफरल पुरस्कार",
    loginToViewPoints: "अपने अर्जित अंकों को देखने के लिए लॉगिन करें",
    emptyReferralCodeMessage: "कृपया एक मान्य रेफरल कोड दर्ज करें",
    emptyReferralRewardMessage:
      "अभी तक कोई रेफरल नहीं। पुरस्कार अर्जित करने के लिए अपना रेफरल कोड साझा करें!",
    referredBytext: "द्वारा संदर्भित",
    referredTotext: "को संदर्भित किया",
    referralActivationOnGainerActivation:
      "जब वे आपके रेफरल के साथ साइन अप करते हैं",
    referralActivationPostGainerPurchase: "उनके पहले ऑर्डर पर",
    referralActivationTotalSpend: "₹{amount} के उनके पहले ऑर्डर पर",
    referralActivationTotalSpendDefault: "जब वे अपना पहला ऑर्डर देते हैं",
    referralRewardReceived: "रेफरल पुरस्कार प्राप्त हुआ - {rewardValue}",
    referralRewardReceivedPoints:
      "रेफरल पुरस्कार प्राप्त हुआ - {rewardTitle} {currencyName}",
    referralRewardReceivedOffer: "रेफरल पुरस्कार प्राप्त हुआ - {rewardTitle}",
    referralRewardReceivedDefault: "रेफरल पुरस्कार प्राप्त हुआ - {rewardTitle}",
    referralRewardPending: "आपको {rewardValue} {conditionText} प्राप्त होगा",
    referralRewardPendingOnActivation:
      "आपको पुरस्कार प्राप्त होगा जब वे ऐप पर साइन अप करेंगे",
    referralRewardPendingPostPurchase:
      "आपको उनके पहले ऑर्डर पर पुरस्कार प्राप्त होगा",
    referralRewardPendingTotalSpend:
      "आपको ₹{amount} के उनके पहले ऑर्डर पर पुरस्कार प्राप्त होगा",
    referralRewardPendingTotalSpendDefault:
      "आपको उनके पहले ऑर्डर पर पुरस्कार प्राप्त होगा",
    referralRewardPendingPurchaseN:
      "आपको {brandName} पर ₹{amount} खर्च करने पर पुरस्कार प्राप्त होगा",
    accessDeniedPopoverTitle: "पहुंच अस्वीकृत",
    accessDeniedPopoverDescription:
      "आप {guestMobileNo} मोबाइल नंबर के साथ लॉगिन हैं। इस खाते को इस पृष्ठ तक पहुंच नहीं है।",
    accessDeniedPopoverCTA: "होम पर जाएं",
    accessDeniedPopoverSecondaryCTA: "लॉग आउट",
    aRewardText: "एक पुरस्कार",
    loginToViewEarnedPointsAndReward:
      "अपने अर्जित अंकों और पुरस्कार को देखने के लिए लॉगिन करें",
    loginToPlaceOrder: "ऑर्डर देने के लिए लॉगिन करें",
    guestModeLoginRequired: "आगे बढ़ने के लिए आपको लॉगिन करना होगा",
    loginButton: "लॉगिन",
    serviceTypeValidationErrorTitle: "ऑफर लागू नहीं है",
    searchAddressPlaceholder: "पता या क्षेत्र खोजें",
    skipCTAText: "छोड़ें",
    geolocationText: "वर्तमान स्थान",
    proximityRadius: "500",
    reviewBooking: "बुकिंग की समीक्षा करें",
    subTotal: "उप-योग",
    gst: "जीएसटी",
    editCTA: "संपादित करें",
    deleteCTA: "हटाएं",
    identifyingLocation: "आपकी लोकेशन की पहचान की जा रही है...",
    addressBook: "पता पुस्तिका",
    addNewAddress: "नया पता जोड़ें",
    selectDate: "तारीख़ चुनें",
    selectDuration: "अवधि चुनें",
    selectSlot: "स्लॉट चुनें",
    chooseService: "सेवा चुनें",
    noBookings: "कोई बुकिंग नहीं दिखा रहा है",
    bookingDetils: "बुकिंग विवरण",
    slotBooked: "स्लॉट बुक किया गया",
    OTP: "OTP : ",
    bookedFor: "बुक किया गया",
    addressText: "पता",
    viewAddressInMap: "मानचित्र में पता देखें",
    cleaning: "सफाई",
    atYourDoorStep: "आपके दरवाजे पर {defaultDispatchTimeMinutes} मिनट में",
    currentlyUnavailable: "वर्तमान में अनुपलब्ध",
    earliestAvailableSlot: "सबसे पहले उपलब्ध स्लॉट दिखाएँ",
    prebook: "पूर्व बुक करें",
    neayYouSoon: "हम जल्द ही आपके पास होंगे!",
    notifyMe: "मुझे सूचित करें",
    tapLocalityChange: "सेवा क्षेत्र चुनने के लिए यहां टैप करें",
    bookingConfirmed: "बुकिंग की पुष्टि हो गई",
    bookingDateAndTime: "बुकिंग की तारीख और समय",
    bookedSlot: "बुक किया गया स्लॉट",
    totalText: "कुल",
    recoverCTA: "वापस पाना",
    refundAndCancellationPolicy: "रिफंड और रद्दीकरण नीति",
    refundAndCancellationPolicyDescription:
      "बुकिंग के 5 मिनट के भीतर रद्द करने पर पूरा रिफंड। {br} आंशिक रद्दीकरण के लिए रिफंड छूट के खिलाफ समायोजित किया जाएगा।",
    privacyPolicyUrl: "https://www.qwiky.in/privacy-policy",
    tncUrl: "https://www.qwiky.in/tnc",
    refundPolicyUrl: "https://www.qwiky.in/refund-policy",
    instagramUrl: "https://www.instagram.com/qwiky_official/",
    whatsIncludedExcluded: "क्या शामिल है और क्या बाहर है?",
    learnMore: "और जानें",
    defaultPaymentType: "PRE_PAYMENT",
    showEarliestAvailableSlot: "सबसे पहले उपलब्ध स्लॉट दिखाएँ",
    availableFrom: "उपलब्ध है {nextSlotStart} पर",
    cancelBookingMessage:
      "नमस्ते, मैं अपनी बुकिंग कैंसिल करना चाहता हूँ। बुकिंग ID: {bookingCode}",
    supportPhoneNumber: "7297970825",
    supportWhatsAppNumber: "7297970825",
    // Retained for backward compatibility with older remote resource configurations.
    supportPhoneNumner: "7297970825",
    forAnyAssistance:
      "अपनी बुकिंग के संबंध में किसी भी सहायता के लिए, कृपया हमारी सपोर्ट टीम से <phone>{countryCode} {phoneNumber}</phone> पर संपर्क करें।",
    bookNowCTA: "अभी बुक करें",
    policiesAndPermissions: "नीतियाँ और अनुमतियाँ",
    permissions: "अनुमतियाँ",
    showTopBanner: false,
    showBottomBanner: true,
    myBookings: "मेरी बुकिंग",
    changeSlot: "स्लॉट बदलें",
    changeAddress: "पता बदलें",
    instantServiceStartMessage:
      "सेवा बुकिंग के {defaultDispatchTimeMinutes} मिनट बाद शुरू होगी",
    userConsentPopoverTitle: "आगे बढ़ने से पहले",
    userConsentPopoverPrimaryCTA: "मैं सहमत हूँ",
    consentAcknowledgedDescription:
      "आपने सेवा की शर्तों, गोपनीयता नीति और सुरक्षा और गुणवत्ता उद्देश्यों के लिए सेवा निगरानी के लिए सहमति दी।",
    userConsentMessage:
      "मैं सेवा की शर्तों, गोपनीयता नीति से सहमत हूँ और सुरक्षा और गुणवत्ता उद्देश्यों के लिए सेवा निगरानी के लिए सहमति देता हूँ।",
    userPreferenceMessage:
      "आपकी प्राथमिकताएँ सहेजी गई हैं। आप इन्हें कभी भी प्रोफ़ाइल से बदल सकते हैं।",
    requiredConsentMessage: "(Required)",
    optionalConsentMessage: "(Optional)",
    serviceDate: "सर्विस तारीख",
    slotTime: "स्लॉट समय",
    serviceLocation: "सर्विस लोकेशन",
    noBookingMessage: "इस समय आपके पास कोई बुकिंग नहीं है।",
    secondsRemainingLabel: "सेकंड शेष",
    minutesRemainingValue: "{minutes} मिनट",
    hoursRemainingValue: "{hours} घंटे",
    userConsentTerms: [
      {
        type: "PII",
        label: "Personal Information",
        description:
          "I agree to the processing of my personal data for booking fulfillment.",
        default: true,
        version: "v1.0",
        required: true,
      },
      {
        type: "SERVICE_UPDATES",
        label: "Service Updates",
        description:
          "Receive service-related and transactional updates via SMS, WhatsApp, Email, Push notifications and RCS.",
        default: true,
        version: "v1.0",
        required: true,
      },
      {
        type: "MARKETING_COMMUNICATION",
        label: "Marketing Communication",
        description:
          "Receive promotional offers, loyalty benefits and new launch updates.",
        default: true,
        version: "v1.0",
        required: false,
      },
      {
        type: "SERVICE_RECORDING",
        label: "Service Recording",
        description:
          "Some experts may use a small camera during service for safety and quality purposes. No recording in private areas.",
        default: true,
        version: "v1.0",
        required: false,
      },
    ],
    bookingReminderIntervalInMinutes: 1,
    serviceCompletionAlertBeforeSeconds: 300,
    expertBookingPollingTime: 30000,
    expertBookingBackgroundPollingTime: 10000,
    expertBookingPendingPollingTime: 60000,
    expertBookingMaxPollingTime: 300000,
    expertBookingPollingJitterRatio: 0.1,
    partnerWebViewScale: 1,
    showUserConsentPopup: 1,
    todaysBookingTitle: "आज की बुकिंग",
    bookingInProgressTitle: "बुकिंग जारी है",
    bookingCompletedTitle: "बुकिंग पूरी हुई",
    partnerBookingCompletedDescription: "सेवा सफलतापूर्वक पूरी हो गई है।",
    partnerBookingConfirmedDescription: "बुकिंग की पुष्टि हो गई है और सेवा के लिए तैयार है।",
    partnerBookingInProgressDescription: "सेवा अभी जारी है।",
    partnerBookingCancelledDescription: "यह बुकिंग अब सक्रिय नहीं है।",
    bookingTimeLabel: "बुकिंग का समय",
    remainingTimeLabel: "शेष समय",
    customerNameLabel: "ग्राहक का नाम",
    customerPhoneLabel: "ग्राहक का फोन नंबर",
    startServiceCta: "सेवा शुरू करें",
    endServiceCta: "सेवा समाप्त करें",
    viewMapRoute: "मैप में रास्ता देखे",
    openInGoogleMaps: "गूगल मैप्स में खोलें",
    startServiceOtpSubtitle:
      "सेवा शुरू करने के लिए ग्राहक से OTP लेकर दर्ज करें।",
    endServiceOtpSubtitle:
      "सेवा पूरी करने के लिए ग्राहक से OTP लेकर दर्ज करें।",
    enterOtp: "OTP दर्ज करें",
    enterOtpPlaceholder: "सर्विस OTP दर्ज करें",
    bookingAcceptedTitle: "बुकिंग स्वीकार",
    bookingAcceptedSubtitle: "बुकिंग स्वीकार। समय पर कार्य सुनिश्चित करें।",
    forTodayLabel: "आज के लिए",
    closeMapCta: "मैप बंद करें",
    noBookingsTitle: "कोई बुकिंग नहीं मिली",
    noBookingsDescription: "नई बुकिंग आने पर यहाँ दिखाई देंगी।",
    bookingCancellationMessage:
      "We apologise for the inconvenience. Your booking was cancelled due to an unexpected issue. You can expect your refund in 4–5 working days.",
    faqs: [
      {
        title: "मुझे नई बुकिंग कैसे मिलेगी?",
        targets: ["helpAndSupport"],
        description:
          "ऑनलाइन रहें और नोटिफिकेशन चालू रखें। नई बुकिंग अलर्ट के साथ होम स्क्रीन पर दिखाई देगी।",
      },
      {
        title: "सर्विस शुरू या पूरी कैसे करें?",
        targets: ["helpAndSupport"],
        description:
          "ग्राहक के पास पहुँचने पर स्टार्ट OTP लें। सर्विस पूरी होने के बाद ही एंड OTP दर्ज करें।",
      },
      {
        title: "ग्राहक उपलब्ध न हो तो क्या करें?",
        targets: ["helpAndSupport"],
        description:
          "बुकिंग कार्ड से ग्राहक को कॉल करें। जवाब न मिलने पर वहाँ से जाने से पहले Qwiky सहायता टीम से संपर्क करें।",
      },
      {
        title: "SOS का उपयोग कब करना चाहिए?",
        targets: ["helpAndSupport"],
        description:
          "बुकिंग के दौरान तुरंत सहायता की आवश्यकता होने पर SOS का उपयोग करें। आप सहायता टीम को कॉल कर सकते हैं या व्हाट्सऐप पर चैट कर सकते हैं।",
      },
      {
        title: "बुकिंग का अलर्ट सुनाई नहीं दे रहा है, क्या करूँ?",
        targets: ["helpAndSupport"],
        description:
          "फोन सेटिंग में Qwiky Partner के नोटिफिकेशन और आवाज़ चालू करें। यह भी जाँचें कि बैटरी सेवर ऐप को रोक नहीं रहा है।",
      },
      {
        title: "बुकिंग की सुरक्षा रिकॉर्डिंग कैसे काम करती है?",
        targets: ["helpAndSupport"],
        description:
          "सही स्टार्ट OTP दर्ज करने के बाद रिकॉर्डिंग शुरू होती है और एंड OTP के बाद बंद हो जाती है। सुरक्षा के लिए यह आपके डिवाइस में निजी रूप से सुरक्षित रहती है।",
      },
    ],
    splashTimeoutInSec: 4000,
    languageCode: "hi",
    languageName: "हिन्दी",
    appMaxInactiveTimeToReloadInMNS: 30,
    bookingReminderIntervalInSeconds: 10,
    partnerServiceOtpLength: 4,
    partnerKioskModeEnabled: true,
    partnerKioskUseLockTaskMode: true,
    partnerKioskAllowedPackages: [
      "com.whatsapp",
      "com.whatsapp.w4b",
      "com.google.android.apps.maps",
      "com.google.android.dialer",
      "com.android.dialer",
      "com.android.server.telecom",
      "com.android.incallui",
      "com.samsung.android.dialer",
      "com.samsung.android.incallui",
    ],
    supportCallTitle: "सहायता टीम को कॉल करें",
    supportCallDescription: "हमारी सहायता टीम से सीधे बात करें",
    supportWhatsAppTitle: "व्हाट्सऐप पर चैट करें",
    supportWhatsAppDescription: "आमतौर पर कुछ ही मिनटों में जवाब मिलता है",
    supportEmailTitle: "ईमेल भेजें",
    supportEmailDescription: "सामान्य प्रश्न या दस्तावेज़ भेजने के लिए",
    faqHeading: "अक्सर पूछे जाने वाले प्रश्न",
    updateNameTitle: "नाम अपडेट करें",
    updateEmailTitle: "ईमेल अपडेट करें",
    addEmailTitle: "ईमेल जोड़ें",
    enterNamePlaceholder: "नाम दर्ज करें",
    enterEmailPlaceholder: "ईमेल दर्ज करें",
    statusOnline: "ऑनलाइन",
    statusOffline: "ऑफलाइन",
    statusBreak: "विराम",
    bookingHistoryTitle: "बुकिंग का इतिहास",
    completedBookingsTitle: "पूरी की गई बुकिंग",
    completedBookingsSubtitle: "आपने अब तक बेहतरीन सेवा अनुभव दिए हैं।",
    rateBookingExperienceCTA: "बुकिंग अनुभव को रेट करें",
    viewBookingDetails: "बुकिंग विवरण देखें",
    additionalServicesCount: "+{count} और",
    bookingDetailsTitle: "बुकिंग विवरण",
    bookingDetailsLoadErrorTitle: "बुकिंग विवरण लोड नहीं हो सका",
    bookingDetailsFeedbackDescription: "इस पूरी की गई बुकिंग के बारे में अपना फीडबैक साझा करें।",
    loadingFeedbackText: "फीडबैक लोड हो रहा है…",
    bookingInformationTitle: "बुकिंग की जानकारी",
    createdLabel: "बनाई गई",
    slotEndsLabel: "स्लॉट समाप्ति",
    serviceTrackingTitle: "सेवा ट्रैकिंग",
    serviceStartTimeLabel: "सेवा शुरू होने का समय",
    expectedEndTimeLabel: "अनुमानित समाप्ति समय",
    serviceEndTimeLabel: "सेवा समाप्ति समय",
    sessionStatusLabel: "सेवा स्थिति",
    partnerBookingFeedbackTitle: "बुकिंग अनुभव को रेट करें",
    partnerBookingFeedbackDescription: "{customerName} के साथ अपने अनुभव के बारे में बताएं",
    bookingFeedbackThanksTitle: "आपके फीडबैक के लिए धन्यवाद",
    bookingFeedbackAlreadyProvidedTitle: "फीडबैक पहले ही दिया जा चुका है",
    bookingFeedbackAlreadyProvidedText: "आप इस बुकिंग के लिए पहले ही फीडबैक दे चुके हैं।",
    partnerFeedbackSuccessText: "आपका फीडबैक हमें हर बुकिंग अनुभव बेहतर बनाने में मदद करता है।",
    doneCTA: "ठीक है",
    submittingFeedbackText: "सबमिट हो रहा है…",
    ratingAriaLabel: "बुकिंग रेटिंग",
    starRatingAriaLabel: "5 में से {value} स्टार",
    tapStarRatingPrompt: "बुकिंग को रेट करने के लिए स्टार चुनें",
    loadingFeedbackOptionsText: "विकल्प लोड हो रहे हैं…",
    bookingFeedbackOptionsError: "फीडबैक विकल्प लोड नहीं हो सके। कृपया दोबारा कोशिश करें।",
    bookingFeedbackSubmitError: "फीडबैक सबमिट नहीं हो सका। कृपया दोबारा कोशिश करें।",
    feedbackCommentsLabel: "अतिरिक्त टिप्पणी (वैकल्पिक)",
    feedbackCommentsPlaceholder: "कोई उपयोगी जानकारी साझा करें",
    partnerRatingHeading1: "हमें खेद है—बताएं क्या गलत हुआ",
    partnerRatingHeading2: "बेहतर करने में हमारी मदद करें",
    partnerRatingHeading3: "हम क्या सुधार सकते हैं?",
    partnerRatingHeading4: "अच्छा लगा कि अनुभव बढ़िया रहा",
    partnerRatingHeading5: "बहुत बढ़िया—अपना अनुभव साझा करें",
    bookingsLoadErrorTitle: "बुकिंग लोड नहीं हो सकीं",
    bookingsLoadErrorDescription:
      "अपना इंटरनेट कनेक्शन जाँचें और दोबारा कोशिश करें।",
    retryCTA: "दोबारा कोशिश करें",
    loadingText: "लोड हो रहा है…",
    unavailableText: "उपलब्ध नहीं",
    addressUnavailableText: "पता उपलब्ध नहीं",
    statusUnavailableText: "स्थिति उपलब्ध नहीं",
    customerFallback: "ग्राहक",
    serviceFallback: "सेवा",
    serviceDetailsTitle: "सेवा विवरण",
    serviceQuantityValue: "मात्रा: {quantity}",
    serviceDurationValue: "{minutes} मिनट",
    completedStatus: "पूरा हुआ",
    cancelledStatus: "रद्द",
    rejectedStatus: "अस्वीकृत",
    completeProfileTitle: "अपनी प्रोफ़ाइल पूरी करें",
    mobileUnavailableText: "मोबाइल नंबर उपलब्ध नहीं",
    personalInformationTitle: "व्यक्तिगत जानकारी",
    personalInformationDescription:
      "सही जानकारी से बुकिंग अपडेट आप तक समय पर पहुँचते हैं।",
    noRatingsYet: "अभी तक कोई रेटिंग नहीं",
    totalRatingsValue: "{count} रेटिंग",
    serviceTimingsTitle: "सेवा का समय",
    shiftTimingsTitle: "शिफ्ट का समय",
    todayShiftLabel: "आज की शिफ्ट",
    todayShiftDescription: "आज की शिफ्ट नीचे बैंगनी बॉर्डर से दिखाई गई है।",
    shiftTimingsUnavailableTitle: "शिफ्ट का समय उपलब्ध नहीं है",
    shiftTimingsUnavailableDescription: "आपकी शिफ्ट निर्धारित होने के बाद यहाँ दिखाई देगी।",
    serviceTimingsDescription: "हर कार्य क्षेत्र के लिए आपकी साप्ताहिक शिफ्ट।",
    serviceHoodLabel: "निर्धारित कार्य क्षेत्र",
    assignedHoodFallback: "कार्य क्षेत्र {number}",
    onLeaveLabel: "साप्ताहिक छुट्टी",
    mondayShort: "सोम",
    tuesdayShort: "मंगल",
    wednesdayShort: "बुध",
    thursdayShort: "गुरु",
    fridayShort: "शुक्र",
    saturdayShort: "शनि",
    sundayShort: "रवि",
    serviceEndsInLabel: "सेवा समाप्त होने में",
    supportUnavailableMessage: "सहायता नंबर अभी उपलब्ध नहीं है।",
    sosWhatsAppMessage:
      "SOS: मुझे Qwiky Partner बुकिंग के लिए तुरंत सहायता चाहिए।",
    sosSupportTitle: "सहायता टीम से संपर्क करें",
    sosSupportDescription: "Qwiky सहायता टीम से संपर्क करने का तरीका चुनें।",
    sosChatCta: "व्हाट्सऐप पर चैट करें",
    sosCallCta: "सहायता टीम को कॉल करें",
    partnerLocationTitle: "अपनी लोकेशन चालू करें",
    partnerLocationDescription:
      "लोकेशन से रास्ता और सर्विस सत्यापन आसान होता है। इसके बंद होने पर भी बुकिंग और अलर्ट चलते रहेंगे।",
    partnerLocationEnable: "लोकेशन चालू करें",
    partnerLocationOpenSettings: "लोकेशन सेटिंग खोलें",
    partnerLocationChecking: "लोकेशन जाँची जा रही है…",
    partnerServiceAreaLabel: "आपका सेवा क्षेत्र",
    partnerLocationUnavailable: "सेवा क्षेत्र देखने के लिए लोकेशन चालू करें",
    searchByBillPlaceholder: "बिल नंबर से खोजें",
    bookingInfoTitle: "बुकिंग की जानकारी",
    confirmed: "पुष्टि हुई",
    doa: "विवाह की वर्षगाँठ",
    gotIt: "समझ गया",
    instantServiceLabel: "तत्काल सेवा",
    invalidOtpMessage: "सही OTP दर्ज करें",
    lastUpdated: "अंतिम अपडेट",
    myRewardsLink: "मेरे रिवॉर्ड",
    newBookingLabel: "नई बुकिंग",
    policies: "नीतियाँ",
    punchInLabel: "पंच-इन",
    refresh: "रिफ्रेश करें",
    secondsLabel: "सेकंड",
    selectCityManually: "शहर चुनें",
    selectLocationManually: "लोकेशन चुनें",
    stopped: "रुका हुआ",
    timeElapsedLabel: "बीता हुआ समय",
    unattended: "अनदेखी",
  },
  bn: {
    "home": "Home",
    "navHome": "হোম",
    "navBookings": "বুকিং",
    "navAccount": "অ্যাকাউন্ট",
    "rewardClub": "Reward Club",
    "getGuestMobileNumber": "To register, Please provide your Mobile number",
    "enterNumberToLogin": "অনুগ্রহ করে আপনার মোবাইল নম্বর লিখুন",
    "rewardCondition": "আমি তথ্য পেতে একমত, কিউউইকি থেকে প্রস্তাব",
    "verifyMobileNumber": "Verify Mobile number",
    "recoverMobileNumber": "Recover Mobile number",
    "enterOtpSentOn": "প্রেরণের সময় OTP প্রেরিত হবে{phoneNumber}",
    "invalidPhoneNumberMessage": "অনুগ্রহ করে বৈধ মোবাইল ফোন ব্যবহার করুন ।",
    "tncError": "দয়া করে জেনারেলের সাথে একমত হন এবং এগিয়ে যান।",
    "emptyOtpMessage": "অনুগ্রহ করে প্রবেশ করুন (p)",
    "guestProfile": "ব্যবহারকারীর প্রোফাইল",
    "provideDetails": "অনুগ্রহ করে আপনার বিবরণ উল্লেখ করুন",
    "provideMissingDetails": "এক শেষ জিনিষ, অনুগ্রহ করে এই বিবরণগুলি বাকি রাখুন",
    "provideDetailsForNewUser": "আমাদের পুরস্কার ক্লাবে যোগ দেওয়ার জন্য,{br}অনুগ্রহ করে নিম্নলিখিত তথ্যটি নিজ হাতে লিখুন",
    "notProvided": "Not Provided",
    "nameFieldLabel": "নাম",
    "phoneNumberLabel": "যাচাইের জন্য OTP প্রেরিত হবে",
    "emailFieldLabel": "ই-মেইল আইডি",
    "birthDateFieldLabel": "জন্ম তারিখ",
    "anniversaryDateFieldLabel": "বিবাহের বার্ষিকী",
    "birthdayReward": "তোমার জন্মদিনও আমাদের জন্য বিশেষ।{br}আপনার জন্মদিনের জন্য একটি রোমাঞ্চকর পুরস্কার পান",
    "anniversaryReward": "আমাদের সাথে আপনার বার্ষিকী উদযাপন করুন!{br}[ অধ্যয়ন প্রশ্নাবলি]",
    "birthDayAndAnniversaryReward": "তোমার বিশেষ দিন আমাদের জন্যও বিশেষ।{br}আপনার জন্মদিন এবং বার্ষিকীর জন্য একটি বিশেষ পুরস্কার পান",
    "hello": "হ্যালো",
    "selectOutlet": "দয়া করে সংবাদপত্রগুলো নির্বাচন করুন যেখানে আপনি প্রায়ই দেখা করেন",
    "invalidNameMessage": "অনুগ্রহ করে একটি বৈধ নাম লিখুন",
    "invalidEmailMessage": "অনুগ্রহ করে একটি বৈধ ই-মেইল ঠিকানা লিখুন",
    "invalidDate": "অনুগ্রহ করে বৈধ একটি বৈধ তারিখ লিখুন",
    "invalidDateOfBirthMessage": "অনুগ্রহ করে বৈধ একটি বৈধ তারিখ লিখুন",
    "invalidDateOfAnniversaryMessage": "অনুগ্রহ করে বৈধ একটি বৈধ তারিখ লিখুন",
    "perferredOutletError": "দয়া করে আপনাদের প্রিয় সংবাদপত্রটি নির্বাচন করুন।",
    "emptyOutletList": "কোনো আউটলেট পাওয়া যায়নি!",
    "getStartedCTAText": "বন্ধ করা হচ্ছে",
    "proceedCTAText": "PROCEED",
    "signupCTAText": "পাওয়া যাচ্ছে না",
    "loginCTAText": "LOGIN",
    "recoverAccountCTAText": "বিশ্ব নিরীক্ষা",
    "doneCTAText": "DONE",
    "guestUserNameText": "অতিথি ব্যবহারকারী",
    "continueAsGuestText": "অতিথি হিসেবে অগ্রসর হোন",
    "saveCTAText": "SAVE",
    "updateCTAText": "UPDATE",
    "resendOtp": "ওলপ",
    "locations": "অবস্থান",
    "locationDetail": "অবস্থান",
    "getDirection": "ব্যক্তিগত সিদ্ধান্ত নিন",
    "call": "CALL",
    "today": "আজ",
    "languageSettingTitle": "ভাষা",
    "languageSettingDescription": "আপনার পছন্দের ভাষা বেছে নিন",
    "hindiLanguage": "हिंदी",
    "englishLanguage": "English",
    "changeLanguageLabel": "ভাষা পরিবর্তন করো",
    "selectLanguageTitle": "একটি ভাষা নির্বাচন করুন",
    "languageOptions": [
      {
        "code": "hi",
        "label": "हिंदी",
        "compactLabel": "हि",
        "englishLabel": "Hindi",
        "symbol": "अ"
      },
      {
        "code": "en",
        "label": "English",
        "compactLabel": "EN",
        "englishLabel": "English",
        "symbol": "A"
      },
      {
        "code": "bn",
        "label": "বাংলা",
        "compactLabel": "বা",
        "englishLabel": "Bengali",
        "symbol": "ব"
      }
    ],
    "slotLabel": "{date}, {timeRange}",
    "use-card-balance": "ব্যবহার{outletCashCardTitle}বাঁদিকে",
    "recharge-card-balance": "পুনরায় চার্জের যোগ্য{outletCashCardTitle}",
    "card-name": "{outletCashCardTitle}",
    "closed": "বন্ধ",
    "errorInfo": {
      "OTP_INVALID": {
        "title": "OTP যাচাই করা হয়নি",
        "message": "মনে হচ্ছে আপনি ভুল লিখেছেন।"
      },
      "USER_BLOCKED": {
        "title": "ব্যবহারকারী দ্বারা প্রবেশ অস্বীকৃত",
        "message": "আপনার অ্যাকাউন্ট সাময়িকভাবে স্থগিত রেখেছেন। সাহায্য করার জন্য অনুগ্রহ করে @কিউউইকি."
      }
    },
    "rewardsClubText": "Rewards Club",
    "rewardProgramDescription": "A rewards club that is all about you. Some pep talk about the rewards program that goes into multiple lines covering about 50 words.",
    "getAppRewardsClubDescriptionText1": "Earn points for every rupee spent",
    "getAppRewardsClubDescriptionText2": "Redeem points for exciting rewards",
    "getAppDownloadRewardsClubAppText": "Download app to join Rewards Club",
    "getAppRewardClubBenefits": "Benefits of Rewards Club",
    "getAppRewardClubOtherBenefits": "Other Benefits",
    "rewardsText": "Rewards",
    "couponsText": "Old Coupons",
    "rewardsDetailsText": "Reward Details",
    "name": "নাম",
    "emailId": "Email id",
    "mobileNo": "মোবাইল না।",
    "dob": "জন্মদিন",
    "dateOfBirthAddedToast": "জন্ম তারিখ যোগ করা হয়েছে!",
    "dateOfAnniversaryAddedToast": "বার্ষিকী যোগ করা হয়েছে!",
    "notification": "সূচনাবার্তা",
    "appNotification": "সূচনাপ্রদান",
    "sms": "SMS",
    "whatsapp": "কীস",
    "email": "Email",
    "rewardPointHistory": "পুরস্কার ইতিহাস",
    "history": "ব্রাউজ-ইতিহাস",
    "rewardProgram": "পুরস্কার কার্যক্রম",
    "settings": "বৈশিষ্ট্য",
    "profile": "প্রোফাইল",
    "shareThisApp": "এই অ্যাপ্লিকেশনটি শেয়ার করা হবে",
    "followUsOn": "[ ১২ পৃষ্ঠার চিত্র]",
    "logOut": "লগ-আউট",
    "login": "লগিন",
    "logoutText": "লগ-আউট করুন",
    "confirmLogoutMessage": "আপনি কি নিশ্চিতরূপে লগ-আউট করতে ইচ্ছুক?",
    "deleteAccount": "Delete Account",
    "pointEarned": "বিন্দু",
    "pointAdjusted": "অবস্থান পরিবর্তন করা হয়েছে",
    "appPermissions": "অনুমতি",
    "communication": "যোগাযোগ ব্যবস্থা",
    "preferredChannelText": "মার্কেটিং বার্তা গ্রহণ করার উদ্দেশ্যে পছন্দের চ্যানেল",
    "offersText": "দান",
    "getCouponCTA": "যান",
    "noBrandDealDescription": "মনে হচ্ছে এই মুহূর্তে কোন অফার নেই",
    "noBrandRewardDescription": "মনে হচ্ছে এই মুহূর্তে কোন পুরস্কার নেই",
    "howThisWorks": "এটা কিভাবে কাজ করে",
    "howItWorks": "কিভাবে কাজ করে",
    "getCouponOnSubscribe": "আপনি এই পুরস্কার সংগ্রহে একটি ক্যুন কোড পাবেন",
    "showCouponBeforeOrder": "রেস্টুরেন্ট পরিদর্শন এবং আপনার অর্ডার রাখার আগে কুপন কোড দেখান",
    "redeemCouponAtBillGeneration": "রেস্টুরেন্টটি বিল প্রজন্মের সময়ে আপনার কুপন মুক্ত করবে",
    "offerDetailsText": "বিস্তারিত বিবরণ দিন",
    "applicableForNewCustomers": "প্রথমবারের মত ক্রেতাদের জন্য ♪",
    "maximumDiscountText": "সর্বাধিক ডিসকাউন্ট{maxValue}",
    "alreadyHaveCoupon": "আপনি ইতিমধ্যেই একটি কুপ কোড আছে",
    "visitRestaurantToReedem": "রেস্তরাঁ থেকে মুক্তি",
    "useCouponOnNextOrder": "পরবর্তী আদেশতে এই কুপন ব্যবহার করুন",
    "instantDealText": "ইনস্ট্যান্ট মেসেজিং",
    "viewDetailsText": "ভবিষ্যৎ",
    "couponStreakText": "কলোপ্যাক",
    "couponApplicableOn": "উপর",
    "viewOnMap": "আপনি কি মনে করতে পারেন?",
    "redeemedCouponAndSavedText": "আপনি এই কুপন উদ্ধার এবং সংরক্ষণ{symbol}{discountAmount}",
    "redeemedCouponAndAvailedText": "আপনি এই কুপন উদ্ধার করেছেন এবং বিনামূল্যে সুবিধা লাভ করেছেন{applicableItem}",
    "locked": "লককৃত",
    "unlockCouponAfterText": "এই কুপন কোড আন-লক করুন{orderCount}ধারা",
    "redeemed": "লালিত",
    "expired": "মেয়াদ উত্তীর্ণ",
    "rewardExpiredOnText": "পুরস্কার পাওয়া{expiredDate}",
    "willUnlockOnText": "এই কুপন বন্ধ হয়ে যাবে{unlockDate}",
    "couponCodeLocked": "poon কোড লক করা হয়েছে",
    "showCouponToAvail": "এই ঘোষণাকৃত কোড দেখাও",
    "yourCouponCode": "Your Coupon Code",
    "goToRewardsPageCTA": "জীবন কাহিনী",
    "couponAdded": "ক্লৌদিয় পুরস্কারে যোগ দিয়েছিলেন",
    "howToRedeem": "যেভাবে রেডম ক্যুন",
    "visitRestaurantShowCoupon": "রেস্টুরেন্ট পরিদর্শন এবং আপনার অর্ডার রাখার আগে কুপন কোড দেখান",
    "restaurantWillRedeem": "রেস্টুরেন্টটি আপনার কুপন মুক্ত করবে এবং প্রযোজ্য সুবিধা প্রদান করবে{offerType}",
    "deleteYourAccount": "Delete your Account",
    "areYouSure": "তুমি নিশ্চিত?",
    "allInformationWillBeLost": "আপনার অ্যাকাউন্ট সংক্রান্ত সকল তথ্য স্থায়ীরূপে মুছে ফেলা হবে।",
    "otpSent": "OTP প্রেরিত",
    "resendOtpCaps": "এই ফাইলটি সংরক্ষণ করুন",
    "points": "POINTS",
    "rewardPointsText": "আর.{br}এইচ- টি- এম- এল",
    "rewardPointsSpentDescription": "{rewardPoints} {currencyName}উপলব্ধ",
    "unlockRewardMilestoreDescription": "অফলাইন অবস্থায় ব্যবহারের জন্য প্রস্তুত করা হচ্ছে{pointPrice}বিন্দু",
    "viewOldCoupons": "জীবন কাহিনী",
    "viewMoreText": "প্রস্তাবিত",
    "myRewards": "আমার পুরস্কার",
    "myRewardsDescription": "পরবর্তী আদেশ অনুযায়ী আপনার সংগৃহীত পুরস্কারগুলো ফিরিয়ে দিন",
    "noRewardsText": "এই মুহূর্তে কোন পুরস্কার প্রদান করা হবে না",
    "redeemableRewardsText": "তোমার এই মুক্তির পুরষ্কার এখানে দেখানো হবে",
    "excitingOffers": "কা.",
    "excitingOffersDescription": "আপনার পরবর্তী সাক্ষাতের জন্য আমাদের কিছু মজার অফার আছে। এটা সীমিত সময়ের জন্য, আপনার কুপন শেষ হওয়ার আগে।",
    "pointsRedeemed": "পয়েন্ট রেড",
    "pointsUsed": "ব্যবহৃত বিন্দু",
    "pointsEarnedForSpending": "ব্যয়ের পরিমাণ{currencySymbol} {netAmount}",
    "claimedReward": "পুরস্কার লাভ করা{sourceName}",
    "noDataToShow": "প্রদর্শনযোগ্য কোনো তথ্য নেই",
    "viewRewards": "বিজয়",
    "claimRewards": "বিবিধ বিষয়",
    "loginCTA": "LOGIN",
    "loginRequiredTitle": "লগ-ইন",
    "viewOffers": "বিবিধ বিষয়",
    "dealRedeemedPopupTitle": "Qoupon বর্তমানে derezed",
    "dealRedeemedPopupDescription": "হাই{username},{br}আপনি ইতোমধ্যে কুপনটি উদ্ধার করেছেন{redeemDate}আর জমা করেছিল{amount}আমাদের একটি কুপন আছে আপনি আগ্রহী হতে পারেন.",
    "dealAlreadyRedeemedItemFreeDescription": "হাই{username},{br}আপনি ইতোমধ্যে কুপনটি উদ্ধার করেছেন{redeemDate}( ১ করি. আমরা একটি কুপন আছে আপনি আগ্রহী হতে পারেন।",
    "dealAlreadySubscribedDescription": "হাই{username},{br}ইতোমধ্যে আপনি এই কুপন দাবি করেছেন{subscribedDate}ড.",
    "lastUpdatedText": "সর্বশেষ আপডেট",
    "redeemOn": "পুনরায় আরম্ভ করা হয়েছে{redeemTime}",
    "expiredOn": "মেয়াদ উত্তীর্ণ{expireTime}",
    "validTill": "চিহ্নিত সময়ের মধ্যে{expireTime}",
    "validFromTo": "বৈধ স্পুল নয়{redeemableTime} - {expireTime}",
    "validFrom": "বৈধ স্পুল নয়{redeemableTime}",
    "validOn": "চিহ্নিত সময়কাল{time}",
    "added": "যোগ করা হয়েছে",
    "deducted": "ক্ষতিগ্রস্ত",
    "pointsText": "বিন্দু",
    "actionText": "কাজ",
    "activityDetails": "কর্মের বিবরণ",
    "dateAndTime": "তারিখ এবং সময়",
    "billNo": "বিল নেই.",
    "billAmount": "Bill Amount",
    "outlet": "আউটলেট",
    "claimedRewardText": "মুছে ফেলা হয়েছে{br}পুরস্কার",
    "earnPointOneSpend": "প্রতিটি খরচের উপর বিন্দু",
    "earnPoints": "আয়োনিক বিন্দু",
    "unlockRewards": "ক্লীব (ক):",
    "unlockRewardsPromotion": "পুরস্কার",
    "redeem": "রেডম",
    "redeemEarnedRewardsOnNextVisit": "বিডড কোড দেখান আর রেডিয়েশন টা দেখান আপনার পরবর্তী পরিদর্শনে।",
    "redeemEarnedRewardsOnNextVisitPromotion": "আপনার পরবর্তী পরিদর্শনে আপনার অর্জনের মূল্য পরিশোধ করুন।",
    "getBirthdayRewards": "জন্মদিন পুরস্কার পান",
    "getAnniversaryRewards": "পুরস্কার পান",
    "addBirthday": "জন্মদিন যোগ করুন",
    "addAnniversary": "বার্ষিকী যোগ করুন",
    "manyMoreOffers": "আরও অনেক প্রস্তাব",
    "reasonToVisitUsAgain": "আমরা নিশ্চিত হতে পারি যে, আপনার আমাদের কাছে সবসময় কোনো কারণ রয়েছে ।",
    "birthdayRewardCardTitle": "আপনার জন্মদিনের এক মাসের জন্য পুরস্কার পেতে",
    "anniversaryRewardCardTitle": "আপনার বার্ষিকীর জন্য পুরস্কার পুরস্কার পেতে",
    "birthdayProvidedInfo": "তোমার জন্মদিন পালনের জন্য ধন্যবাদ।{br}আপনার জন্মদিন দেখার পুরস্কার{br}অতিরিক্ত পুরস্কার কার্যক্রম",
    "anniversaryProvidedInfo": "আপনার বার্ষিকী পালনের জন্য ধন্যবাদ।{br}আপনার বার্ষিক পুরস্কার দেখার জন্য{br}অতিরিক্ত পুরস্কার কার্যক্রম",
    "claimBirthdayRewardText": "জন্মদিন পুরস্কার",
    "claimAnniversaryRewardText": "বার্ষিকী",
    "birthdayRewardsText": "জন্মদিন পুরস্কার",
    "welcomeRewardText": "স্বাগতম পুরস্কার",
    "welcomeRewardDescription": "তোর পুরষ্কারটা খালি",
    "redeemRewardPointsText": "পুরস্কারের পুরস্কার সংগ্রহ করুন{currencyName}",
    "pointsAvailable": "{rewardPoints} {currencyName}উপলব্ধ",
    "birthdayRewardsTitle": "আপনার জন্মদিনের জন্য বিভিন্ন ধরনের পুরস্কার প্রাপ্ত করুন",
    "birthdayRewardDetails": "জন্মদিনের পুরস্কার",
    "claimCTAText": "এটা বন্ধ কর",
    "birthdayRewardAvailableDate": "বিদ্যমান{startDate} - {endDate}",
    "anniversaryRewardAvailableDate": "বিদ্যমান{startDate} - {endDate}",
    "active": "সক্রিয়",
    "noActiveRewardText": "কোন সক্রিয় পুরস্কার এই মুহূর্তে",
    "noInactiveRewardText": "আপনি কি মনে করতে পারেন?",
    "redeemedOrExpired": "বিভ্রান্ত / মেয়াদ উত্তীর্ণ",
    "greeterContent": "ফিরে পেয়ে খুশি হলাম",
    "notTakenRewards": "আপনি এখনো কোন পুরস্কার গ্রহণ করেননি",
    "invalidOTPMessage": "OTP আপনি ভুল লিখেছেন",
    "showThisCodeToRedeem": "এই কুপন{br}পরবর্তী অর্ডারে",
    "cretingSomethingExciting": "আমরা উত্তেজনা সৃষ্টি করছি!{br}অনুগ্রহ করে পরে পরে পরীক্ষা করুন",
    "swipeToClaimReward": "সংগ্রহে সোয়াইপ করুন",
    "joinRewardClubLink": "এখনো সদস্য না?{joinRewardsClub}",
    "joinRewardsClub": "পুরস্কার ক্লাবের সাথে যোগ দিন",
    "alreadyAMember": "ইতিমধ্যেই একজন সদস্য?{login}",
    "welcomeRewardsText": "স্বাগতম পুরস্কার",
    "welcomeRewardDetails": "স্বাগতম পুরস্কারের বিবরণ",
    "welcomeRewardsTitle": "বিভিন্ন দানের থেকে বাছাই করুন",
    "anniversaryRewardsText": "পুরস্কার",
    "anniversaryRewardDetails": "বার্ষিকীর বিস্তারিত বিবরণ",
    "anniversaryRewardsTitle": "প্রতি মাসে বিভিন্ন ধরনের পুরস্কার প্রাপ্ত করুন",
    "claimRewardCTAText": "পুরস্কার সংগ্রহ করুন",
    "greetingSubtitle": " ",
    "greetingTitle": " ",
    "joiningRewardText": "জীবন কাহিনী",
    "joiningReward": "আমরা জানি কিভাবে আমাদের অতিথিদের স্বাগত জানাতে হয়। পুরস্কার ক্লাবে যোগদানের জন্য একটা বিশেষ পুরস্কার নিয়ে এসো।",
    "accountAlreadyExists": "অ্যাকাউন্ট বর্তমানে উপস্থিত রয়েছে। অনুগ্রহ করে লগ-ইন করুন।",
    "accountNotExists": "অ্যাকাউন্ট বর্তমানে উপস্থিত নেই। দয়া করে স্বাক্ষর করুন",
    "welcomeOnboard": "বোর্ডে স্বাগতম,{br} {name}",
    "viewOtherBenefits": "অন্যান্য উপকারগুলো দেখুন",
    "collectPoint": "সংগ্রহ{earn}প্রতিটির জন্য{unit} {spend}ব্যয় করেছি।",
    "collectPointWithCurrency": "সংগ্রহ{earn} {currencyName}প্রতি{unit} {spend}ব্যয় করেছি।",
    "collectPointInPer": "কান{earn}{unit}বিলের মান{currencyName}",
    "collectPointWithFixedAndMinSpend": "কান{earn}সর্বনিম্ন বিন্দু দিয়ে অঙ্কিত প্রত্যেক বিন্দুকে{minSpend}",
    "collectPointinFixed": "কান{earn}সর্বনিম্ন মানের বিপরীত অনুক্রমের মান নির্দেশ করে",
    "collectMaxPointInPer": "এলবানো{earn}{unit}বিলের মান{currencyName}",
    "earnPointOnSelectedItems": "কান{earn} {currencyName}প্রতি বার কিনলে{tag}",
    "spendAndEarnPoint": "আপনি যখন ব্যয় করেন, আপনি পয়েন্ট সংগ্রহ করেন।{unit} {spend}কাটা হয়েছে ={earn}পয়েন্ট.",
    "minRedeemPoints": "ভিতরে{minRedeemPrice}( হিতো. আপনার পছন্দের পুরষ্কার সংগ্রহ করুন।",
    "minRedeemPointsPromotion": "ভিতরে{minRedeemPrice}( হিতো.",
    "unlockRewardOn": "পুরস্কার লাভ করা হবে{minRedeemPrice}পয়েন্ট।",
    "useEarnPoints": "পরবর্তী নির্দেশে যে পরিমাণ বিন্দু ব্যবহার করা হবে",
    "useEarnPointsWithCurrency": "আপনার আদেশ অনুযায়ী টাকা দিন{currencyName}",
    "userEarnPointInPer": "এই মুদ্রাগুলোকে পেতে দিতে ব্যবহার করো{spend}{unit}আপনার বিলের",
    "okGotIt": "আচ্ছা, বুঝেছি",
    "knowMore": "জানি (জ)",
    "dealSubscribedPopupTitle": "বন্ধ করা হয়েছে",
    "rewardApplicableOn": "পনপেমিংটন",
    "nearbyOutlets": "নিকটবর্তী আউটলেট",
    "limitedOutletCouponTnC": "সীমিত সম্প্রচারের জন্য ক্যুনুন প্রযোজ্য। অনুগ্রহ করে নীচে তালিকা প্রদর্শন করুন",
    "singleUseCouponTnC": "এটি একটি ব্যবহার একটি বনভোজন",
    "offerNotClubbedCouponTnC": "এই প্রস্তাব অন্য কোন প্রস্তাব দিয়ে ক্লাবিং করা যাবে না",
    "redemptionCouponTnC": "কুপনের যন্ত্র রেস্টুরেন্টের বিচক্ষণতায় আছে",
    "minimumOrderValueCouponTnC": "সর্বনিম্ন পরিমাণ{currencySymbol}{minOrderValue}এটা কর ও অন্যান্য অভিযোগ হতে হবে.",
    "newlyLaunchedOutlets": "নতুন পরিচর্যা শুরু",
    "limitedOutletCouponTnC2": "সীমিত সম্প্রচারের জন্য ক্যুনুন প্রযোজ্য।",
    "nextOfferActivateCouponTnC": "পরবর্তী প্রস্তাব সক্রিয় করা হবে{couponApplicableAfter}আগের বনভোজন.",
    "maximumDiscountCouponTnC": "সর্বোচ্চ ডিসকাউন্ট{currencySymbol}{maxValue}প্রতি",
    "orderModeApplicabilityCouponTnC": "শুধুমাত্র প্রযোজ্য{orderModes}কমান্ড",
    "getOffer": "যা{offer}",
    "limitedTimeOffersText": "সীমা উল্লেখ করার সময়",
    "appUpdateTitle": "{brandName}অ্যাপ্লিকেশনের ক্ষেত্রে একটি সহায়ক তথ্য আবশ্যক",
    "appUpdateDescription": "এই অ্যাপ্লিকেশনটি ব্যবহার করতে হলে, সাম্প্রতিক সংস্করণের সাথে ব্যবহারের জন্য এই অ্যাপ্লিকেশনটি আপডেট করা আবশ্যক।",
    "appUpdatePrimaryCTA": "UPDATE",
    "recentlyVisitedOutlets": "সম্প্রতি পরিদর্শিত",
    "orderTitle": "ধারা",
    "yourOrder": "তোমাদের অর্ডার",
    "coupons": "ক্রোটোন",
    "promoCode": "Promo Code",
    "coins": "মূল্য",
    "additionalDetails": "অতিরিক্ত বিবরণ",
    "proceedToPayCTAText": "টাকা নিয়ে এগিয়ে চলুন",
    "selectDeliveryLocation": "বিতরণ সংক্রান্ত অবস্থান নির্বাচন করুন",
    "cartHeaderTitle": "কার্মাক্স",
    "itemTotalText": "আইটেমের সর্বমোট",
    "discountText": "ক্ষমা",
    "additionalDiscount": "Additional Discount",
    "freeItemText": "মুক্ত বস্তু",
    "taxesText": "নিক্তি",
    "toPayText": "টাকা দিতে",
    "amountText": "{currencySymbol}{amount}",
    "discountAmountText": "- {currencySymbol}{amount}",
    "offerItemText": "আইটেম প্রস্তাব করো",
    "offerItemsText": "একটি ফাইল নির্বাচন করুন",
    "freeText": "FREE",
    "userAccessBlocked": "ব্যবহারকারী দ্বারা প্রতিরোধ হয়েছে",
    "gotToHomeCTA": "চিহ্নিত স্থানে চলুন",
    "userAccessBlockedDescription": "এই পুরস্কার পাওয়া যাবে না।{br}এই অ্যাকাউন্টটির সাথে যুক্ত মোবাইল নম্বর প্রশাসন দ্বারা ব্লক করা হয়েছে।",
    "mobileNumberBlocked": "প্রশাসন এই মোবাইলটি বন্ধ করে দিয়েছে।",
    "offerCollectedMultipleTimes": "এই অফার সংগ্রহ করা যাবে{perGuestMax}সময়।",
    "offerAlreadyRedeemedMultipleTimes": "আপনি ইতোমধ্যে এই দানটি ছেড়ে দিয়েছেন, দয়া করে আরো বেশি > এ যান বিবরণ প্রদর্শন সংক্রান্ত পূর্ববর্তী তথ্য",
    "addAmountToApplyCoupon": "সরঞ্জাম যোগ করুন{amount}এই কুপনটি প্রয়োগের জন্য আরো বেশি কিছু",
    "orderPlaced": "সাজানোর ধারা",
    "orderConfirmed": "নিশ্চিত করার অনুমতি",
    "orderPartiallyConfirmed": "আংশিক অনুমোদন প্রয়োজন",
    "viewCancelledItems": "বস্তু প্রদর্শন করা হবে",
    "orderId": "Order ID",
    "orderNo": "অর্ডার.",
    "dateTime": "তারিখ এবং সময়",
    "discount": "Discount",
    "total": "সর্বমোট",
    "orderDetails": "বিস্তারিত বিবরণ",
    "paymentDetails": "যোগাযোগ সংক্রান্ত বিবরণ",
    "refundDetails": "অতিরিক্ত বিবরণ",
    "applyRewardCoupon": "সংযোগ স্থাপন করুন{currencyName}",
    "applyCouponText": "Copock প্রয়োগ করুন",
    "emptyMenuListPlaceholder": "অনুসন্ধানের মান অনুযায়ী কোনো ফলাফল পাওয়া যায়নি। অনুগ্রহ করে মেনুর মধ্যে অনুসন্ধান মুছে ফেলুন।",
    "emptyApplicableMenuListPlaceholder": "এই মুহূর্তে কোনো সামগ্রী উপলব্ধ নেই।",
    "tableNumber": "টেবিল{number}",
    "scanQrCode": "স্ক্যান করুন{br}QR কোড",
    "outletReadMode": "এই মুহূর্তে আমরা অনলাইন আদেশ মেনে নেই।",
    "outletDeactiveMode": "এই মুহূর্তে আমরা অনলাইন আদেশ মেনে নেই।",
    "outletClosedMode": "আমরা দিনের জন্য বন্ধ",
    "outletNotOpenMode": "আমরা এখনো খোলা নেই",
    "notAcceptionOrdersText": "আমরা গ্রহণ করছি না{serviceType}এই মুহূর্তে নির্দেশ",
    "accountDeletionStarted": "অ্যাকাউন্ট মোছা হয়েছে",
    "recoverAccountText": "যদি আপনি আপনার অ্যাকাউন্ট পুনরুদ্ধার করতে চান, শুধুমাত্র পুনরুদ্ধার বাটন টিপে OTP এর মাধ্যমে যাচাই করার জন্য অনুসরণ করুন। যে কোন সাহায্যের জন্য@কিউউইকি.",
    "outOfRestaurantScopeErrorDescription": "মনে হচ্ছে এটা কিউআরের নয়{brandId}.{br}অনুগ্রহ করে একটি বৈধ ফলাফল স্ক্যান করুন{brandId}পূ.",
    "aboutUs": "আমাদের সম্বন্ধে",
    "orders": "অনুক্রম",
    "menu": "মেনু",
    "recommended": "প্রস্তাবিত",
    "cameraAccessError": "ক্যামেরা ব্যবহারের মত মনে হচ্ছে ব্লক করা হয়েছে",
    "enterManualCode": "Please enter the restaurant code mentioned below QR code",
    "scanQRCodeText": "ইমপোর্ট করার জন্য ফাইল কোড স্ক্যান করুন",
    "undetectScanCode": "Not able to Scan",
    "enterCodeCTA": "কোড লিখুন",
    "nonFudrQRCodeText": "দয়া করে স্ক্যান করুন{brandId}QR কোড",
    "enterCodeError": "ভুল রেস্টুরেন্ট কোড। অনুগ্রহ করে কোড পরীক্ষা করে পুনরায় প্রচেষ্টা করুন।",
    "invalidCodeError": "দয়া করে বৈধ রেস্টুরেন্ট কোড লিখুন ।",
    "scanCodeText": "কোড স্ক্যান করুন",
    "viewMenuCTA": "মেনু প্রদর্শন",
    "pickupTimePopupTitle": "সময় নির্বাচন করুন",
    "pickupTimePopupDescription": "আপনার আগমনের সময় সম্পর্কে আমাদের বলুন। এটা তোমাকে ভাল কাজে সাহায্য করবে",
    "selectCityTitle": "শহর নির্বাচন করুন",
    "viewCartCTA": "কার্মাক্স",
    "menuCategoriesTitle": "মেনু অনুসন্ধান করুন",
    "lastUpdatedTime": "সর্বশেষ আপডেট{time}",
    "collectReward": "পুরস্কার সংগ্রহ করুন",
    "itemDetailsTitle": "বস্তুর বিবরণ",
    "pickupOrderInstruction": "আপনাকে এই আদেশ গ্রহণ করতে হবে{br} {restaurantName}",
    "couponApplied": "Coupon Rice",
    "itemsInCartPopupTitle": "কার্টের বস্তু",
    "itemsInCartChangeOutletPopupDescription": "আপনি আপনার গাড়িতে কিছু জিনিস হারিয়ে ফেলবেন যদি সংবাদপত্র পরিবর্তন হয়",
    "itemsInCartChangeModePopupDescription": "মোডে পরিবর্তন হলে তা হারিয়ে যাবে",
    "changeOutletCTA": "প্রস্থান করো",
    "changeModeCTA": "মোড পাল্টাও",
    "collectRewardsDescription": "আপনি আপনার ব্যবহার করে পুরস্কার সংগ্রহ করতে পারেন{currencyName}.{br}পুরস্কারের প্রতি উপলব্ধি দেখান",
    "updateAppTitle": "উপলব্ধ রয়েছে",
    "updateAppDescription": "অ্যাপ্লিকেশনের একটি নতুন সংস্করণ উপলব্ধ রয়েছে। সবচেয়ে ভাল অভিজ্ঞতার জন্য এখন আপডেট করো।",
    "updateAppCTA": "এপিপির সর্বশেষ সংবাদ",
    "selectOptional": "বিকল্প",
    "selectOne": "একটি নির্বাচন করুন",
    "repeatCustomizationPopupTitle": "সর্বশেষ প্রথা পুনরায় নির্ধারণ?",
    "getDirections": "বিভিন্ন পাথ প্রাপ্ত করুন",
    "orderCTA": "ক্রম",
    "outletTimings": "টিমিং",
    "multipleCustomizationsPopupTitle": "একাধিক স্বনির্ধারিত",
    "multipleCustomizationsPopupCTA": "যান cart যেতে",
    "multipleCustomizationsPopupDescription": "এই বস্তুটিতে একাধিক স্বনির্বাচিতকরণ যোগ করা হয়েছে। গাড়ি সরিয়ে নিয়ে যেতে চান?",
    "multipleCustomizationsBogoPopupDescription": "এই বস্তুটিতে একাধিক স্বনির্বাচিতকরণ যোগ করা হয়েছে। নির্বাচিত বস্তুগুলির তালিকা থেকে সরিয়ে ফেলা হবে",
    "noOrdersToShow": "প্রদর্শনের জন্য কোনো অনুক্রম উপলব্ধ নেই",
    "orderingComingSoon": "তাড়াতাড়ি অর্ডার করা",
    "nonExistSubdomainFallbackTitle": "পৃষ্ঠা প্রিন্ট করতে ব্যর্থ",
    "nonExistSubdomainFallbackDescription": "মনে হচ্ছে কোন সমস্যা হয়েছে। দয়া করে একবার চেষ্টা করুন",
    "nonExistSubdomainFallbackCTA": "ছোট্ট একটা দৃশ্য",
    "nonVeg": "অবিরাম",
    "pureVeg": "বিশুদ্ধ বিশুদ্ধি",
    "customizable": "স্বনির্বাচিত উইজেট",
    "orderRunning": "{count}চলমান প্রসেস",
    "orderAgain": "আবার & পড়ো",
    "moreDetails": "অধিক বিবরণ",
    "selectOutletManuallyCTA": "নিজে হাতে তালিকা নির্বাচন করো",
    "locationPermissionDenialTitle": "অবস্থান নির্ধারণ করতে ব্যর্থ।",
    "locationPermissionDenialDescriptionAndroid": "ভাল অভিজ্ঞতার জন্য, ডিভাইসের অবস্থান জানার অনুমতি দিন। চিহ্নিত স্থানে চলুন{brandName}অ্যাপ্লিকেশন অবস্থান ব্যবহারের অনুমোদন করুন",
    "locationPermissionDenialDescriptionIOS": "ভাল অভিজ্ঞতার জন্য, ডিভাইসের অবস্থান জানার অনুমতি দিন। চিহ্নিত স্থানে চলুন{brandName}অ্যাপ্লিকেশন অবস্থান ব্যবহারের অনুমোদন করুন",
    "locationPermissionDenialDescriptionBrowser": "ভাল অভিজ্ঞতার জন্য, ডিভাইসের অবস্থান জানার অনুমতি দিন।",
    "addCTA": "ADD",
    "viewCTA": "VIEW",
    "earnPointsPopupTitle": "পুরস্কার প্রোগ্রাম",
    "helpFaqTitle": "সহায়তা (H)",
    "helpSupportTitle": "কীভাবে আমরা সাহায্য করতে পারি?",
    "supportDescription": "আমাদের সমর্থন দল প্রতিদিন সকাল ৭ টা থেকে ৯ টা পর্যন্ত পাওয়া যাচ্ছে।",
    "helpSupportMail": "support@qwiky.in",
    "pointsRefreshedToast": "{currencyName}সাফল্যের সাথে আপডেট করা হয়েছে",
    "pointsRefreshDelayInMS": 1000,
    "refundTxnInitiated": "পুনরায় লোড করুন{totalRefundAmount}আরম্ভ করা হয়েছে{initiateDate}",
    "refundTxnProcessed": "পুনরায় লোড করুন{totalRefundAmount}প্রক্রিয়া করা হচ্ছে{processedDate}",
    "dineInMinDistanceInMeter": 1000,
    "selfPickupMinDistanceInKM": 10,
    "notAtOutlet": "আউটলেট না",
    "tooFarFromOutet": "আউটলেট থেকে অনেক দূরে",
    "outletOutOfRangeDescription": "মনে হচ্ছে তুমি অনেক দূরে. দয়া করে নিশ্চিত করুন যে আপনি সঠিক ঘরে আছেন কিনা",
    "okUnderstandCTA": "আচ্ছা, IUNEDADY",
    "loaderTimeoutInMilliSeconds": 5000,
    "repeatLast": "সর্বশেষ পুনরাবৃত্তি",
    "addNew": "নতুন যোগ করুন",
    "howToRedeemText": "কিভাবে রিলেব করা",
    "collectRewardOnlineInstruction": "পুরস্কার সংগ্রহ, অ্যাপ্লিকেশন থেকে অর্ডার সংগ্রহ করুন এবং caret এর উপর প্রয়োগ করুন",
    "collectRewardOfflineInstruction": "পুরস্কার সংগ্রহ করুন, রেস্টুরেন্ট পরিদর্শন করুন আর রেস্টুরেন্টের কাছে অনুরোধ করুন ঠিক করার সময় কুপনটি প্রয়োগ করতে।\nরেস্তোরান আপনার নিবন্ধিত মোবাইল নেই। OTP তৈরি করতে ওপি।",
    "orDivider": "--OR--",
    "subscribeMembershipOnlineInstruction": "গ্রাহকগণ, অ্যাপ থেকে অর্ডার এবং কার্ট পাতায় বিজ্ঞাপন প্রয়োগ করুন",
    "subscribeMembershipOfflineInstruction": "গ্রাহক সদস্যগণ, রেস্টুরেন্ট পরিদর্শন করুন আর রেস্টুরেন্টের কাছে অনুরোধ করুন ঠিক করার সময় কুপনটি প্রয়োগ করতে।\nরেস্তোরান আপনার নিবন্ধিত মোবাইল নেই। OTP তৈরি করতে ওপি।",
    "emptyVariations": "বর্তমানে নির্বাচিত বস্তুটি, বর্তমানে উপলব্ধ নয়",
    "streakItemSequenceTitle": "{sequence}ক্রম",
    "rewardPointEarnedTextWithCurrency": "{rewardPoints} {currencyName} {br}এই আদেশের উপর নিবদ্ধ",
    "rewardPointEarnedText": "{rewardPoints} {br}এই আদেশের উপর নিবদ্ধ",
    "useRewardPoint": "ব্যবহার{currencyName}",
    "rewardPointUsed": "{redeemablePoints} {currencyName}ব্যবহৃতfree{br}উপলব্ধ{balancePoints}বিন্দু",
    "availablePointToUse": "উপলব্ধ{balancePoints}বিন্দু{br} {redeemablePoints} {currencyName}ব্যবহৃতfree",
    "zeroPointAvailable": "উপলব্ধ{balancePoints}বিন্দু",
    "pointDiscountText": "ভুলে যান{currencyName})",
    "savedOnOrder": "আপনি সংরক্ষণ{currencySymbol}{amount}এই অনুক্রমে",
    "youWillSave": "আপনি সংরক্ষণ{currencySymbol}{amount}",
    "rewardPointsTitle": "{currencyName}",
    "okGotItCTA": "আচ্ছা, বুঝেছি",
    "billAmountPaidWithPoints": "পরের নির্দেশে তুমি তোমার অর্জনের পয়েন্ট বের কর।{billAmount}চার্জের পরিমাণ কম হতে পারে{currencyName}",
    "maxRedeemablePointsPer": "সর্বোচ্চ মান{maxValue}%s উপলব্ধ{currencyName}ব্যবহারযোগ্য বিভিন্ন সামগ্রী",
    "maxRedeemablePoints": "সীমা{maxValue} {currencyName}প্রতিটি ক্ষেত্রেই প্রযোজ্য",
    "vipPassTitle": "{vipPass}",
    "vipPassSubtitle": "বিভিন্ন প্রকার নির্বাচন করো{vipPass}",
    "vipMaxDiscount": "ম্যাক্স। ডাউনলোড করা হয়েছে{maxValue}প্রতি",
    "vipPassDetailsText": "{vipPass}বিবরণ",
    "swipeToBuy": "বিইউ-তে জয়",
    "redeemPointOnNextOrder": "পরের নির্দেশে তুমি তোমার অর্জনের পয়েন্ট বের কর।{percentage}পেমেন্ট পয়েন্টের মাধ্যমে বিলের দাম পরিশোধ করা যাবে।",
    "rewardPointToMoney": "{point} {currencyName} = {currencySymbol}{amount}",
    "passDetails": "বিবরণ",
    "noMembershipDescription": "মনে হচ্ছে আপনি এখনো কোন পাস করেননি",
    "vipPassActiveDays": "উল্লিখিত বস্তুর জন্য বৈধ{activeDays}দিন",
    "membershipValidity": "চিহ্নিত সময়ের মধ্যে{membershipExpirationTime}",
    "renew": "RENEW",
    "membershipPuschased": "কিনুন...{activationTime}",
    "membershipConclulded": "অন্তর্ভুক্ত{expireTime}",
    "renewMembershipText": "{vipPass}মেয়াদ উত্তীর্ণ আপনার পাসটা নতুন করে উপভোগ করুন এবং আবারও সুবিধাগুলো উপভোগ করুন",
    "membershipCouponUsed": "{totalUsed}কুন ব্যবহার করা হয়েছে",
    "backToHomeCTA": "বাড়ি ফিরে যান",
    "stopAndBuy": "বর্তমান পাস বন্ধ করুন এবং এই পাস ক্রয় করুন",
    "buyThisPass": "এই পাসটি কিনুন",
    "stopAndBuyVIPDescription": "বর্তমানে সক্রিয় থাকলে, আপনি প্রচুর উপকার হারাবেন{vipPass}যদি আপনি এই পাস কেনা",
    "vipPassBuyErrorMessage": "আপনার বর্তমানে সক্রিয় থাকলে, এই পাস করা যাবে{vipPass}বন্ধ করা হবে",
    "couponRedeemedOn": "পুনরায় আরম্ভ করা হয়েছে{expireTime}",
    "couponValidity": "চিহ্নিত সময়ের মধ্যে{expireTime}",
    "noCouponToShow": "প্রদর্শন করার জন্য কোনো কুপন নেই",
    "membershipCouponPerGuestMax": "পাসওয়ার্ড বৈধ{perGuestMax}কমান্ডের পাথ{activeDays}দিন",
    "recaptchaBranding": "এই সাইট পুন:প্রকাশ এবং গুগল দ্বারা সুরক্ষিত।{privacyPolicyLink}এবং{tncLink}প্রয়োগ করা হবে",
    "recaptchaPrivacyPolicy": "ব্যক্তিগত তথ্যের নীতিমালা",
    "recaptchaTnC": "& উত্তর",
    "savedByUsingRewardPoint": "আপনি স্বয়ংক্রিয়ভাবে সংরক্ষিত{amount}ব্যবহার করে{point} {currencyName}এই অনুক্রমে",
    "rewardPoints": "পুরস্কার",
    "loyaltyPoints": "আনুগত্য",
    "redeemPoints": "রেডম পয়েন্ট",
    "membershipAlreadySubscribedTitle": "পাস আগে সক্রিয় আছে",
    "membershipAlreadySubscribedDescription": "মনে হচ্ছে আপনি পাসটি চেষ্টা করছেন ইতোমধ্যে আপনার অ্যাকাউন্টের জন্য সক্রিয়",
    "stayHereCTA": "এখানেই আছে",
    "passName": "পাসওয়ার্ডের নাম",
    "purchasedOn": "কিনুন",
    "validTillText": "চিহ্নিত সময়ের মধ্যে",
    "amount": "Amount",
    "paymentMode": "প্রদানের মোড",
    "paymentStatus": "Payment Status",
    "transactionOn": "ট্রানস্যাকশন",
    "referenceId": "Reference ID",
    "refundMode": "র‌্যাপ মোড",
    "refundStatus": "Refund Status",
    "remark": "পরিষ্কার করো",
    "initiatedOn": "আরম্ভ করা হয়েছে",
    "processedOn": "প্রসেস করা হয়েছে",
    "paymentFailed": "বিফল",
    "passPaymentFailedDescription": "এই প্রদানের জন্য কোনো প্রদান করা হয়নি। যদি কোন পরিমাণ টাকা বাদ দেয়া হয় তাহলে ৭ দিনের মধ্যে পুনরায় ফেরত দেওয়া হবে।",
    "updateRewardProgramTitle": "আমরা আমাদের সর্বশেষ আপডেট{br}পুরস্কার কার্যক্রম",
    "seeWhatsNewCTA": "দেখুন নতুন কী।",
    "rewardPointRedeemRule": "তুলে ধর{maxEarn}{unit}আপনার বিল সঙ্গে{currencyName}. {earn} {currencyName} = {currency}{spend}",
    "updateRewardProgramTnC": "আপনার বর্তমান পুরস্কারের পয়েন্ট পরিবর্তন করা হবে{currencyName}. {br} {br}সংগ্রহকৃত সমস্ত পুরস্কার মুক্তির জন্য উপলব্ধ হবে",
    "unlimitedOrders": "সকল",
    "minCartValueForPointsRedemption": "দিনের সর্বনিম্ন মান{currencySymbol}{minOrderValue}প্রয়োজনমত সময়:{br}প্রয়োগ করা হবে{currencyName}এই অনুক্রমে",
    "minCartValueForPointsRedemptionRewardDetails": "{currencyName}উপরে অর্ডারে প্রয়োগ করা যাবে{currencySymbol}{minCartValueForPointsRedemption}",
    "deliveryLocation": "কার্সারের অবস্থান",
    "selectLocation": "অবস্থান নির্বাচন করুন",
    "addressDetails": "ঠিকানার বিবরণ",
    "deliveryLocationTitle": "অনুগ্রহ করে আপনার অবস্থান নিশ্চিত করুন",
    "addressLine": "গৃহ / ফ্ল্যাট / ফ্লোর সংখ্যা",
    "landmark": "/ রোড/ এলাকা",
    "addressMaxLength": 200,
    "saveAs": "নতুন নামে সংরক্ষণ",
    "office": "অফিস",
    "other": "অন্যান্য",
    "notdeliverableText": "দুঃখিত, আমরা এই অবস্থানে সরবরাহ করছি না",
    "selectDeliveryAddress": "ঠিকানা নির্বাচন করুন",
    "deleteYourAddress": "ঠিকানা মুছে ফেলুন",
    "dontDelete": "DON'T DELETE",
    "delete": "DELETE",
    "areYouSureAddress": "আপনি কি নিশ্চিতরূপে এই ঠিকানা মুছে ফেলতে ইচ্ছুক?",
    "placeHolderTitle": "Eg, জন এর স্থান",
    "orderDelivered": "প্রেরিত হয়েছে",
    "deliverTo": "উদ্ধার করুন",
    "membershipExpiredTitle": "আপনার{vipPassTitle}মেয়াদ উত্তীর্ণ",
    "getNewPassCTA": "নতুন পাস প্রাপ্ত করুন",
    "membershipExpiredDescription": "নতুন পাস করুন এবং ডিসকাউন্ট উপভোগ করুন",
    "discountSavedUsingMembership": "আপনি এই ব্যবহার করেছেন{totalUsed}সংরক্ষিত সময় ও অনুসন্ধান{currencySymbol}{totalDiscount}",
    "whereYouAt": "তুমি কোথায়?",
    "selectBrand": "ব্র্যান্ড নির্বাচন করুন",
    "payingAtOutlet": "টাকা{outletName}",
    "totalPayable": "সর্বমোট মান",
    "willSaveAmount": "আপনি সংরক্ষণ{currency}{amount}",
    "billPaid": "Bill Paid",
    "billCanPaidWithPoints": "{billAmount}বিলের দাম দিতে পারে{currencyName}",
    "everySpendEarnPoint": "প্রতি{unit}{spend}ব্যয় করেছি, আপনি অর্জন{earn} {currencyName}",
    "spotlightTitle": "কেন্দ্রবিন্দু",
    "mapMarkerDeliveryText": "পিনটি সঠিকভাবে স্থাপন করতে চেষ্টা করুন",
    "noSavedAddressText": "কোনো পরিচিতি পাওয়া যায়নি",
    "redirectingToPG": "পুনরায় লোড করা হচ্ছে{br}প্রদানের গেটওয়ে",
    "doNotCloseApp": "অনুগ্রহ করে অ্যাপ্লিকেশন বন্ধ করুন",
    "processingPayment": "প্রদানের মেয়াদ",
    "processingPaymentDescription": "আমরা আপনার পেমেন্ট করছি,{br}অনুগ্রহ করে অ্যাপ্লিকেশন বন্ধ করুন",
    "currentLevelTagText": "বর্তমান স্তর",
    "tierEligibilityVisit": "পরিদর্শন করুন{minSpend}চিহ্নিত সময়ের মধ্যে{duration} {durationUnit}এই স্তরের প্রতি",
    "tierEligibilitySpend": "খরচ{currency}{minSpend}অন্তর্ভুক্ত{duration} {durationUnit}এই স্তরের প্রতি",
    "tierEligibilityOrder": "ধারা{minSpend}চিহ্নিত সময়ের মধ্যে{duration} {durationUnit}এই স্তরের প্রতি",
    "tierEligibilityPoint": "কান{minSpend}বিন্দুর মধ্যে{duration} {durationUnit}এই স্তরের প্রতি",
    "tierProgramPromotionTNC": "কান{currencyName}প্রত্যেক ক্রয় আর টাকা দিয়ে তাদের মুক্তি দাও. প্রত্যেক{currencyName}একটি মান ধারণ করে{currency}১, তোমাকে তোমার খরচ বাঁচানোর অনুমতি দিচ্ছি।{br}{br}অতিরিক্ত পরিমাণ এবং সুবিধার জন্য টাইবের মাধ্যমে সংযুক্ত",
    "viewTierLevelsCTA": "টিয়ের স্তর দেখাও",
    "additionalBenefits": "আরও উপকার",
    "tierLevelsPopupTitle": "ধনাত্মক স্তর",
    "myBenefitsTabLabel": "আমার TNEF",
    "levelTabLabel": "LEVELS",
    "faqsTabLabel": "FAQS",
    "enterAmountShownOnBill": "বিলটির মধ্যে যে পরিমাণ লিখুন",
    "coinsCantBeClubbedWithCoupon": "{currencyName}কুপিয়ে ক্লাব হতে পারে না",
    "nextText": "NEXT",
    "billDetails": "বিল সংক্রান্ত বিবরণ",
    "billCreatedOn": "নির্মাণের তারিখ",
    "itemBasePriceTotal": "আইটেমের সর্বমোট",
    "totalBillAmount": "Total Bill Amount",
    "coinUsed": "কলিন ব্যবহৃত হয়েছে",
    "totalSaving": "সর্বমোট সংরক্ষণ",
    "selectOutletText": "প্রস্থান করো",
    "noOutletForSelectedCity": "নির্বাচিত শহরের জন্য কোনো প্রকাশনা নেই",
    "amountSaveOnBill": "{currency}{amount}আপনার বিলে সংরক্ষিত",
    "amountPaid": "Amount Paid",
    "transactionId": "Transaction ID",
    "cancelPayment": "বাতিলকরণ বাতিল করুন",
    "exitPayEarnConfirmationMsg": "আপনি কি নিশ্চিত আপনি বিল পরিশোধ করতে চান না এবং টাকা আয় করতে চান না?{currencyName}",
    "doNotPayCTA": "নাশ",
    "outletSize": 100,
    "earnCoinInPercentage": "কান{earn}{unit}বিলের মান{currencyName}",
    "tryAgainCTA": "পুনরায় প্রচেষ্টা করুন",
    "tooFarFromOutetDescription": "মনে হচ্ছে তুমি অনেক দূরে. দয়া করে নিশ্চিত করুন যে সঠিক সংবাদপত্রে আপনি টাকা দিচ্ছেন।",
    "nearbyOutletDistanceInMeter": "20",
    "annualSpend": "বার্ষিক ব্যয়{currency}{amount}",
    "tierTitle": "{title}স্তর সুবিধা",
    "loyaltyCardTierTitle": "{title}স্তর",
    "applyOffersOnNextPage": "Apply coins / coupon on next page",
    "swipeToPayAmount": "কা.{currency}{amount}",
    "termsAndConditions": "& উত্তর",
    "inTheTier": "এর মধ্যে{currentTier}মাত্রা,",
    "coinsEarned": "{amount} {currencyName}নিক্তি",
    "transactionDetails": "কর্মের বিবরণ",
    "cookingRequest": "রান্না করার অনুরোধ",
    "readOnlyMenuServiceTitle": "গৃহীত",
    "paymentFailedDescription": "আমরা আপনার পেমেন্ট করতে পারব না. যদি কোন টাকা বাদ দেয়া হয় তাহলে ২-৩ দিনের ব্যাবসার দিনে ফেরত দেয়া হবে।",
    "backToCartCTA": "সমাপ্তি",
    "paymentSuccess": "নিয়মিত প্রদান",
    "userLocationSearchPlaceholder": "স্থানীয়তা অথবা রাস্তার নাম অনুযায়ী অনুসন্ধান",
    "allOutlets": "সমস্ত আউটলেট",
    "doNotRemove": "কিছু মনে করবেন না",
    "remove": "মুছে ফেলুন",
    "switchRewardWarningTitle": "বিকৃত{type}মুছে ফেলা হবে",
    "switchRewardWarningDesc": "ট্যাব পরিবর্তন করলে,{type}আপনার বিলটিতে প্রয়োগ করা হবে।",
    "coinsText": "মুদ্রা",
    "couponText": "কুপন",
    "paymentProcessingInSeconds": "90",
    "rewardProgramDetails": "পুরস্কারের বিস্তারিত বিবরণ",
    "bookTable": "বইয়ের টেবিল",
    "tableOutlet": "টেবিলের নাম নির্বাচন করুন",
    "helpAndSupport": "সাহায্য",
    "termsOfService": "পরিসেবাের উৎস",
    "privacyPolicy": "ব্যক্তিগত তথ্যের নীতিমালা",
    "privacyPolicyAndTermsOfServiceDescription": "আমি একমত{brand}নিক্তি{br}{privacyPolicy}এবং{termsOfService}",
    "privacyPolicyAndTermsOfServiceDescriptionInternal": "আমি একমত{brand}নিক্তি{privacyPolicy}এবং{termsOfService}",
    "invalidGroupSizeMessage": "অনুগ্রহ করে দলের নাম পরিবর্তন করুন",
    "exitTableBooking": "টেবিল বুকিং থেকে প্রস্থান?",
    "dontWantToBookTable": "আপনি কি নিশ্চিতরূপে টেবিল নির্মাণ করতে ইচ্ছুক?",
    "dontBookTableCTA": "Throlphys- র জন্য সক্রিয় করো না",
    "bookingForLargeParty": "বড় পার্টির জন্য বুকিং?",
    "giveUsCallForLargeParties": "দয়া করে আমাদের বড় দলের জন্য বুকিং এর আহ্বান জানান। এটা আপনাকে আরও ভাল এক অভিজ্ঞতা প্রদান করতে আমাদের সাহায্য করবে",
    "bookedSlotWillbeCancelled": "যদি আপনি আপনার বই বাতিল করেন, আপনার বইটি বাতিল হয়ে যাবে।",
    "cancelBooking": "মে",
    "dontCancel": "নট",
    "guests": "অতিথি",
    "whenAreYouVisiting": "তুমি কখন যাচ্ছ?",
    "noSlotsAvailable": "কোনো ইঙ্গিত উপলব্ধ নেই",
    "customCaps": "CUSTOM",
    "callOutlet": "কল আউট",
    "callOutletCaps": "না ।",
    "forLargeParties": "বড় পার্টির জন্য",
    "tableBooked": "টেবিলের সেল",
    "bookingCancelled": "বই বাতিল করা হয়েছে",
    "forGroupSize": "উল্লিখিত সময় অবধি{groupSize}",
    "payAndEarn": "টাকা & জয়",
    "bookingDetails": "বিস্তারিত বর্ণনা",
    "bookings": "বই",
    "addOnMinSelection": "যে কোন একটি নির্বাচন করা হবে{minSelection}বিকল্প",
    "addOnMinSelectionMultiple": "যে কোন একটি নির্বাচন করা হবে{minSelection}বিকল্প",
    "addOnMinAndMaxSelection": "যে কোন একটি নির্বাচন করা হবে{minSelection}চিহ্নিত স্থানে চলুন{maxSelection}বিকল্প",
    "addOnMaxSelection": "টোক্‌কা নির্বাচন করুন{maxSelection}বিকল্প",
    "addOnMaxSelectionMultiple": "টোক্‌কা নির্বাচন করুন{maxSelection}বিকল্প",
    "maxLimitWarningAddon": "এই বস্তুর জন্য আপনার সর্বাধিক সীমা ধার্য করা হয়েছে",
    "minRequiredWarningAddon": "অন্তত নির্বাচন করতে হলে প্রয়োজন{minSelection}বস্তু থেকে{category}",
    "bookingYourTable": "আপনার টেবিলের বই",
    "pleaseDoNotCloseApplication": "অনুগ্রহ করে অ্যাপ্লিকেশন বন্ধ করুন",
    "alreadyTooManyBooking": "ইতোমধ্যে অনেক বই রয়েছে",
    "have5ActiveBookings": "তোমার কাছে ৫ টা সক্রিয় বই আছে। একজন অতিথি ৫টি সক্রিয় বই পড়তে পারেন না। অনুগ্রহ করে একটি ভিন্ন অ্যাকাউন্ট থেকে বই নির্বাচন করুন।",
    "sameSlotBooking": "বই বর্তমানে উপস্থিত",
    "sameSlotBookingDescription": "এই সময়-টি বর্তমানে উপস্থিত রয়েছে। অনুগ্রহ করে অন্য একটি নাম নির্বাচন করুন।",
    "updateProfileTitle": "প্রোফাইল আপডেট করুন",
    "updateProfileDescription": "দয়া করে আপনার প্রফাইলটি সংরক্ষণ করুন",
    "updateProfileCTA": "আপডেট",
    "selectItem": "নির্বাচন করুন",
    "itemsAddedInCart": "কমান্ডে যোগ করা বস্তু",
    "customizationPopupAddItemCTA": "একটি ডি.ডি. আইটেম{currency}{amount}",
    "continueCTA": "এগিয়ে চলুন",
    "bogoItemPlaceholderText": "{stack}আইটেম",
    "bogoOfferPageTitle": "কিনে নিন{buyQuantity}যা{getQuantity}প্রস্তাব",
    "bogoItemsTitle": "কিনে নিন{buyQuantity}যা{getQuantity}বস্তু",
    "missedPointsOnOrder": "তুমি পারতে{br}পুরস্কার পাওয়া{br}এই অনুক্রমে",
    "earnedPointsOnOrder": "আপনি এরি পুরস্কার পেয়েছেন{br}এই অনুক্রমে{br}Moice - র প্রতিলিপি ডাউনলোড করুন",
    "orderFromAppToEarnPoints": "অ্যাপ্লিকেশনের থেকে অর্ডার এবং প্রত্যেক নিয়মের উপর ভিত্তি করে লেখা হবে",
    "orderFromAppToRedeemPoints": "আপনার পয়েন্ট মুক্ত করার জন্য অ্যাপ থেকে অর্ডার",
    "downLoadAppCTA": "নিচে নামা/ এপিপি",
    "downloadAppToManageProfileTitle": "প্রোফাইল পরিচালনা করতে অ্যাপ্লিকেশন ডাউনলোড করুন",
    "downloadAppToManageProfileDescription": "আপনি আপনার প্রোফাইল পরিচালনা করতে এবং আমাদের এ্যাপে আরো অনেক কিছু করতে পারেন",
    "swipeToBookTable": "[ ৫ পৃষ্ঠার চিত্র]",
    "bogoOfferInstruction": "পুরস্কার, অ্যাপ্লিকেশনের জন্য মেনু খোলা হবে, 'ওফার ব্যানার' বেছে নিন । কনফিগার প্রয়োগ করা হবে ।",
    "bogoCouponTnC": "সর্বোচ্চ মান{getQuantity}অর্ডারে কোন মুক্ত আইটেম থাকবে",
    "bogoCouponPerTnC": "সর্বোচ্চ মান{getQuantity}এটি প্রয়োগের পরে কোনো বস্তু প্রতিস্থাপন করা হবে",
    "bogoCouponMenuValidation": "নির্বাচিত বস্তুর মধ্যে বৈধ আইকন",
    "bogoCouponCTA": "আইটেম সমূহ নির্বাচন করুন",
    "bookingId": "Booking Id",
    "bookingStatus": "Booking Status",
    "groupedServiceSummary": "{itemCount}আইটেম{duration}মিনিট",
    "asSoonAsPossible": "যত তাড়াতাড়ি সম্ভব",
    "oneOrderMultipleServices": "এক আদেশ, একাধিক সেবা",
    "checkoutInProgress": "আপনার বই তৈরি করা হচ্ছে...",
    "slotNoLongerAvailable": "সেই সময়টা কেবল পড়ার কথা ছিল। অনুগ্রহ করে অন্য একটি নাম নির্বাচন করুন।",
    "expiredCartServicesRemoved": "হোস্ট- এর সঙ্গে যোগাযোগ বিচ্ছিন্ন হয়েছে । অনুগ্রহ করে অবশিষ্ট পরিষেবাগুলো পর্যালোচনা করুন।",
    "cartNoLongerAvailable": "তোমার গাড়ির আর সার্ভিস নেই. অনুগ্রহ করে পুনরায় পরিসেবা যোগ করুন।",
    "invalidServiceGroup": "কিছু সার্ভিস চালু করা যায় নি । দয়া করে আপনার কার্ট পর্যালোচনা করুন।",
    "mixedHoodServiceGroup": "এক ক্ষেত্রে, একই সার্ভিস অবস্থান ব্যবহার করতে হবে ।",
    "bookingOrderReference": "& উদ্ধৃতি নির্দেশক",
    "quantityShort": "কিউ- টি:{quantity}",
    "downloadBill": "বিল ডাউনলোড করুন",
    "serviceText": "পরিসেবা",
    "selectedServiceCount": "{count}নির্বাচিত",
    "addMoreServices": "অতিরিক্ত পরিসেবা যোগ করুন",
    "selectionsSaved": "ব্রাউজ করার সময় আপনার নির্বাচনগুলো সংরক্ষণ করা হবে।",
    "itemsInCart": "♪ বহুভাষী এক ♪{# item in cart}অন্যান্য{# items in cart}}",
    "categoriesInCart": "ঠিক আছে{# category}অন্যান্য{# categories}}",
    "viewCart": "প্রদর্শন",
    "scheduleCart": "নির্ধারিত সময়সীমা",
    "clearCartTitle": "গাড়ি থেকে সব জিনিস সরিয়ে ফেলা হবে?",
    "clearCartDescription": "সরিয়ে ফেলা হলে, উদ্দিষ্ট বস্তু পুনরায় যোগ করা আবশ্যক।",
    "cartSelectionCleanupDelayMs": 300000,
    "keepCart": "মুছে ফেলা হবে না",
    "confirmClearCart": "হ্যাঁ, সরিয়ে নাও",
    "changeAddressCartTitle": "সার্ভিস ঠিকানা পরিবর্তন করা হবে কি?",
    "changeAddressCartDescription": "বিভিন্ন অবস্থানে সার্ভিস করা হয় । অন্য কোনো সার্ভিস অবস্থানে পরিবর্তন করা হচ্ছে।",
    "changeAddressAndClearCart": "পরিবর্তন ও অপসারণ",
    "distanceFromHood": "{distance}সেবা কেন্দ্র থেকে কিলোমিটার দূরে",
    "servingHomesWithCare": "যত্ন নিয়ে বাড়ি সেবা করা",
    "yourHomeOurPriority": "আপনার বাড়ি, আমাদের অগ্রাধিকার",
    "bookOnceGetItAllDone": "বই একবার, সব শেষ হয়ে যাবে",
    "statusUnavailable": "অফ-লাইন অবস্থা উপলব্ধ নয়",
    "servicesCount": "♪ বহুভাষী এক ♪{# service}অন্যান্য{# services}}",
    "paymentStatusLabel": "প্রদানের মেয়াদ:{status}",
    "viewServices": "সার্ভিস প্রদর্শন",
    "hideServices": "পরিসেবা আড়াল করা হবে",
    "durationMinutes": "{duration}মিনিট",
    "addMoreItems": "অতিরিক্ত সামগ্রী যোগ করুন",
    "offerExistInCart": "প্রস্তাব ইতোমধ্যে কার্টে যোগ করা",
    "offerExistInCartDescription": "তোমার গাড়ির জিনিসপত্রের একটা অংশ",
    "removeItemsCTA": "বস্তু মুছে ফেলুন",
    "removeItem": "মুছে ফেলুন",
    "goToCartCTA": "চিহ্নিত স্থানে চলুন",
    "applyCouponCTA": "এই পদক্ষেপ নিন",
    "offerRemovePopupTitle": "অপসারণযোগ্য তথ্য মুছে ফেলা হবে",
    "offerRemovePopupDescription": "নীচে স্থানান্তর করা হলে, সংশ্লিষ্ট বস্তু মুছে ফেলা হবে ।",
    "offerRemovePopupCTA": "REMOVE",
    "offerRemovePopupSecondaryCTA": "কিছু মনে করবেন না",
    "offerNotApplicableTitle": "{preText}এই মুহূর্তে প্রযোজ্য নয়",
    "offerNotApplicableDescription": "এই মুহূর্তে প্রযোজ্য নয়",
    "offerNotApplicableTitle2": "এই মুহূর্তে প্রযোজ্য নয়",
    "viewOfferDetails": "বিস্তারিত বিবরণ দেখুন",
    "viewDetailsCTA": "বিস্তারিত দেখুন",
    "rateYourExperienceCTA": "আপনার অভিজ্ঞতা",
    "yourRatingText": "আপনার মাত্রা",
    "feedbackVisibleTimeInMinutes": "30",
    "submitFeedbackCTA": "উদ্‌বিগ্নতা",
    "orderFeedbackTitle": "অনুক্রম",
    "viewOrderText": "তালিকা অনুসারে প্রদর্শন",
    "foodRatingQuestion": "খাবার কেমন ছিল?",
    "overallRatingQuestion": "আপনার অভিজ্ঞতা কেমন ছিল?",
    "serviceRatingQuestion": "সার্ভিস কেমন ছিল?",
    "ambienceRatingQuestion": "কিন্তু, সা.",
    "feedbackSuccessText": "তোমার ভালবাসা দেখানোর জন্য অনেক ধন্যবাদ। আমরা নিশ্চিত হব যে আপনার পরবর্তী সফর খুবই সাধারণ।",
    "feedbackSuccessBadText": "আপনাদের সৎ মতামত জানানোর জন্য ধন্যবাদ। আমরা আপনার প্রত্যাশা পূরণ না করার জন্য ক্ষমাপ্রার্থী। আমাদের দল বিস্তারিত আলোচনা করার জন্য আপনার কাছে ফিরে আসবে।",
    "weLoveYoutooText": "আমিও তোমাকে ভালবাসি",
    "weAreImporvingText": "আমরা উন্নতি করছি",
    "weAreSorryText": "আমরা খুবই দুঃখিত",
    "enjoyCouponText": "পরবর্তী এই কুপন উপভোগ করুন",
    "tellUsMore": "(ঐচ্ছিক)",
    "lastOrderListSize": "1",
    "lastOrderPreviousDays": "3",
    "collectOrder": "কাউন্টার থেকে আপনার অর্ডার সংগ্রহ করুন",
    "deliveryChargesTitle": "চার্জ",
    "deliveryDiscount": "Delivery Discount",
    "orderHistoryPopupTitle": "পূর্ববর্তী তথ্য",
    "orderHistoryPopupSubtitle": "আপনার ব্রাউজ-ইতিহাস ইতিহাস দেখার জন্য অ্যাপ্লিকেশন ডাউনলোড করুন",
    "orderHistoryPopupDesciption": "আপনি আপনার ইতিহাস দেখতে পারেন এবং আমাদের এ্যাপে আরো অনেক কিছু করতে পারেন।",
    "orderHistoryPopupCTA": "এপিপি ডাউনলোড করুন",
    "selfPickupLabel": "স্বাস্থ:",
    "switchText": "SWITCH",
    "addMoreItemsTitle": "অতিরিক্ত সামগ্রী যোগ করুন",
    "goToMenuCTA": "[ ১৬ পৃষ্ঠার চিত্র]",
    "minBillAmountTnc": "বিলের সর্বনিম্ন মান{currencySymbol}{minBillValue}সরবরাহের আদেশ প্রয়োজন{br}অনুগ্রহ করে আপনার গাড়িতে আরো কিছু জিনিস যোগ করুন",
    "paymentPollInterval": [
      0,
      5,
      10,
      15,
      20,
      20,
      20,
      20,
      20,
      15,
      5,
      5
    ],
    "viewAllRatingsCTA": "সকল মাত্রা প্রদর্শন",
    "featuredItemsTitle": "বিবিধ বস্তু",
    "swipeToPlaceOrder": "বই স্থাপনার উদ্দেশ্যে সোয়াইপ করুন",
    "rateYourLastExperience": "আপনার শেষ অভিজ্ঞতার হার",
    "swipeToPay": "টাকা দিয়ে সোয়াইপ করুন",
    "nearby": "নিকটবর্তী",
    "outletDistanceDisplayThresoldInKm": "1",
    "nearbyOutletThresoldInMeter": "50",
    "addToCartCTA": "চিহ্নিত স্থানে ইম্পোর্ট করুন",
    "availRewardWithPoints": "আভাল এই পুরস্কার{pointPrice}প্রান্তীয় বিন্দু",
    "rewardDetails": "অধিক বিবরণ",
    "pointsDeducted": "{pointPrice}পয়েন্ট হ্রাস করা হবে",
    "appApplicableOnly": "শুধুমাত্র বাধ্যতামূলকভাবে প্রযোজ্য",
    "swipeToCollectReward": "সংগ্রহে সোয়াইপ করুন",
    "excludeReservationStatus": "PENDING",
    "checkedInText": "CHECKED IN",
    "FoodImagePlaceholderUrl": "https://assets.fudr.in/assets/images/food-image-placeholder.png",
    "maximumDiscountText2": "ভিটোতে{maxValue}",
    "knowMoreCTA": "অতিরিক্ত তথ্য",
    "selectItemCTA": "আইটেম সমূহ নির্বাচন করুন",
    "applyOfferCTA": "অনুমতি প্রদান করুন",
    "offerText": "প্রস্তাব",
    "rewardText": "পুরস্কার",
    "couponAlreadyTaken": "আপনি ইতিমধ্যে আপনার সাথে কুপন করেছে{currencyName}",
    "dayValidationError": "{preText}শুধুমাত্র প্রযোজ্য{applicableWeekdays}",
    "timeValidationError": "{preText}শুধুমাত্র উপলব্ধ রয়েছে{startTime}চিহ্নিত স্থানে চলুন{endTime}",
    "dateValidationError": "{preText}উপলব্ধ স্থান থেকে{activationTime}",
    "rewardValidationTitle": "{preText}এই মুহূর্তে প্রযোজ্য নয়",
    "trackOrder": "ট্র্যাক",
    "offerAlreadyAppliedTitle": "{preText}বর্তমানে প্রয়োগ করা হয়েছে",
    "removeOfferCTA": "মুছে ফেলুন{preText}",
    "amountValidationError": "এই{preText}সর্বনিম্ন ক্রম{currencySymbol}{minOrderValue}",
    "amountValidationErrorTitle": "আরো বস্তু যোগ করুন",
    "expireValidationDateError": "এই{preText}মেয়াদ উত্তীর্ণ হয়েছে{expireDate}",
    "expireValidationError": "এই{preText}মেয়াদ উত্তীর্ণ হয়েছে",
    "expireValidationErrorTitle": "মেয়াদ উত্তীর্ণ",
    "useRewardPointToGetDiscount": "ব্যবহার{currencyName}তোমার বিলে ডিসকাউন্ট পেতে",
    "billAmountPaidWithPoints2": "তুলে ধর{billAmount}%s-র সাথে{currencyName}",
    "howToRedeemTitle": "কিভাবে রেডম দিয়ে",
    "applyPointsOnCart": "প্রয়োগ করুন{currencyName}পৃষ্ঠার মধ্যে",
    "okCTA": "OK",
    "itemNotAvailableTitle": "বস্তুটি বিদ্যমান নয়",
    "itemNotAvailableDescription": "এই মুহূর্তে উপলব্ধ নয়।{br}অসুবিধার জন্য দুঃখিত",
    "couponAppliedText": "{displayTitle}এই অনুক্রমের উপর প্রয়োগ করা হবে",
    "appliedCouponCTAText": "YAY!",
    "reviewOnSocialText": "দয়া করে সোশ্যাল চ্যানেলে আমাদের পর্যালোচনা করুন এবং আপনার অভিজ্ঞতা সম্পর্কে বিশ্বকে জানান",
    "reviewOnGoogeText": "বিশ্ব নিরীক্ষা",
    "reviewOnTripadvisorText": "বিশ্ব নিরীক্ষা",
    "homeAddressTitle": "হোম",
    "workAddressTitle": "কর্ম",
    "otherAddressTitle": "অন্যান্য",
    "nearbyOutletsSize": "5",
    "viewMoreOutlets": "আরো দেখুন",
    "menuSearchPlaceholder": "মেনুর মধ্যে অনুসন্ধান করুন",
    "menuSearchTitle": "অনুসন্ধানের মেনু",
    "specialInstructions": "রান্নার অনুরোধ যোগ করো",
    "swipeToOrderCTAText": "ইংরেজি",
    "swipeToPayCTAText": "কা.",
    "emptyNameMessage": "অনুগ্রহ করে আপনার নাম লিখুন",
    "emptyGenderMessage": "দয়া করে লিঙ্গ নির্বাচন করুন",
    "emptyEmailMessage": "আপনার ইমেইল ঠিকানা লিখুন",
    "emptyDOBMessage": "অনুগ্রহ করে একটি তারিখ লিখুন",
    "emptyAnniversaryDateMessage": "অনুগ্রহ করে একটি তারিখ লিখুন",
    "namePlaceHolder": "আপনার নাম",
    "emailPlaceHolder": "আপনার ই-মেইল আইডি",
    "otpPlaceHolder": "OTP",
    "phoneNumberPlaceHolder": "মোবাইল না।",
    "doaPlaceHolder": "dd-mm-yyyy",
    "doaSecondaryPlaceHolder": "আপনার জন্মদিন",
    "dobPlaceHolder": "dd-mm-yyyy",
    "dobSecondaryPlaceHolder": "তোমার জন্ম তারিখ",
    "signUpRequiredFields": [
      "name"
    ],
    "pointPrice": "{pointPrice}বিন্দু",
    "lockedItemDealCTA": "বস্তু প্রদর্শন করুন",
    "unlockedItemDealCTA": "আইটেম সমূহ নির্বাচন করুন",
    "promoCodePlaceholder": "প্রমো কোড লিখুন",
    "applyPromoCodeCTA": "APPLY",
    "promoCodeNotFoundDescription": "আপনার উল্লিখিত কোড সঠিক নয় অথবা এর মেয়াদ পূর্ণ হয়েছে।",
    "promoCodeNotFoundTitle": "প্রোটো কোড পাওয়া যায়নি",
    "promoOfferTitle": "স্বাধীনতা প্রস্তাব",
    "tncTitle": "& উত্তর",
    "promoCodeTitle": "প্রোমো কোড আছে?",
    "loyaltyPassTitle": "আনুগত্য পাস",
    "applyCTAText": "প্রয়োগ করুন",
    "unlockYourReward": "{name}আপনি শুধু বন্ধ থেকে দূরে সরে যাচ্ছেন{displayTitle}",
    "unlockYourRewardDescrption": "এই প্রস্তাবটি দাবি করতে এখন নিবন্ধন করুন",
    "verifyAndUnlockOffer": "আন- লক করুন",
    "grabOfferTitle": "তুমি এই প্রস্তাব দাবি করার থেকে সরে যাচ্ছ। ধরো!",
    "demoOfferTnC": "এই প্রস্তাব একটি ডেমো, যা শুধুমাত্র কল্পনার জন্য সরবরাহ করা হয়",
    "otpVerificationTitle": "OTP Verty-র বিবরণ",
    "orderConfirmationDemoTitle": "ডেমো শেষ করার জন্য ধন্যবাদ!",
    "orderConfirmationDemoDescription": "আমরা আশা করি তুমি এটা পড়ছ।",
    "orderNowCTA": "& এখন পাঠাও",
    "rewardProgramSubtext": " ",
    "dealListOrderPriority": [
      "loyalty",
      "deal",
      "promo"
    ],
    "enterReferralCode": "কোনো সংকেত আছে?{cta}",
    "referralCodeFieldLabel": "উল্লেখকৃত কোড",
    "referralCodePlaceHolder": "উল্লেখকৃত কোড লিখুন",
    "enterReferralCodeCTA": "কোড লিখুন",
    "invalidReferralCodeTitle": "অবৈধ সীমা",
    "invalidReferralCodeDescription": "আপনি যে লাইনে লিখেছেন তা বৈধ নয় । অনুগ্রহ করে একটি বৈধ কোড লিখুন",
    "referrals": "আমার গঠন",
    "referralsTitle": "গঠন",
    "referralTabTitle": "আমার গঠন",
    "referralCardTitle": "& সন্ধান",
    "referralPopupTitle": "& সন্ধান",
    "howReferralWorksTitle": "এটা কিভাবে কাজ করে",
    "referralCodeTnc": "আপনার বন্ধুদের সঙ্গে শর্তযুক্ত কোড শেয়ার করুন",
    "referralPointCardRule": "আপনার বন্ধু ও বন্ধুদের সঙ্গে আপনার উল্লেখের কোড শেয়ার করুন{rewardPoints}তারা যখন প্রথম আদেশ করে",
    "referralCouponCardRule": "আপনার বন্ধুদের সঙ্গে নির্দিষ্ট কোড শেয়ার করুন এবং পান{dealName}যখন তাদের সর ্ বাধিক হতভাগ ্ য ব ্ যক ্ তি তৎপর হয়ে উঠেছিল ।",
    "referralPointRule": "আপনি ‘ পাবেন ’{rewardPoints}আপনার বন্ধু যখন তাদের প্রথম নির্দেশনা দেয়",
    "referralCouponRule": "আপনি ‘ পাবেন ’{dealName}আপনার বন্ধু যখন তাদের প্রথম আদেশ দেন",
    "gainerPointRule": "তারা ‘হ্যাঁ পাবেন’{rewardPoints}আপনার উল্লেখকৃত লিঙ্কের সঙ্গে স্বাক্ষর করার ক্ষেত্রে মূল বিষয়গুলো",
    "gainerCouponRule": "তারা ‘হ্যাঁ পাবেন’{dealName}আপনার উল্লেখকৃত লিঙ্কের সঙ্গে স্বাক্ষর করার মাধ্যমে পুরস্কার",
    "referralMilestonePointRule": "যা{rewardPoints}বিন্দু{thresold}সফল কথাবার্তা",
    "referralMilestoneCouponRule": "যা{dealName}এর উপর{thresold}সফল কথাবার্তা",
    "referralMilestonePointMaxThresoldRule": "যা{rewardPoints}বিন্দু{thresold}সাফল্যের সাথে চিহ্নিত করা হবে{maxThresold}গঠন",
    "referralMilestoneCouponMaxThresoldRule": "যা{dealName}এর উপর{thresold}সাফল্যের সাথে চিহ্নিত করা হবে{maxThresold}গঠন",
    "referralRewardKnowMoreCTA": "অতিরিক্ত তথ্য",
    "referralCodewhatsappShareMessage": "হেই, আমি ব্যবহার করছি{brandName}অ্যাপ। আমার মূল কোড ব্যবহার করো{referralCode}",
    "referralCodewhatsappShareMessagNew": "অসাধারণ কিছু সৃষ্টি? আমি ব্যবহার করি{brandName}আমার প্রিয়দের জন্য। আমার মূল কোড ব্যবহার করো{referralCode}যখন তুমি সাইন করবে... ...তখন তুমি বিশেষ ডিসকাউন্ট পাবে. সেরা খাবার চুক্তি থেকে দূরে থেকো না! অ্যাপটি নাও:{appLink}",
    "signupDetailsTitle": "এক শেষ বিষয়",
    "unlockCouponTitle": "আপনি আন-লক করেছেন{br} {displayTitle}কুপন",
    "unlockFallbackCouponTitle": "{displayTitle}নতুন অতিথিদের জন্য কুপন, আমরা আপনার সাথে দেখা করতে পেরে খুশি{fallbackDisplayTitle}কুপন!",
    "unlockCouponDescription": "আমরা তোমাকে এই কুপনটা দিয়েছি।{br}পরের অর্ডারে লাগিয়ে দাও",
    "couponCodeText": "কোড -{couponCode}",
    "noOfferApplicableTitle": "দুঃখিত, এই প্রস্তাবটি প্রযোজ্য নয়",
    "noOfferApplicableDescription": "কিন্তু, আমরা আপনাকে আমাদের আ্যপার্টমেন্টের ওপর আমাদের আনুগত্যের অনুষ্ঠান থেকে রোমাঞ্চকর ফল লাভ করেছি!",
    "goBackCTA": "পূর্বাবস্থায় যাও",
    "changeCTA": "পরিবর্তন",
    "referralMilestoneProgress": "{completed}/{total}উল্লেখকৃত সম্পন্ন",
    "genderFields": [
      "MALE",
      "FEMALE",
      "OTHER"
    ],
    "unlockFallbackOfferTitle": "{displayTitle}শুধু নতুন যোগদানকারীদের জন্য। কিন্তু, আমরা আপনাদের সামনে বিশেষ আচরণ করেছি!",
    "unlockOfferTitle": "আপনি আন-লক করেছেন{br} {displayTitle}",
    "getBrandAppCTA": "যাও{brandName}এপিপি",
    "offerAlreadyRedeemed": "সাফল্যের সঙ্গে দান",
    "unlockMoreOfferOnApp": "আরও প্রস্তাব দিয়ে উপকার লাভ করুন{br}জলদি অ্যাপটি নিয়ে আসো!",
    "getMoreOffers": "আরো প্রস্তাব করুন!",
    "offerExpiredTitle": "দুঃখিত, এই প্রস্তাবের মেয়াদ শেষ।",
    "getDealTitleCTA": "যা{dealTitle}",
    "rewardPointEarnedTextWithoutCurrency": "{rewardPointsText} {br}এই আদেশের উপর নিবদ্ধ",
    "cartAdditionalSupportText": "প্রাইসের মধ্যে কন্টেইনার চার্জ অন্তর্ভুক্ত করা হয়েছে (যদি পানীয় ও লিঙ্ক যোগ করা যায় না)",
    "orderingAtTitle": "অনুক্রম",
    "pleaseSelectAnOutlet": "অনুগ্রহ করে একটি সংবাদপত্র নির্বাচন করুন",
    "searchForOutlet": "আউটলেট অনুসন্ধান",
    "sessionExpiryLoginTitle": "তবে এটা নিশ্চিত যে আপনার নাম",
    "sessionExpiryLoginDescription": "নিষ্ক্রিয় অবস্থায় লগ-ইন করা হয়েছে। অনুগ্রহ করে আপনার নিবন্ধিত মোবাইল ফোন নাম্বার সহযোগে লগ-ইন করুন",
    "sessionExpiryPopoverTitle": "আপনার সেশানের মেয়াদ পূর্ণ হয়েছে",
    "sessionExpiryPopoverDescription": "অনুগ্রহ করে পুনরায় লগ-ইন করুন।",
    "sessionExpiryPopoverCTA": "লগ-ইন করুন",
    "tierUpgradeBenefitText": "অতিরিক্ত টলার লেভেলের দিকে উঠে এমনকি আরও বড় উপকারও লাভ করে!",
    "isExternalLoyaltyEnabled": false,
    "applyOfferOnCart": "অর্ডার ঠিক করার সময় এই প্রস্তাবটি প্রয়োগ করুন",
    "viewOfferDetailsCTA": "বিস্তারিত দেখুন",
    "runningOrderFetchStatuses": [
      "UNATTENDED",
      "CONFIRMED"
    ],
    "minOrderValueOfferTnc": "মিনিটের অর্ডার দিচ্ছি।{currencySymbol}{minOrderValue}",
    "refundSupportInfo": "",
    "displayMenuItemImages": true,
    "referralRewardTitle": "পুরস্কার",
    "loginToViewPoints": "প্রদর্শনের উদ্দেশ্যে লগ-ইন{br}লাভযুক্ত বিন্দু",
    "emptyReferralCodeMessage": "অনুগ্রহ করে একটি বৈধ পংক্তি উল্লেখ করুন",
    "emptyReferralRewardMessage": "এখনো কোন গঠন হয় নি। পুরস্কার পেতে বার্ষিক কোড শেয়ার করুন!",
    "referredBytext": "উল্লেখকৃত",
    "referredTotext": "উল্লেখ করা হয়েছে",
    "referralActivationOnGainerActivation": "তারা যখন আপনার নির্দেশে স্বাক্ষর করে",
    "referralActivationPostGainerPurchase": "তাদের প্রথম আদেশ",
    "referralActivationTotalSpend": "তাদের প্রথম আদেশ অনুসারে{amount}",
    "referralActivationTotalSpendDefault": "যখন তাদের সর ্ বাধিক হতভাগ ্ য ব ্ যক ্ তি তৎপর হয়ে উঠেছিল ।",
    "referralRewardReceived": "এক যথাযথ প ্ রতিদান ।{rewardValue}",
    "referralRewardReceivedPoints": "এক যথাযথ প ্ রতিদান ।{rewardTitle} {currencyName}",
    "referralRewardReceivedOffer": "এক যথাযথ প ্ রতিদান ।{rewardTitle}",
    "referralRewardReceivedDefault": "এক যথাযথ প ্ রতিদান ।{rewardTitle}",
    "referralRewardPending": "আপনি পাবেন{rewardValue} {conditionText}",
    "referralRewardPendingOnActivation": "অ্যাপে সাইন করার পর তুমি পুরষ্কার পাবে",
    "referralRewardPendingPostPurchase": "তুমি তাদের প্রথম আদেশ মানতে পারবে",
    "referralRewardPendingTotalSpend": "তুমি তাদের প্রথম আদেশ অনুসারে পুরষ্কার পাবে{amount}",
    "referralRewardPendingTotalSpendDefault": "তুমি পুরস্কার পাবে যখন তারা প্রথম আদেশ পালন করবে",
    "referralRewardPendingPurchaseN": "আপনি পুরস্কার পাবেন একবার তারা  ভাগ ব্যয়{amount}চিহ্নিত সময়ে{brandName}",
    "accessDeniedPopoverTitle": "প্রবেশাধিকার প্রত্যাখ্যাত",
    "accessDeniedPopoverDescription": "আপনি লগ-ইন করেছেন{guestMobileNo}মোবাইল নেই। এই অ্যাকাউন্টের ক্ষেত্রে ব্যবহারের অনুমতি আপনার নেই।",
    "accessDeniedPopoverCTA": "বাড়ি যাও",
    "accessDeniedPopoverSecondaryCTA": "প্রস্থান করুন",
    "aRewardText": "পরিপূর ্ ণ প ্ রতিফল হিসেবে ।",
    "loginToViewEarnedPointsAndReward": "লগ-ইন করতে আপনার ব্যবহৃত",
    "loginToPlaceOrder": "লগ-ইন শেল",
    "guestModeLoginRequired": "লগ-ইন করার উদ্দেশ্যে লগ-ইন করা আবশ্যক",
    "loginButton": "লগ-ইন",
    "serviceTypeValidationErrorTitle": "প্রযোজ্য নয়",
    "searchAddressPlaceholder": "সাইড-বার অনুসন্ধান করুন অথবা বার্তা প্রাপ্ত করুন",
    "skipCTAText": "SKIP",
    "geolocationText": "বর্তমান অবস্থান",
    "proximityRadius": "500",
    "reviewBooking": "মুছে ফেলা হচ্ছে",
    "subTotal": "সর্বমোট",
    "gstAndCharges": "জি. এস. টি. চার্জ",
    "editCTA": "সম্পাদনা",
    "deleteCTA": "মুছে ফেলুন",
    "identifyingLocation": "আপনার অবস্থান সনাক্ত করা হচ্ছে",
    "addressBook": "ঠিকানা-বই",
    "addNewAddress": "নতুন ঠিকানা যোগ করুন",
    "selectDate": "তারিখ নির্বাচন করুন",
    "selectDuration": "Select Duration",
    "selectSlot": "ঘর নির্বাচন করুন",
    "chooseService": "পরিসেবা নির্বাচন করুন",
    "swipeToPlaceBooking": "ইংরেজি",
    "noBookings": "বইয়ের কোনো তথ্য উপস্থিত নেই",
    "bookingDetils": "বিস্তারিত বর্ণনা",
    "slotBooked": "বই মুছে ফেলা হয়েছে",
    "OTP": "OTP : ",
    "bookedFor": "বই",
    "addressText": "ঠিকানা",
    "cleaning": "পরিশ্রুত করা হচ্ছে",
    "atYourDoorStep": "আপনার দোরগোড়ায়{defaultDispatchTimeMinutes}মিনিট",
    "currentlyUnavailable": "বর্তমানে উপলব্ধ নয়",
    "earliestAvailableSlot": "প্রথম সারি দেখাও",
    "prebook": "বই",
    "neayYouSoon": "আমরা শীঘ্রই তোমার কাছে আসব!",
    "notifyMe": "আমার আগমন",
    "tapLocalityChange": "সেবাযোগ্য এলাকা নির্বাচন করার জন্য তাp এখানে",
    "bookingConfirmed": "বই মুছে ফেলা হয়েছে",
    "bookingDateAndTime": "বই ও সময়",
    "bookedSlot": "মুছে ফেলা",
    "totalText": "সর্বমোট",
    "recoverCTA": "পুনরুদ্ধার",
    "refundAndCancellationPolicy": "পুনঃলিখনযোগ্য নীতি",
    "refundAndCancellationPolicyDescription": "৫ মিনিটের মধ্যে সম্পূর্ণ পরিশোধন বাতিল করা হয়েছে।{br}আংশিক নিন্দার কারণে ডিসকাউন্টের বিরুদ্ধে মীমাংসা করা হবে।",
    "privacyPolicyUrl": "https://www.qwiky.in/privacy-policy",
    "tncUrl": "https://www.qwiky.in/tnc",
    "refundPolicyUrl": "https://www.qwiky.in/refund-policy",
    "instagramUrl": "https://www.instagram.com/qwiky_official/",
    "whatsIncludedExcluded": "এর মধ্যে কি অন্তর্ভুক্ত এবং উপেক্ষিত?",
    "underStoodCTA": "বুঝেছিস",
    "fewHandyThings": "কিছু জিনিস হাত রাখা",
    "expertTrainedTo": "বিশেষজ্ঞ প্রশিক্ষণ নিতে হয়",
    "whatIsNotIncluded": "( ১ করি.",
    "companionshipIncludesConversation": "বন্ধুত্বপূর্ণ কথাবার্তা এবং মেলামেশা",
    "companionshipIncludesActivities": "পাঠ, খেলা অথবা সংগীতের জন্য হালকা কাজকর্মের কোম্পানি",
    "companionshipIncludesWalk": "একটি নিরাপদ এবং কাছাকাছি কাছাকাছি এলাকায় একটি ছোট হাঁটার জন্য সাজানো",
    "companionshipIncludesRoutine": "রোজকার রুটিন এবং নির্ধারিত কাজের জন্য পরামর্শ",
    "companionshipIncludesFamilyUpdate": "নির্ধারিত সময়ের পরে পরিবারের জন্য একটি মৌলিক সার্ভিস আপডেট",
    "companionshipExcludesMedicalCare": "চিকিৎসা সেবা, নার্সিং, চিকিৎসা সংক্রান্ত যত্ন",
    "companionshipExcludesMedication": "ওষুধ, ইঞ্জেকশন অথবা চিকিৎসা সংক্রান্ত সিদ্ধান্ত নেওয়া",
    "companionshipExcludesPersonalCare": "গোসল, টয়লেট করা, খাওয়ানো, দেখাশোনা করা অথবা ব্যক্তিগত সাহায্য",
    "companionshipExcludesMobility": "উপরে উঠা, স্থানান্তর বা সমর্থন করার যেখানে বিপদ রয়েছে সেখানে বিপদ",
    "companionshipExcludesErrands": "আর্থিক লেনদেন, পরিবহন, কেনাকাটা, অথবা এই চুক্তির সাথে জড়িত ব্যক্তিদের পরিদর্শন",
    "companionshipExcludesEmergency": "জরুরি প্রতিক্রিয়া, রাতের যত্ন নেওয়া, অথবা ব্যক্তি ছাড়া অন্য কোথাও রেখে যাওয়া",
    "learnMore": "অারো জানুন",
    "defaultPaymentType": "PRE_PAYMENT",
    "showEarliestAvailableSlot": "প্রথম সারি দেখাও",
    "availableFrom": "বিদ্যমান{nextSlotStart}",
    "cancelBookingMessage": "হাই, আমি আমার বইিং বাতিল করতে চাই। বইয়ের ID:{bookingCode}",
    "bookingCancelMessage": "হাই টিম, আমি আমার বুকিং বাতিল করতে চাই.",
    "supportPhoneNumber": "7297970825",
    "supportWhatsAppNumber": "7297970825",
    "forAnyAssistance": "আপনার বইটি সম্পর্কে যে কোন সাহায্যের জন্য দয়া করে আমাদের HELO দলের সাথে যোগাযোগ করুন{countryCode} {phoneNumber}টেলিফোন",
    "chatWithSupportOnWhatsApp": "হোয়াটসঅ্যাপ-এ আমাদের সমর্থন টিমের সাথে কথোপকথন",
    "bookNowCTA": "বই",
    "policiesAndPermissions": "পলিসি & অনুমতি",
    "permissions": "অনুমতি",
    "showTopBanner": false,
    "showBottomBanner": true,
    "myBookings": "সাব্‌ত",
    "changeSlot": "পরিবর্তন করুন",
    "changeAddress": "ঠিকানা পরিবর্তন করুন",
    "instantServiceStartMessage": "সার্ভিস আরম্ভ করা হবে{defaultDispatchTimeMinutes}বই পড়ার পরে",
    "userConsentPopoverTitle": "এগিয়ে যাওয়ার পূর্বে",
    "userConsentPopoverPrimaryCTA": "আমি একমত",
    "consentAcknowledgedDescription": "আপনি সার্ভিস, গোপনীয়তা নীতি এবং সেবাকে নিরাপত্তার জন্য পর্যবেক্ষণ করতে রাজি হয়েছেন।",
    "userConsentMessage": "আমি সার্ভিস, গোপনীয়তা নীতি এবং নিরাপত্তা ও গুণগত উদ্দেশ্যের উপর পর্যবেক্ষণের জন্য কাজ করতে রাজি।",
    "userPreferenceMessage": "আপনার পছন্দ সংরক্ষিত রয়েছে। আপনি যে কোন সময় তাদের প্রোফাইল থেকে পরিবর্তন করতে পারেন।",
    "requiredConsentMessage": "(Required)",
    "optionalConsentMessage": "(Optional)",
    "serviceStartOTP": "সার্ভিস OTP আরম্ভ করা হবে",
    "serviceEndOTP": "সার্ভিস OTP",
    "remainingTimeLabel": "অবশিষ্ট সময়",
    "secondsRemainingLabel": "সেকেন্ড অবশিষ্ট রয়েছে",
    "serviceInProgress": "বর্তমানে চলছে",
    "serviceEndsAt": "সমাপ্ত হচ্ছে{time}",
    "userConsentTerms": [
      {
        "type": "PII",
        "label": "Personal Information",
        "description": "I agree to the processing of my personal data for booking fulfillment.",
        "default": true,
        "version": "v1.0",
        "required": true
      },
      {
        "type": "SERVICE_UPDATES",
        "label": "Service Updates",
        "description": "Receive service-related and transactional updates via SMS, WhatsApp, Email, Push notifications and RCS.",
        "default": true,
        "version": "v1.0",
        "required": true
      },
      {
        "type": "MARKETING_COMMUNICATION",
        "label": "Marketing Communication",
        "description": "Receive promotional offers, loyalty benefits and new launch updates.",
        "default": true,
        "version": "v1.0",
        "required": false
      }
    ],
    "expertText": "অভিজ্ঞ{expertName}",
    "assignedExpert": "বরাদ্দকৃত বিশেষজ্ঞ",
    "ourServices": "আমাদের সেবা",
    "showUserConsentPopup": 0,
    "bookingFailedMessage": "অপ্রত্যাশিত সমস্যার কারণে আপনার বইটি বিফল হয়েছে। যদি কোন পরিমাণ টাকা বাদ দেয়া হয়, তাহলে ৪-৫ দিনের কাজের দিনের মধ্যে একই পরিমাণ ঋণ পরিশোধ করা হবে।",
    "bookingCancellationMessage": "We apologise for the inconvenience. Your booking was cancelled due to an unexpected issue. You can expect your refund in 4–5 working days.",
    "faqs": [
      {
        "title": "কীভাবে আমি নতুন বইটা পাব?",
        "targets": [
          "helpAndSupport"
        ],
        "description": "অনলাইন থেকে সূচনাবার্তা সক্রিয় ও সক্রিয় করা হবে। নিরাপদ মোডে নতুন বইটি দেখা যাচ্ছে ।"
      },
      {
        "title": "কিভাবে আমি সার্ভিস শুরু করবো?",
        "targets": [
          "helpAndSupport"
        ],
        "description": "যখন তুমি আসবে তখন তুমি ওটিপির কাছে যাবে। শুধুমাত্র সার্ভিস শেষ করার পর OTP ব্যবহার করো ।"
      },
      {
        "title": "যদি কাস্টমার না থাকে তাহলে আমার কি করা উচিত?",
        "targets": [
          "helpAndSupport"
        ],
        "description": "কাস্টমারকে কার্ড থেকে ফোন করো. যদি তারা সাড়া না দেয়, প্রস্থানের আগে কিউইকির সাথে যোগাযোগ করুন।"
      },
      {
        "title": "আমি SOS কখন ব্যবহার করব?",
        "targets": [
          "helpAndSupport"
        ],
        "description": "বই পাঠানোর সময় এসওএস ব্যবহার করুন । আপনি হোয়াটসঅ্যাপ-এ সমর্থন বা চ্যাট করতে পারেন।"
      },
      {
        "title": "আমি কেন সতর্ক সংকেত শুনছি না?",
        "targets": [
          "helpAndSupport"
        ],
        "description": "ফোনের বৈশিষ্ট্যে কিউইকি পার্টনারের জন্য বিজ্ঞপ্তি ও শব্দের ব্যবস্থা সক্রিয় করুন এবং ব্যাটারির অপব্যবহারের বিষয়টি নিশ্চিত করুন।"
      },
      {
        "title": "বুকিং রেকর্ডিং কেমন হচ্ছে?",
        "targets": [
          "helpAndSupport"
        ],
        "description": "OTP আরম্ভ করার পরে আরম্ভ করা হয় ও OTP পরে বন্ধ করা হবে। এটা আপনার ডিভাইসের নিরাপত্তার জন্য আপনার ডিভাইসের মধ্যে সংরক্ষিত।"
      }
    ],
    "appDownloadOneLinkUrl": "https://onelink.to/ebc2zk",
    "verificationDisclaimer": "বেদনাদায়ক। ট্রেন. উপরে.",
    "prebookLookupDays": 3,
    "bookingFailedLabel": "কারণ বিফলতা",
    "bookingCancelledLabel": "তারিখের কারণ",
    "offerDetailsTitle": "বিস্তারিত বিবরণ দিন",
    "offerDetailsPromoCode": "প্রোমো কোড ব্যবহার করুন{promoCode}সার্টিফিকেটের অবকাল",
    "allowLocationAccess": "অবস্থান ব্যবহারের অনুমোদন করুন",
    "proceedToSchedule": "নির্ধারিত স্থানে এগিয়ে চলুন",
    "subCategorySectionTitle": "আমাদের সেবা থেকে নির্বাচন করুন",
    "selectCategory": "একটি শ্রেণী নির্বাচন করুন",
    "selectSubcategory": "একটি শ্রেণী নির্বাচন করুন",
    "cartSubcategoryMismatch": "শুধুমাত্র একটি উপ শ্রেণী থেকে সেবা বইতে যোগ করা যাবে।",
    "noExpertWorking": "কোন বিশেষজ্ঞ কাজ করছে না",
    "fullyBooked": "সম্পূর্ণ বই",
    "slotUnavailable": "উপলব্ধ নয়",
    "noSlotsToday": "আজকের কোনো হোস্ট নেই। অনুগ্রহ করে অন্য একটি তারিখ নির্বাচন করুন।",
    "noSlotsLater": "কোনো ইঙ্গিত উপলব্ধ নেই। অনুগ্রহপূর্বক পরে পরীক্ষা করুন।",
    "noSlotsOnDate": "কোনো ইঙ্গিত উপলব্ধ নেই{date}.",
    "nextSlotsOnDate": "পরবর্তী উপস্থিত{date}.",
    "logoutAllDevices": "সকল ডিভাইস থেকে লগ-আউট করুন",
    "confirmLogoutAllDevices": "ডিভাইসটি অথবা সকল ডিভাইস থেকে লগ-আউট করার উদ্দেশ্যে এই ডিভাইসটি নির্বাচন করুন।",
    "servicesTitle": "পরিসেবা",
    "viewBookingDetails": "বিস্তারিত বিবরণ দেখুন",
    "languageCode": "en",
    "languageName": "ইংরেজি",
    "appMaxInactiveTimeToReloadInMNS": 30,
    "expertBookingPollingTime": 30000,
    "expertBookingBackgroundPollingTime": 10000,
    "expertBookingPendingPollingTime": 60000,
    "expertBookingMaxPollingTime": 300000,
    "expertBookingPollingJitterRatio": 0.1,
    "partnerWebViewScale": 1,
    "bookingReminderIntervalInSeconds": 10,
    "bookingReminderIntervalInMinutes": 1,
    "partnerServiceOtpLength": 4,
    "partnerKioskModeEnabled": true,
    "partnerKioskUseLockTaskMode": true,
    "partnerKioskAllowedPackages": [
      "com.whatsapp",
      "com.whatsapp.w4b",
      "com.google.android.apps.maps",
      "com.google.android.dialer",
      "com.android.dialer",
      "com.android.server.telecom",
      "com.android.incallui",
      "com.samsung.android.dialer",
      "com.samsung.android.incallui"
    ],
    "supportCallTitle": "কল সমর্থন",
    "supportCallDescription": "আমাদের সমর্থন টিমের সাথে কথা বলুন।",
    "supportWhatsAppTitle": "হোয়াটসঅ্যাপ-এ আলাপনName",
    "supportWhatsAppDescription": "সাধারণত কয়েক মিনিটের মধ্যে উত্তর দেয়",
    "supportEmailTitle": "ই-মেইল সমর্থন",
    "supportEmailDescription": "নগন্য প্রশ্ন এবং নথির জন্য",
    "faqHeading": "সাধারণ প্রশ্নোত্তর",
    "updateNameTitle": "আপডেট করার নাম",
    "updateEmailTitle": "ই-মেইল আপডেট করুন",
    "addEmailTitle": "ই-মেইল যোগ করুন",
    "enterNamePlaceholder": "নাম লিখুন",
    "enterEmailPlaceholder": "ই-মেইল লিখুন",
    "statusOnline": "অন-লাইন",
    "statusOffline": "অফ-লাইন",
    "statusBreak": "বিরতি",
    "bookingHistoryTitle": "পূর্ববর্তী তথ্য",
    "completedBookingsTitle": "সমাপ্তির তারিখ",
    "completedBookingsSubtitle": "( হিতো.",
    "rateBookingExperienceCTA": "বুকিংয়ের অভিজ্ঞতা রেট করুন",
    "additionalServicesCount": "+{count} আরও",
    "bookingDetailsTitle": "বুকিংয়ের বিস্তারিত",
    "bookingDetailsLoadErrorTitle": "বুকিংয়ের বিস্তারিত লোড করা যায়নি",
    "bookingDetailsFeedbackDescription": "এই সম্পন্ন বুকিং সম্পর্কে আপনার মতামত জানান।",
    "loadingFeedbackText": "মতামত লোড হচ্ছে…",
    "bookingInformationTitle": "বুকিংয়ের তথ্য",
    "createdLabel": "তৈরি হয়েছে",
    "slotEndsLabel": "স্লট শেষ",
    "serviceTrackingTitle": "পরিষেবা ট্র্যাকিং",
    "serviceStartTimeLabel": "পরিষেবা শুরুর সময়",
    "expectedEndTimeLabel": "প্রত্যাশিত শেষ সময়",
    "serviceEndTimeLabel": "পরিষেবা শেষের সময়",
    "sessionStatusLabel": "পরিষেবার অবস্থা",
    "partnerBookingFeedbackTitle": "বুকিংয়ের অভিজ্ঞতা রেট করুন",
    "partnerBookingFeedbackDescription": "{customerName}-এর সঙ্গে আপনার অভিজ্ঞতা জানান",
    "bookingFeedbackThanksTitle": "আপনার মতামতের জন্য ধন্যবাদ",
    "bookingFeedbackAlreadyProvidedTitle": "মতামত ইতিমধ্যে দেওয়া হয়েছে",
    "bookingFeedbackAlreadyProvidedText": "আপনি এই বুকিংয়ের জন্য ইতিমধ্যে মতামত দিয়েছেন।",
    "partnerFeedbackSuccessText": "আপনার মতামত আমাদের প্রতিটি বুকিংয়ের অভিজ্ঞতা উন্নত করতে সাহায্য করে।",
    "doneCTA": "ঠিক আছে",
    "submittingFeedbackText": "জমা দেওয়া হচ্ছে…",
    "ratingAriaLabel": "বুকিং রেটিং",
    "starRatingAriaLabel": "৫-এর মধ্যে {value} স্টার",
    "tapStarRatingPrompt": "বুকিং রেট করতে একটি স্টার বেছে নিন",
    "loadingFeedbackOptionsText": "বিকল্প লোড হচ্ছে…",
    "bookingFeedbackOptionsError": "মতামতের বিকল্প লোড করা যায়নি। আবার চেষ্টা করুন।",
    "bookingFeedbackSubmitError": "মতামত জমা দেওয়া যায়নি। আবার চেষ্টা করুন।",
    "feedbackCommentsLabel": "অতিরিক্ত মন্তব্য (ঐচ্ছিক)",
    "feedbackCommentsPlaceholder": "সহায়ক কোনো তথ্য জানান",
    "partnerRatingHeading1": "দুঃখিত—কী সমস্যা হয়েছে জানান",
    "partnerRatingHeading2": "আরও ভালো করতে আমাদের সাহায্য করুন",
    "partnerRatingHeading3": "আমরা কী উন্নত করতে পারি?",
    "partnerRatingHeading4": "অভিজ্ঞতা ভালো হয়েছে জেনে আনন্দিত",
    "partnerRatingHeading5": "চমৎকার—আপনার অভিজ্ঞতা জানান",
    "bookingsLoadErrorTitle": "বই লোড করা যায়নি",
    "bookingsLoadErrorDescription": "আপনার ইন্টারনেট সংযোগ পরীক্ষা করে পুনরায় প্রচেষ্টা করুন।",
    "retryCTA": "পুনরায় প্রচেষ্টা করুন",
    "loadingText": "লোড করা হচ্ছে...",
    "unavailableText": "উপলব্ধ নেই",
    "addressUnavailableText": "ঠিকানা উপলব্ধ নয়",
    "statusUnavailableText": "পাওয়া যাচ্ছে না",
    "customerFallback": "গ্রাহক",
    "serviceFallback": "পরিসেবা",
    "serviceDetailsTitle": "পরিসেবার বিবরণ",
    "serviceQuantityValue": "ক্ষমতা:{quantity}",
    "serviceDurationValue": "{minutes}মিনিট",
    "completedStatus": "Completed",
    "cancelledStatus": "Cancelled",
    "rejectedStatus": "Rejected",
    "completeProfileTitle": "আপনার প্রোফাইল সম্পন্ন হয়েছে",
    "mobileUnavailableText": "মোবাইল নম্বর উপলব্ধ নেই",
    "personalInformationTitle": "ব্যক্তিগত তথ্য",
    "personalInformationDescription": "সঠিক তথ্য পাঠের জন্য সাহায্য",
    "noRatingsYet": "এখনও কোনো রেটিং নেই",
    "totalRatingsValue": "{count}টি রেটিং",
    "serviceTimingsTitle": "পরিসেবার সময়",
    "shiftTimingsTitle": "টিমল্যান্ডিং",
    "todayShiftLabel": "আজকের পরিবর্তন",
    "todayShiftDescription": "আজকের শিফট নীচের বেগুনি সীমানায় তুলে ধরা হয়েছে।",
    "shiftTimingsUnavailableTitle": "সময় উপলব্ধ নয়",
    "shiftTimingsUnavailableDescription": "তোমার শিডিউল এখানে এসে পড়বে... ...যখন এটা দেয়া হবে.",
    "serviceTimingsDescription": "আপনি প্রতিটা কাজের জন্য সাপ্তাহিক শিফট পরিবর্তন করেন ।",
    "serviceHoodLabel": "বরাদ্দকৃত কাজের ক্ষেত্র",
    "assignedHoodFallback": "কর্মস্থলের ক্ষেত্র{number}",
    "onLeaveLabel": "সাপ্তাহিক ছুটি",
    "mondayShort": "মন",
    "tuesdayShort": "মঙ্গল",
    "wednesdayShort": "অস্বীকৃত",
    "thursdayShort": "বৃহঃ",
    "fridayShort": "ফ্রিসেল",
    "saturdayShort": "শনি",
    "sundayShort": "রবি",
    "bookingAcceptedTitle": "বই গ্রহণ করা হয়েছে",
    "bookingAcceptedSubtitle": "বুকিং গৃহীত. প্লিজ, জলদি আসো।",
    "bookingInfoTitle": "বই সংক্রান্ত তথ্য",
    "bookingTimeLabel": "বইয়ের সময়",
    "closeMapCta": "ম্যাপ",
    "confirmed": "নিশ্চায়ণ:",
    "customerNameLabel": "গ্রাহক",
    "doa": "বার্ষিকী:",
    "forTodayLabel": "আজকের জন্য",
    "gotIt": "বুঝেছি",
    "invalidOtpMessage": "একটি বৈধ OTP লিখুন",
    "lastUpdated": "সর্বশেষ আপডেট",
    "myRewardsLink": "আমার সবর",
    "newBookingLabel": "নতুন ঠিকানাবই",
    "noBookingMessage": "এই মুহূর্তে কোনো সক্রিয় করা হয়নি",
    "noBookingsDescription": "নতুন বই এখানে দেখা যাবে।",
    "noBookingsTitle": "কোনো বই পাওয়া যায়নি",
    "openInGoogleMaps": "গুগল ম্যাপে খুলুন",
    "policies": "নীতি",
    "punchInLabel": "পিঞ্চিন",
    "refresh": "নতুন করে প্রদর্শন",
    "secondsLabel": "সেকেন্ড",
    "selectCityManually": "স্বয়ং নির্বাচন করুন",
    "selectLocationManually": "নিজ হাতে নির্বাচন করুন",
    "serviceDate": "পরিসেবার তারিখ",
    "serviceLocation": "পরিসেবাের অবস্থান",
    "slotTime": "সময়",
    "stopped": "বন্ধ",
    "timeElapsedLabel": "অতিবাহিত সময়",
    "unattended": "অংশগ্রহণকারীবৃন্দ",
    "viewAddressInMap": "মানচিত্রের মধ্যে ঠিকানা প্রদর্শন করা হবে ( n)",
    "viewMapRoute": "পথ দেখুন",
    "todaysBookingTitle": "আজকের বই",
    "bookingInProgressTitle": "মুছে ফেলা হচ্ছে",
    "bookingCompletedTitle": "বই সম্পূর্ণ হয়েছে",
    "partnerBookingCompletedDescription": "পরিষেবাটি সফলভাবে সম্পন্ন হয়েছে।",
    "partnerBookingConfirmedDescription": "বুকিং নিশ্চিত হয়েছে এবং পরিষেবার জন্য প্রস্তুত।",
    "partnerBookingInProgressDescription": "পরিষেবাটি বর্তমানে চলছে।",
    "partnerBookingCancelledDescription": "এই বুকিংটি আর সক্রিয় নেই।",
    "customerPhoneLabel": "গ্রাহক ফোন নম্বর",
    "startServiceCta": "পরিসেবা আরম্ভ করা হবে",
    "endServiceCta": "পরিসেবা বন্ধ করা হবে",
    "startServiceOtpSubtitle": "ওটিপির গ্রাহককে অনুরোধ করো সেবা শুরু করার জন্য।",
    "endServiceOtpSubtitle": "সেবা সম্পূর্ণ করার জন্য ওটিপির গ্রাহককে জিজ্ঞাসা করুন।",
    "enterOtp": "OTP লিখুন",
    "enterOtpPlaceholder": "OTP পরিসেবা লিখুন",
    "minutesRemainingValue": "{minutes}মিনিট",
    "hoursRemainingValue": "{hours}লাহর",
    "serviceEndsInLabel": "সার্ভিস শেষে বিদ্যমান",
    "supportUnavailableMessage": "বর্তমানে উপলব্ধ নয় ।",
    "sosWhatsAppMessage": "এসওএস: আমার কিউউইকি পার্টনার বুকিং এর জরুরি সাহায্য দরকার।",
    "sosSupportTitle": "পরিচিতির সমর্থন",
    "sosSupportDescription": "আপনি কিভাবে কিউউইকি সাপোর্ট দলের সাথে যোগাযোগ করতে চান তা বেছে নিন ।",
    "sosChatCta": "হোয়াটসঅ্যাপ-এ আলাপনName",
    "sosCallCta": "কল সমর্থন",
    "partnerLocationTitle": "আপনার অবস্থান পরিবর্তন করুন",
    "partnerLocationDescription": "অবস্থান পরিচালনা আর সার্ভিস যাচাইে সাহায্য করে। বই পড়া এবং সতর্ক থাকাও চলবে যখন এটা বন্ধ হয়ে যাবে।",
    "partnerLocationEnable": "অবস্থান পরিবর্তন করুন",
    "partnerLocationOpenSettings": "অবস্থান খুলুন",
    "partnerLocationChecking": "অবস্থান পরীক্ষা করা হচ্ছে...",
    "partnerServiceAreaLabel": "আপনার পরিষেবা এলাকা",
    "partnerLocationUnavailable": "পরিষেবা এলাকা দেখতে অবস্থান চালু করুন",
    "searchByBillPlaceholder": "বিলের সংখ্যা অনুযায়ী অনুসন্ধান করুন",
    "instantServiceLabel": "ইনস্ট্যান্ট পরিসেবা"
  },
  en: {
    home: "Home",
    navHome: "Home",
    navBookings: "Bookings",
    navAccount: "Account",
    rewardClub: "Reward Club",
    getGuestMobileNumber: `To register, Please provide your Mobile number`,
    enterNumberToLogin: "Please enter your Mobile number",
    rewardCondition: "I agree to receive information, offers from Qwiky",
    verifyMobileNumber: "Verify Mobile number",
    recoverMobileNumber: "Recover Mobile number",
    enterOtpSentOn: "Enter OTP sent on {phoneNumber}",
    invalidPhoneNumberMessage: "Please enter a valid mobile no.",
    tncError: "Please agree to Terms & Conditions to proceed.",
    emptyOtpMessage: "Please enter otp",
    guestProfile: "User Profile",
    provideDetails: "Please provide your details",
    provideMissingDetails:
      "One Last thing, please provide these details to proceed",
    provideDetailsForNewUser:
      "To Join our Rewards club,{br}Please provide  following details",
    notProvided: "Not Provided",
    nameFieldLabel: "Name",
    phoneNumberLabel: "OTP will be sent for verification",
    emailFieldLabel: "Email id",
    birthDateFieldLabel: "Date of birth",
    anniversaryDateFieldLabel: "Marriage Anniversary",
    birthdayReward:
      "Your birthday is special for us too. {br} Get an exciting reward for your birthday month",
    anniversaryReward:
      "Elevate your anniversary celebration with us! {br} Enjoy a special reward to make your marriage anniversary unforgettable",
    birthDayAndAnniversaryReward:
      "Your special days are special for us too. {br} Get a special reward for your Birthday & Anniversary",
    hello: "Hello",
    selectOutlet: "Please select the outlet(s) where you visit more often",
    invalidNameMessage: "Please enter a valid name",
    invalidEmailMessage: "Please enter a valid email",
    invalidDate: "Please enter a valid date",
    invalidDateOfBirthMessage: "Please enter a valid date",
    invalidDateOfAnniversaryMessage: "Please enter a valid date",
    perferredOutletError: "Please select your favourite outlet.",
    emptyOutletList: "No Outlet Found!",
    getStartedCTAText: "GET STARTED",
    proceedCTAText: "PROCEED",
    signupCTAText: "SIGN UP",
    loginCTAText: "LOGIN",
    recoverAccountCTAText: "RECOVER ACCOUNT",
    doneCTAText: "DONE",
    guestUserNameText: "Guest User",
    continueAsGuestText: "Continue as Guest",
    saveCTAText: "SAVE",
    updateCTAText: "UPDATE",
    resendOtp: "Resend OTP",
    locations: "Locations",
    locationDetail: "Location Detail",
    getDirection: "GET DIRECTION",
    call: "CALL",
    today: "Today",
    languageSettingTitle: "Language",
    languageSettingDescription: "Choose your app language",
    hindiLanguage: "हिंदी",
    englishLanguage: "English",
    changeLanguageLabel: "Change language",
    selectLanguageTitle: "Select a language",
    languageOptions: [
      { code: "hi", label: "हिंदी", compactLabel: "हि", englishLabel: "Hindi", symbol: "अ" },
      { code: "en", label: "English", compactLabel: "EN", englishLabel: "English", symbol: "A" },
      { code: "bn", label: "বাংলা", compactLabel: "বা", englishLabel: "Bengali", symbol: "ব" },
    ],
    slotLabel: "{date}, {timeRange}",
    "use-card-balance": "Use {outletCashCardTitle} balance",
    "recharge-card-balance": "Recharge {outletCashCardTitle}",
    "card-name": "{outletCashCardTitle}",
    closed: "Closed",
    errorInfo: {
      OTP_INVALID: {
        title: "OTP not verified",
        message: "It seems like you’ve entered a wrong otp.",
      },
      USER_BLOCKED: {
        title: "User access denied",
        message:
          "Your account has been temporarily suspended by the administration. Please contact support@qwiky.in for any help.",
      },
    },
    rewardsClubText: "Rewards Club",
    rewardProgramDescription:
      "A rewards club that is all about you. Some pep talk about the rewards program that goes into multiple lines covering about 50 words.",
    getAppRewardsClubDescriptionText1: "Earn points for every rupee spent",
    getAppRewardsClubDescriptionText2: "Redeem points for exciting rewards",
    getAppDownloadRewardsClubAppText: "Download app to join Rewards Club",
    getAppRewardClubBenefits: "Benefits of Rewards Club",
    getAppRewardClubOtherBenefits: "Other Benefits",
    rewardsText: "Rewards",
    couponsText: "Old Coupons",
    rewardsDetailsText: "Reward Details",
    name: "Name",
    emailId: "Email id",
    mobileNo: "Mobile no.",
    dob: "Date of Birth",
    dateOfBirthAddedToast: "Date of Birth Added!",
    dateOfAnniversaryAddedToast: "Anniversary Added!",
    notification: "Notifications",
    appNotification: "App notification",
    sms: "SMS",
    whatsapp: "Whatsapp",
    email: "Email",
    rewardPointHistory: "Reward Points History",
    history: "History",
    rewardProgram: "Rewards Program",
    settings: "Settings",
    profile: "Profile",
    shareThisApp: "Share this app",
    followUsOn: "FOLLOW US ON",
    logOut: "Log out",
    login: "Log in",
    logoutText: "Logout",
    confirmLogoutMessage: "Are you sure you want to log out?",
    deleteAccount: "Delete Account",
    pointEarned: "Points Earned",
    pointAdjusted: "Points Adjusted",
    appPermissions: "App Permissions",
    communication: "Communication",
    preferredChannelText: "Preferred channels for receiving marketing messages",
    offersText: "Offers",
    getCouponCTA: "GET COUPON",
    noBrandDealDescription: "Seems like there are no offers at the moment",
    noBrandRewardDescription: "Seems like there are no rewards at the moment",
    howThisWorks: "How this works",
    howItWorks: "How it Works",
    getCouponOnSubscribe: "You’ll get a Coupon code on collecting this reward",
    showCouponBeforeOrder:
      "Visit the restaurant and show the coupon code before placing your order",
    redeemCouponAtBillGeneration:
      "The restaurant will redeem your coupon at the time of bill generation",
    offerDetailsText: "Offer Details",
    applicableForNewCustomers: "Applicable for first time customers",
    maximumDiscountText: "Maximum discount ₹{maxValue}",
    alreadyHaveCoupon: "You already have a coupon code",
    visitRestaurantToReedem: "Visit restaurant to redeem",
    useCouponOnNextOrder: "Use this coupon on your next order",
    instantDealText: "Instant Deal",
    viewDetailsText: "VIEW DETAILS",
    couponStreakText: "Coupon Streak",
    couponApplicableOn: "Coupon Applicable on",
    viewOnMap: "VIEW ON MAP",
    redeemedCouponAndSavedText:
      "You have redeemed this coupon and saved {symbol}{discountAmount}",
    redeemedCouponAndAvailedText:
      "You have redeemed this coupon and availed Free {applicableItem}",
    locked: "Locked",
    unlockCouponAfterText: "Unlock this coupon code after {orderCount} Order",
    redeemed: "Redeemed",
    expired: "Expired",
    rewardExpiredOnText: "Reward expired on {expiredDate}",
    willUnlockOnText: "This coupon will unlock on {unlockDate}",
    couponCodeLocked: "Coupon Code Locked",
    showCouponToAvail: "Show this coupon code to avail offer",
    yourCouponCode: "Your Coupon Code",
    goToRewardsPageCTA: "GO TO REWARDS PAGE",
    couponAdded: "Coupon added in Claimed Rewards",
    howToRedeem: " How to Redeem Coupon",
    visitRestaurantShowCoupon:
      "Visit the restaurant and show the coupon code before placing your order",
    restaurantWillRedeem:
      "The restaurant will redeem your coupon and provide applicable {offerType}",
    deleteYourAccount: "Delete your Account",
    areYouSure: "Are you sure?",
    allInformationWillBeLost:
      "All information related to your account will be lost forever.",
    otpSent: "OTP Sent",
    resendOtpCaps: "RESEND OTP",
    points: "POINTS",
    rewardPointsText: "R E W A R D {br} P O I N T S",
    rewardPointsSpentDescription: "{rewardPoints} {currencyName} available",
    unlockRewardMilestoreDescription:
      "Unlock reward on reaching {pointPrice} points",
    viewOldCoupons: "VIEW OLD COUPONS",
    viewMoreText: "VIEW MORE",
    myRewards: "My Rewards",
    myRewardsDescription: "Redeem your collected rewards on next order",
    noRewardsText: "No rewards at the moment",
    redeemableRewardsText: "All your redeemable rewards will be shown here",
    excitingOffers: "Exciting Offers",
    excitingOffersDescription:
      "We have some exciting offers for your next visit. It's for limited time, grab your coupon before it ends.",
    pointsRedeemed: "Points Redeemed",
    pointsUsed: "Points Used",
    pointsEarnedForSpending: "Amount spent {currencySymbol} {netAmount}",
    claimedReward: "Collected Reward - {sourceName}",
    noDataToShow: "No Data to show",
    viewRewards: "VIEW REWARDS",
    claimRewards: "COLLECT REWARDS",
    loginCTA: "LOGIN",
    loginRequiredTitle: "Login Required",
    viewOffers: "VIEW OFFERS",
    dealRedeemedPopupTitle: "Coupon already Redeemed",
    dealRedeemedPopupDescription:
      "Hi {username},{br}  You’ve already redeemed the coupon on {redeemDate}  and got discount of {amount}. We’ve a coupon you might be interested in.",
    dealAlreadyRedeemedItemFreeDescription:
      "Hi {username},{br} You’ve already redeemed the coupon on {redeemDate} and availed free item. We’ve a coupon you might be interested in.",
    dealAlreadySubscribedDescription:
      "Hi {username},{br} You’ve already claimed this coupon on {subscribedDate}. Please check Claimed Rewards section to view coupon code",
    lastUpdatedText: "Last updated",
    redeemOn: "Redeemed on {redeemTime}",
    expiredOn: `Expired on {expireTime}`,
    validTill: "Valid till {expireTime}",
    validFromTo: "Valid from {redeemableTime} - {expireTime}",
    validFrom: "Valid from {redeemableTime}",
    validOn: "Valid on {time}",
    added: "Added",
    deducted: "Deducted",
    pointsText: "Points",
    actionText: "Action",
    activityDetails: "Activity Details",
    dateAndTime: "Date & Time",
    billNo: "Bill no.",
    billAmount: "Bill Amount",
    outlet: "Outlet",
    claimedRewardText: "Claimed {br} Reward",
    earnPointOneSpend: "Earn point on every spend",
    earnPoints: "Earn Points",
    unlockRewards: "Unlock & Claim Rewards",
    unlockRewardsPromotion: "Unlock Rewards",
    redeem: "Redeem",
    redeemEarnedRewardsOnNextVisit:
      "Show the coupon code and Redeem your collected rewards on your next visit.",
    redeemEarnedRewardsOnNextVisitPromotion:
      "Redeem your earned rewards on your next visit.",
    getBirthdayRewards: "Get Birthday Rewards",
    getAnniversaryRewards: "Get Anniversary Rewards",
    addBirthday: "Add Birthday",
    addAnniversary: "Add Anniversary",
    manyMoreOffers: "Many more Offers",
    reasonToVisitUsAgain:
      "We make sure that you always have a reason to visit us again.",
    birthdayRewardCardTitle: "Get Exciting Reward for your Birthday Month",
    anniversaryRewardCardTitle:
      "Get Exciting Reward for your Anniversary Month",
    birthdayProvidedInfo:
      "Thanks for Providing your Birthday. {br}To view your Birthday Rewards go to {br}More > Rewards Program",
    anniversaryProvidedInfo:
      "Thanks for Providing your Anniversary Date. {br}To view your Anniversary Rewards go to {br}More > Rewards Program",
    claimBirthdayRewardText: "Birthday Reward",
    claimAnniversaryRewardText: "Anniversary Reward",
    birthdayRewardsText: "Birthday Rewards",
    welcomeRewardText: "Welcome Reward",
    welcomeRewardDescription: "Your reward is just a tap away",
    redeemRewardPointsText: "Collect Reward with {currencyName}",
    pointsAvailable: "{rewardPoints} {currencyName} available",
    birthdayRewardsTitle:
      "Choose from a variety of rewards for your birthday month",
    birthdayRewardDetails: "Birthday Reward Details",
    claimCTAText: "Claim it",
    birthdayRewardAvailableDate: "Available from {startDate} - {endDate}",
    anniversaryRewardAvailableDate: "Available from {startDate} - {endDate}",
    active: "Active",
    noActiveRewardText: "No Active Rewards at the moment",
    noInactiveRewardText: "No Redeemed / Expired Rewards at the moment",
    redeemedOrExpired: "Redeemed / Expired",
    greeterContent: "Glad to have you back",
    notTakenRewards: `You'e not taken any Rewards yet`,
    invalidOTPMessage: "The OTP you have entered is incorrect",
    showThisCodeToRedeem: "Redeem this coupon{br} on your next order",
    cretingSomethingExciting:
      "We’re creating something exciting !!! {br} Please check back later",
    swipeToClaimReward: "Swipe to Collect",
    joinRewardClubLink: "Not a member yet? {joinRewardsClub}",
    joinRewardsClub: "Join Reward Club",
    alreadyAMember: "Already a Member? {login}",
    welcomeRewardsText: "Welcome Rewards",
    welcomeRewardDetails: "Welcome Reward Details",
    welcomeRewardsTitle: "Choose from a variety of rewards",
    anniversaryRewardsText: "Anniversary Rewards",
    anniversaryRewardDetails: "Anniversary Reward Details",
    anniversaryRewardsTitle:
      "Choose from a variety of rewards for your anniversary month",
    claimRewardCTAText: "Collect Reward",
    greetingSubtitle: " ",
    greetingTitle: " ",
    joiningRewardText: "Joining Reward",
    joiningReward:
      "We know how to welcome our guests. Get a special reward for joining Rewards Club.",
    accountAlreadyExists: "Account exists. Please log in.",
    accountNotExists: "Account doesn't exists. Please signup",
    welcomeOnboard: "Welcome Onboard,{br} {name}",
    viewOtherBenefits: "View Other Benefits",
    collectPoint: "Collect {earn} point for every {unit} {spend} spent.",
    collectPointWithCurrency:
      "Collect {earn} {currencyName} for every {unit} {spend} spent.",
    collectPointInPer: "Earn {earn}{unit} of bill value as {currencyName}",
    collectPointWithFixedAndMinSpend:
      "Earn {earn} points on every order with minimum order of {minSpend}",
    collectPointinFixed:
      "Earn {earn} points on every order with no minimum order value",
    collectMaxPointInPer:
      "Earn upto {earn}{unit} of bill value as {currencyName}",
    earnPointOnSelectedItems:
      "Earn {earn} {currencyName} every time you purchase {tag}",
    spendAndEarnPoint:
      "Every time you spend, you collect points. {unit} {spend} spent = {earn} point.",
    minRedeemPoints:
      "On reaching {minRedeemPrice} points, you get to choose from a variety of rewards. Collect reward of your choice.",
    minRedeemPointsPromotion:
      "On reaching {minRedeemPrice} points, you get to choose from a variety of rewards.",
    unlockRewardOn: "Unlock rewards on reaching {minRedeemPrice} points.",
    useEarnPoints: "Use earned points on your next order",
    useEarnPointsWithCurrency: "Pay for your order with {currencyName}",
    userEarnPointInPer:
      "Use these coins to pay upto {spend}{unit} of your bill",
    okGotIt: "Ok, got it",
    knowMore: "Know more",
    dealSubscribedPopupTitle: "Coupon already Claimed",
    rewardApplicableOn: "Coupon Applicable On",
    nearbyOutlets: "Nearby Outlets",
    limitedOutletCouponTnC:
      "Coupon applicable on limited outlets. Please see the below list",
    singleUseCouponTnC: "This is a Single use coupon",
    offerNotClubbedCouponTnC:
      "This offer cannot be clubbed with any other offer",
    redemptionCouponTnC: "Redemption of coupon is at restaurant discretion",
    minimumOrderValueCouponTnC:
      "Minimum order amount of {currencySymbol}{minOrderValue}. It should be exclusive of taxes and other charges.",
    newlyLaunchedOutlets: "Newly Launched Outlets",
    limitedOutletCouponTnC2: "Coupon applicable on limited outlets.",
    nextOfferActivateCouponTnC:
      "Next offer will be activated after {couponApplicableAfter} of previous coupon redemption.",
    maximumDiscountCouponTnC:
      "Maximum discount {currencySymbol}{maxValue} per order",
    orderModeApplicabilityCouponTnC: "Only applicable on {orderModes} orders",
    getOffer: "Get {offer}",
    limitedTimeOffersText: "Limited Time Offers",
    appUpdateTitle: "{brandName} app needs an update",
    appUpdateDescription:
      "To use this app, you need to update this app to the latest version.",
    appUpdatePrimaryCTA: "UPDATE",
    recentlyVisitedOutlets: "Recently Visited",
    orderTitle: "Order",
    yourOrder: "Your Order",
    coupons: "Coupons",
    promoCode: "Promo Code",
    coins: "Coins",
    additionalDetails: "Additional Details",
    proceedToPayCTAText: "Proceed To Pay",
    selectDeliveryLocation: "Select Delivery Location",
    cartHeaderTitle: "Cart",
    itemTotalText: "Item Total",
    discountText: "Discount",
    additionalDiscount: "Additional Discount",
    freeItemText: "Free Item",
    taxesText: "Taxes",
    toPayText: "To Pay",
    amountText: "{currencySymbol}{amount}",
    discountAmountText: "- {currencySymbol}{amount}",
    offerItemText: "Offer Item",
    offerItemsText: "Offer Items",
    freeText: "FREE",
    userAccessBlocked: "User access blocked",
    gotToHomeCTA: "GO TO HOME",
    userAccessBlockedDescription:
      "This reward cannot be collected. {br} Mobile number associated with this account has been blocked by administration.",
    mobileNumberBlocked: "This mobile no. is blocked by administration.",
    offerCollectedMultipleTimes:
      "This offer can be collected {perGuestMax} times.",
    offerAlreadyRedeemedMultipleTimes:
      "You’ve already redeemed this offer multiple times, please go to More > History to view details",
    addAmountToApplyCoupon: "Add Rs {amount} more to apply this coupon",
    orderPlaced: "Order Placed",
    orderConfirmed: "Order Confirmed",
    orderPartiallyConfirmed: "Order Partially Confirmed",
    viewCancelledItems: "View Cancelled items",
    orderId: "Order ID",
    orderNo: "Order no.",
    dateTime: "Date & Time",
    discount: "Discount",
    total: "Total",
    orderDetails: "Order Details",
    paymentDetails: "Payment Details",
    refundDetails: "Refund Details",
    applyRewardCoupon: "Apply Coupon / {currencyName}",
    applyCouponText: "Apply Coupon",
    emptyMenuListPlaceholder:
      "No results match with the search criteria. Please clear the search to view the menu.",
    emptyApplicableMenuListPlaceholder: "No items are available at the moment.",
    tableNumber: "Table {number}",
    scanQrCode: "Scan {br} QR code",
    outletReadMode: "We are not accepting online orders at the moment",
    outletDeactiveMode: "We are not accepting online orders at the moment",
    outletClosedMode: "We are closed for the day",
    outletNotOpenMode: "We are not yet open for the day",
    notAcceptionOrdersText:
      "We are not accepting {serviceType} orders at the moment",
    accountDeletionStarted: "Account Deletion Started",
    recoverAccountText:
      "If you wish to recover your account, simply tap the Recover button and follow the steps to verify with OTP. For any help, contact us at support@qwiky.in.",
    outOfRestaurantScopeErrorDescription:
      "Seems like this QR doesn’t belong to {brandId}.{br} Please scan a valid {brandId}’s QR code.",
    aboutUs: "About Us",
    orders: "Orders",
    menu: "Menu",
    recommended: "Recommended",
    cameraAccessError: "Seems like camera access is blocked",
    enterManualCode: "Please enter the restaurant code mentioned below QR code",
    scanQRCodeText: "Scan QR code to order",
    undetectScanCode: "Not able to Scan",
    enterCodeCTA: "Enter Code",
    nonFudrQRCodeText: "Please Scan a {brandId} QR code",
    enterCodeError:
      "Incorrect restaurant code. Please check the code and retry.",
    invalidCodeError: "Please enter valid restaurant code.",
    scanCodeText: "Scan Code",
    viewMenuCTA: "View Menu",
    pickupTimePopupTitle: "Pickup Time",
    pickupTimePopupDescription:
      "Tell us about your estimated arrival time. This will help us to serve you better",
    selectCityTitle: "Select City",
    viewCartCTA: "View Cart",
    menuCategoriesTitle: "Explore Menu",
    lastUpdatedTime: "Last updated {time}",
    collectReward: "Collect Reward",
    itemDetailsTitle: "Item Details",
    pickupOrderInstruction:
      "You’ll need to pickup this order from {br} {restaurantName}",
    couponApplied: "Coupon Applied",
    itemsInCartPopupTitle: "Items in Cart",
    itemsInCartChangeOutletPopupDescription:
      "You’ll lose items in your cart if you change outlet",
    itemsInCartChangeModePopupDescription:
      "You’ll lose items in your cart if you change mode",
    changeOutletCTA: "Change Outlet",
    changeModeCTA: "Change Mode",
    collectRewardsDescription:
      "You can collect rewards by using your {currencyName}.{br} Go to Rewards page and collect rewards",
    updateAppTitle: "App Update Available",
    updateAppDescription:
      "A new version of app is available. Update now for best experience.",
    updateAppCTA: "UPDATE APP",
    selectOptional: "Optional",
    selectOne: "Select one",
    repeatCustomizationPopupTitle: "Repeat last customization?",
    getDirections: "get directions",
    orderCTA: "order",
    outletTimings: "Timings",
    multipleCustomizationsPopupTitle: "Multiple Customizations",
    multipleCustomizationsPopupCTA: "Go to cart",
    multipleCustomizationsPopupDescription:
      "This item has multiple customizations added. Proceed to cart to remove item?",
    multipleCustomizationsBogoPopupDescription:
      "This item has multiple customizations added. Remove this item from the below selected items list.",
    noOrdersToShow: "No Orders to show",
    orderingComingSoon: "Ordering Coming Soon",
    nonExistSubdomainFallbackTitle: "Unable to reach this page",
    nonExistSubdomainFallbackDescription:
      "It seems some error has occured. Please try after sometime",
    nonExistSubdomainFallbackCTA: "TRY AGAIN",
    nonVeg: "Non Veg",
    pureVeg: "Pure Veg",
    customizable: "customizable",
    orderRunning: "{count} order running",
    orderAgain: "Order Again",
    moreDetails: "More Details",
    selectOutletManuallyCTA: "Select Outlet Manually",
    locationPermissionDenialTitle:
      "Not able to determine your device location.",
    locationPermissionDenialDescriptionAndroid:
      "For best experience, Please allow access to device's location. Go to settings > {brandName} app > Allow access to location",
    locationPermissionDenialDescriptionIOS:
      "For best experience, Please allow access to device's location. Go to settings > {brandName} app > Allow access to location",
    locationPermissionDenialDescriptionBrowser:
      "For best experience, Please allow access to device's location.",
    addCTA: "ADD",
    viewCTA: "VIEW",
    earnPointsPopupTitle: "Reward Program",
    helpFaqTitle: "Help & Support",
    helpSupportTitle: "How can we help?",
    supportDescription:
      "Our support team is available every day from 7 AM to 9 PM.",
    helpSupportMail: "support@qwiky.in",
    pointsRefreshedToast: "{currencyName} updated successfully",
    pointsRefreshDelayInMS: 1000,
    refundTxnInitiated:
      "Refund of ₹{totalRefundAmount} initiated on {initiateDate}",
    refundTxnProcessed:
      "Refund of ₹{totalRefundAmount} processed on {processedDate}",
    dineInMinDistanceInMeter: 1000,
    selfPickupMinDistanceInKM: 10,
    notAtOutlet: "Not at Outlet",
    tooFarFromOutet: "Too Far From Outlet",
    outletOutOfRangeDescription:
      "Seems like you're too far from outlet. Please make sure you're ordering at the correct outlet",
    okUnderstandCTA: "OK, I UNDERSTAND",
    loaderTimeoutInMilliSeconds: 5000,
    repeatLast: "Repeat Last",
    addNew: "Add New",
    howToRedeemText: "How To Reedem",
    collectRewardOnlineInstruction:
      "Collect reward, Order from app and apply coupon on cart page",
    collectRewardOfflineInstruction:
      "Collect reward, visit the restaurant and ask restaurant to apply the coupon at the time of placing order.\nRestaurant will require your registered mobile no. to generate OTP to redeem coupon.",
    orDivider: "--OR--",
    subscribeMembershipOnlineInstruction:
      "Subscribe membership, Order from app and apply coupon on cart page",
    subscribeMembershipOfflineInstruction:
      "Subscribe membership, visit the restaurant and ask restaurant to apply the coupon at the time of placing order.\nRestaurant will require your registered mobile no. to generate OTP to redeem coupon.",
    emptyVariations: "Current selection is not available at the moment",
    streakItemSequenceTitle: "{sequence} order",
    rewardPointEarnedTextWithCurrency: `{rewardPoints} {currencyName} {br} Earned on this order`,
    rewardPointEarnedText: `{rewardPoints} {br} Earned on this order`,
    useRewardPoint: "Use {currencyName}",
    rewardPointUsed:
      "{redeemablePoints} {currencyName} will be used {br} Available - {balancePoints} points",
    availablePointToUse:
      "Available - {balancePoints} points {br} {redeemablePoints} {currencyName} will be used",
    zeroPointAvailable: "Available - {balancePoints} points",
    pointDiscountText: "Discount ({currencyName})",
    savedOnOrder: " You’ll save {currencySymbol}{amount} on this order",
    youWillSave: "You’ll save {currencySymbol}{amount}",
    rewardPointsTitle: "{currencyName}",
    okGotItCTA: "Ok, Got it",
    billAmountPaidWithPoints:
      "Redeem your earned points on your next order. {billAmount}% of the bill amount can be paid using {currencyName}",
    maxRedeemablePointsPer:
      "A maximum of {maxValue}% of the available {currencyName} can be used per order",
    maxRedeemablePoints:
      "A limit of {maxValue} {currencyName} applies to each order",
    vipPassTitle: "{vipPass}",
    vipPassSubtitle: "Choose from a variety of {vipPass}",
    vipMaxDiscount: "Max. Discount ₹{maxValue} per order",
    vipPassDetailsText: "{vipPass} Details",
    swipeToBuy: "SWIPE TO BUY",
    redeemPointOnNextOrder:
      "Redeem your earned points on your next order. {percentage}% of the bill can be paid through reward points. ",
    rewardPointToMoney: "{point} {currencyName} = {currencySymbol}{amount}",
    passDetails: "Pass Details",
    noMembershipDescription: "Seems like you’ve not taken any pass yet",
    vipPassActiveDays: "Valid for {activeDays} days",
    membershipValidity: "Valid till {membershipExpirationTime}",
    renew: "RENEW",
    membershipPuschased: "Purchased - {activationTime}",
    membershipConclulded: "Concluded - {expireTime}",
    renewMembershipText:
      "{vipPass} is expired. Renew your pass and keep enjoying the benefits again",
    membershipCouponUsed: "{totalUsed} Coupon used",
    backToHomeCTA: "Back To Home",
    stopAndBuy: "Stop Current Pass and Buy this Pass",
    buyThisPass: "Buy This Pass",
    stopAndBuyVIPDescription:
      "You’ll lose remaining benefits of your currently active {vipPass} if you buy this pass",
    vipPassBuyErrorMessage:
      "If you buy this pass, remaining benefits of your currently active {vipPass} will be stopped",
    couponRedeemedOn: "Redeemed on {expireTime}",
    couponValidity: "Valid till {expireTime}",
    noCouponToShow: "No coupons to show",
    membershipCouponPerGuestMax:
      "Pass is valid for {perGuestMax} orders upto {activeDays} days",
    recaptchaBranding:
      "This site is protected by reCAPTCHA and the Google {privacyPolicyLink} and {tncLink} apply",
    recaptchaPrivacyPolicy: "Privacy Policy",
    recaptchaTnC: "Terms & Conditions",
    savedByUsingRewardPoint:
      "You saved  ₹{amount} by using {point} {currencyName} on this order",
    rewardPoints: "Reward Points",
    loyaltyPoints: "Loyalty Points",
    redeemPoints: "Redeem Points",
    membershipAlreadySubscribedTitle: "Pass already active",
    membershipAlreadySubscribedDescription:
      "Seems like the pass you are trying to subscribe is already active for your account",
    stayHereCTA: "STAY HERE",
    passName: "Pass Name",
    purchasedOn: "Purchased on",
    validTillText: "Valid till",
    amount: "Amount",
    paymentMode: "Payment Mode",
    paymentStatus: "Payment Status",
    transactionOn: "Transaction On",
    referenceId: "Reference ID",
    refundMode: "Refund Mode",
    refundStatus: "Refund Status",
    remark: "Remark",
    initiatedOn: "Initiated on",
    processedOn: "Processed on",
    paymentFailed: "Payment Failed",
    passPaymentFailedDescription:
      "Payment for this pass has not been received. If any amount was deducted it will be refunded within 7 business days",
    updateRewardProgramTitle: "We’ve updated our {br} Rewards program",
    seeWhatsNewCTA: "SEE WHATS NEW",
    rewardPointRedeemRule:
      "Pay upto {maxEarn}{unit} of your bill with {currencyName}. {earn} {currencyName} = {currency}{spend}",
    updateRewardProgramTnC:
      "Your current Rewards Points will be converted into {currencyName}. {br} {br} All collected rewards will be available for redemption",
    unlimitedOrders: "all",
    minCartValueForPointsRedemption:
      "Minimum Order of {currencySymbol}{minOrderValue} (before tax) required {br} to apply {currencyName} on this order",
    minCartValueForPointsRedemptionRewardDetails:
      "{currencyName} can be applied on orders above {currencySymbol}{minCartValueForPointsRedemption}",
    deliveryLocation: "Delivery Location",
    selectLocation: "Select Location",
    addressDetails: "Address Details",
    deliveryLocationTitle: "Please confirm your location",
    addressLine: "House / Flat / Floor Number",
    landmark: "Apartment / Road / Area",
    addressMaxLength: 200,
    saveAs: "Save as",
    office: "Office",
    other: "Other",
    notdeliverableText: "Sorry, we’re not delivering at this location",
    selectDeliveryAddress: "Select Delivery Address",
    deleteYourAddress: "Delete Address",
    dontDelete: "DON'T DELETE",
    delete: "DELETE",
    areYouSureAddress: "Are you sure, you want to delete this address",
    placeHolderTitle: "Eg. John's Place",
    orderDelivered: "Order Delivered",
    deliverTo: "Deliver to",
    membershipExpiredTitle: "Your {vipPassTitle} Expired",
    getNewPassCTA: "Get a New Pass",
    membershipExpiredDescription:
      "Get a new pass and keep enjoying the discount",
    discountSavedUsingMembership:
      "You have used this pass {totalUsed} times and saved {currencySymbol}{totalDiscount}",
    whereYouAt: "Where you at?",
    selectBrand: "Select Brand",
    payingAtOutlet: "Paying - {outletName}",
    totalPayable: "Total Payable",
    willSaveAmount: "You’re saving {currency}{amount}",
    billPaid: "Bill Paid",
    billCanPaidWithPoints:
      "{billAmount}% of the bill can be paid with {currencyName}",
    everySpendEarnPoint:
      "For every {unit}{spend} spent,  you earn {earn} {currencyName}",
    spotlightTitle: "Spotlight",
    mapMarkerDeliveryText: "Move the pin to place accurately",
    noSavedAddressText: "No saved addresses found",
    redirectingToPG: "Redirecting to {br} Payment Gateway",
    doNotCloseApp: "Please do not close the application",
    processingPayment: "Processing Payment",
    processingPaymentDescription:
      "We are processing your payment, {br} please do not close the application",
    currentLevelTagText: "Current Level",
    tierEligibilityVisit:
      "Visit {minSpend} times within {duration} {durationUnit} to reach this level",
    tierEligibilitySpend:
      "Spend {currency}{minSpend} within {duration} {durationUnit} to reach this level",
    tierEligibilityOrder:
      "Order {minSpend} times within {duration} {durationUnit} to reach this level",
    tierEligibilityPoint:
      "Earn {minSpend} points within {duration} {durationUnit} to reach this level",
    tierProgramPromotionTNC:
      "Earn {currencyName} with every purchase and redeem them towards your bill payments. Each {currencyName} holds a value of {currency}1, allowing you to save as you spend.{br}{br}Ascend through tier levels to unlock additional perks and benefits",
    viewTierLevelsCTA: "View Tier Levels",
    additionalBenefits: "Additional Benefits",
    tierLevelsPopupTitle: "Tier Levels",
    myBenefitsTabLabel: "MY BENEFITS",
    levelTabLabel: "LEVELS",
    faqsTabLabel: "FAQS",
    enterAmountShownOnBill: "Enter amount shown on the bill",
    coinsCantBeClubbedWithCoupon:
      "{currencyName} cannot be clubbed with coupons",
    nextText: "NEXT",
    billDetails: "Bill Details",
    billCreatedOn: "Created on",
    itemBasePriceTotal: "Item Total",
    totalBillAmount: "Total Bill Amount",
    coinUsed: "Coin used",
    totalSaving: "Total Saving",
    selectOutletText: "Select Outlet",
    noOutletForSelectedCity: "No outlet for selected city",
    amountSaveOnBill: "{currency}{amount} saved on your bill",
    amountPaid: "Amount Paid",
    transactionId: "Transaction ID",
    cancelPayment: "Cancel Payment",
    exitPayEarnConfirmationMsg:
      "Are you sure you do not want to pay bill and earn {currencyName}",
    doNotPayCTA: "DO NOT PAY",
    outletSize: 100,
    earnCoinInPercentage: "Earn {earn}{unit} of bill value as {currencyName}",
    tryAgainCTA: "Try Again",
    tooFarFromOutetDescription:
      "Seems like you are too far from outlet. Please make sure you’re paying at the correct outlet",
    nearbyOutletDistanceInMeter: "20",
    annualSpend: "Annual spend {currency}{amount}",
    tierTitle: "{title} Level Benefits",
    loyaltyCardTierTitle: "{title} Level",
    applyOffersOnNextPage: "Apply coins / coupon on next page",
    swipeToPayAmount: "SWIPE TO PAY {currency}{amount}",
    termsAndConditions: "Terms & Conditions",
    inTheTier: "In the {currentTier} level,",
    coinsEarned: "{amount} {currencyName} Earned",
    transactionDetails: "Transaction Details",
    cookingRequest: "Cooking Request ",
    readOnlyMenuServiceTitle: "Pickup",
    paymentFailedDescription:
      "We are unable to process your payment. If any money was deducted it will be refunded in 2-3 business days",
    backToCartCTA: "BACK TO CART",
    paymentSuccess: "Payment Successful",
    userLocationSearchPlaceholder: "Search by locality or street name",
    allOutlets: "All Outlets",
    doNotRemove: "DO NOT REMOVE",
    remove: "Remove",
    switchRewardWarningTitle: "Applied {type} will be removed",
    switchRewardWarningDesc:
      "If you change the tab, {type} applied on your bill will be removed.",
    coinsText: "coins",
    couponText: "coupon",
    paymentProcessingInSeconds: "90",
    rewardProgramDetails: "Reward program details",
    bookTable: "Book Table",
    tableOutlet: "Choose the outlet where you want to book table",
    helpAndSupport: "Support",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    privacyPolicyAndTermsOfServiceDescription:
      "By proceeding, I agree to {brand}’s {br}{privacyPolicy} and {termsOfService}",
    privacyPolicyAndTermsOfServiceDescriptionInternal:
      "By proceeding, I agree to {brand}’s {privacyPolicy} and {termsOfService}",
    invalidGroupSizeMessage: "Please enter valid group size",
    exitTableBooking: "Exit Table Booking?",
    dontWantToBookTable: "Are you sure you do not want to book a table?",
    dontBookTableCTA: "DONT BOOK TABLE",
    bookingForLargeParty: "Booking for Large Party?",
    giveUsCallForLargeParties:
      "Please give us a call for booking for large parties. This will help us to provide you a better experience",
    bookedSlotWillbeCancelled:
      "If you cancel your booking, your booked slot will be cancelled.",
    cancelBooking: "CANCEL BOOKING",
    dontCancel: "DON’T CANCEL",
    guests: "Guests",
    whenAreYouVisiting: "When are you visiting?",
    noSlotsAvailable: "No slots available",
    customCaps: "CUSTOM",
    callOutlet: "Call Outlet",
    callOutletCaps: "CALL OUTLET",
    forLargeParties: "For Large Parties",
    tableBooked: "Table Booked",
    bookingCancelled: "Booking Cancelled",
    forGroupSize: "For {groupSize}",
    payAndEarn: "Pay & Earn",
    bookingDetails: "Booking Details",
    bookings: "Bookings",
    addOnMinSelection: "Required | Select any {minSelection} option",
    addOnMinSelectionMultiple: "Required | Select any {minSelection} options",
    addOnMinAndMaxSelection:
      "Required | Select any {minSelection} to {maxSelection} options",
    addOnMaxSelection: "Optional | Select upto {maxSelection} option",
    addOnMaxSelectionMultiple: "Optional | Select upto {maxSelection} options",
    maxLimitWarningAddon: "You have reached the maximum limit for this item",
    minRequiredWarningAddon:
      "You need to select at least {minSelection} item from {category}",
    bookingYourTable: "Booking your Table",
    pleaseDoNotCloseApplication: "Please do not close the application",
    alreadyTooManyBooking: "Already Too Many Bookings",
    have5ActiveBookings:
      "You already have 5 active bookings. A guest cannot have more than 5 active bookings. Please book from a different account.",
    sameSlotBooking: "Booking already exists",
    sameSlotBookingDescription:
      "Booking already exists for this time slot. Please try booking a different slot.",
    updateProfileTitle: "Update Profile",
    updateProfileDescription: "Please update your profile to continue",
    updateProfileCTA: "Update",
    selectItem: "Select",
    itemsAddedInCart: "Items added in cart",
    customizationPopupAddItemCTA: "ADD Item | {currency}{amount}",
    continueCTA: "Continue",
    bogoItemPlaceholderText: "{stack} Item",
    bogoOfferPageTitle: "Buy {buyQuantity} Get {getQuantity} Offer",
    bogoItemsTitle: "Buy {buyQuantity} Get {getQuantity} Items",
    missedPointsOnOrder:
      "You could've {br} Earned Reward Points {br} on this order",
    earnedPointsOnOrder:
      "You've Earned Reward Points {br} on this order {br} Download app to Redeem",
    orderFromAppToEarnPoints: "Order from app and earn points on every order",
    orderFromAppToRedeemPoints: "Order from app to redeem your points",
    downLoadAppCTA: "DOWNLOAD APP",
    downloadAppToManageProfileTitle: "Download app to manage profile",
    downloadAppToManageProfileDescription:
      "You can manage your profile and do a lot more things on our app",
    swipeToBookTable: "SWIPE TO BOOK TABLE",
    bogoOfferInstruction:
      "Collect reward, open menu on app, tap on ‘Offer Banner’, choose items of your choice. Coupon will be applied automatically.",
    bogoCouponTnC: "Maximum of {getQuantity} item will be free on an order",
    bogoCouponPerTnC:
      "Maximum of {getQuantity} item will be discounted on an order",
    bogoCouponMenuValidation: "Valid on selected items",
    bogoCouponCTA: "Select Items",
    bookingId: "Booking Id",
    bookingStatus: "Booking Status",
    groupedServiceSummary: "{itemCount} items · {duration} min",
    asSoonAsPossible: "As soon as possible",
    oneOrderMultipleServices: "One order, multiple services",
    checkoutInProgress: "Creating your booking…",
    slotNoLongerAvailable:
      "That time was just booked. Please choose another slot.",
    expiredCartServicesRemoved:
      "Services with expired slots were removed. Please review the remaining services.",
    cartNoLongerAvailable:
      "Your cart no longer contains services. Please add the services again.",
    invalidServiceGroup:
      "Some services could not be grouped. Please review your cart.",
    mixedHoodServiceGroup:
      "Services in one order must use the same service location.",
    bookingOrderReference: "Order reference",
    quantityShort: "Qty: {quantity}",
    downloadBill: "Download bill",
    serviceText: "Service",
    selectedServiceCount: "{count} selected",
    addMoreServices: "Add more services",
    selectionsSaved: "Your selections are saved while you browse.",
    itemsInCart:
      "{count, plural, one {# item in cart} other {# items in cart}}",
    categoriesInCart:
      "From {count, plural, one {# category} other {# categories}}",
    viewCart: "View",
    scheduleCart: "Schedule",
    clearCartTitle: "Remove all items from cart?",
    clearCartDescription:
      "Once removed, you'll have to add all the items again.",
    cartSelectionCleanupDelayMs: 300000,
    keepCart: "don't remove",
    confirmClearCart: "Yes, remove",
    changeAddressCartTitle: "Change service address?",
    changeAddressCartDescription:
      "Services vary by location. Changing to another service area will remove your cart items.",
    changeAddressAndClearCart: "Change and remove",
    distanceFromHood: "{distance} km from service hub",
    servingHomesWithCare: "Serving homes with care",
    yourHomeOurPriority: "Your home, our priority",
    bookOnceGetItAllDone: "Book once, get it all done",
    statusUnavailable: "Status unavailable",
    servicesCount: "{count, plural, one {# service} other {# services}}",
    paymentStatusLabel: "Payment: {status}",
    viewServices: "View services",
    hideServices: "Hide services",
    durationMinutes: "{duration} min",
    addMoreItems: "Add more items",
    offerExistInCart: "Offer already added in cart",
    offerExistInCartDescription:
      "Following items in your cart are part of the offer",
    removeItemsCTA: "Remove Items",
    removeItem: "Remove",
    goToCartCTA: "Go To Cart",
    applyCouponCTA: "APPLY THIS COUPON",
    offerRemovePopupTitle: "Applied coupon will be removed",
    offerRemovePopupDescription:
      "If you remove this item, your below applied coupon will also be removed.",
    offerRemovePopupCTA: "REMOVE",
    offerRemovePopupSecondaryCTA: "DO NOT REMOVE",
    offerNotApplicableTitle: "{preText} not applicable at the moment",
    offerNotApplicableDescription: "Not applicable at the moment",
    offerNotApplicableTitle2: "Offer not applicable at the moment",
    viewOfferDetails: "View Offer Details",
    viewDetailsCTA: "View Details",
    rateYourExperienceCTA: "Rate Your Experience",
    yourRatingText: "Your Rating",
    feedbackVisibleTimeInMinutes: "30",
    submitFeedbackCTA: "SUBMIT FEEDBACK",
    orderFeedbackTitle: "Order feedback",
    viewOrderText: "view order",
    foodRatingQuestion: "How was the food?",
    overallRatingQuestion: "How was your experience?",
    serviceRatingQuestion: "How was the service?",
    ambienceRatingQuestion: "How was the ambience?",
    feedbackSuccessText:
      "Thanks a lot for showing us your love. We'll make sure that your next visit is awseome.",
    feedbackSuccessBadText:
      "Thank you for sharing your honest feedback.  We apologise for not meeting your expectations. Our team will get back to you to discuss it in detail.",
    weLoveYoutooText: "We love you too",
    weAreImporvingText: "We are improving",
    weAreSorryText: "We're so sorry",
    enjoyCouponText: "Enjoy this coupon on your next visit",
    tellUsMore: "Tell us more (optional)",
    lastOrderListSize: "1",
    lastOrderPreviousDays: "3",
    collectOrder: "Collect your order from the counter",
    deliveryChargesTitle: "Delivery Charges",
    deliveryDiscount: "Delivery Discount",
    orderHistoryPopupTitle: "Order History",
    orderHistoryPopupSubtitle: "Download app to view your order history",
    orderHistoryPopupDesciption:
      "You can view your order history and do a lot more things on our app.",
    orderHistoryPopupCTA: "Download APP",
    selfPickupLabel: "Self Pickup",
    switchText: "SWITCH",
    addMoreItemsTitle: "Add more items",
    goToMenuCTA: "GO TO MENU",
    minBillAmountTnc:
      "Minimum bill of {currencySymbol}{minBillValue} is required for delivery orders {br} Please add some more items in your cart",
    paymentPollInterval: [0, 5, 10, 15, 20, 20, 20, 20, 20, 15, 5, 5],
    viewAllRatingsCTA: "View all Ratings",
    featuredItemsTitle: "Featured Items",
    swipeToPlaceOrder: "Swipe To Place Booking",
    rateYourLastExperience: "Rate your last experience",
    swipeToPay: "Swipe To Pay",
    nearby: "Nearby",
    outletDistanceDisplayThresoldInKm: "1",
    nearbyOutletThresoldInMeter: "50",
    addToCartCTA: "Add To Cart",
    availRewardWithPoints: "Avail this reward with {pointPrice} reward points",
    rewardDetails: "Reward Details",
    pointsDeducted: "{pointPrice} points will be deducted",
    appApplicableOnly: "Applicable only on app orders",
    swipeToCollectReward: "Swipe to Collect",
    excludeReservationStatus: "PENDING",
    checkedInText: "CHECKED IN",
    FoodImagePlaceholderUrl:
      "https://assets.fudr.in/assets/images/food-image-placeholder.png",
    maximumDiscountText2: "Upto ₹{maxValue}",
    knowMoreCTA: "Know More",
    selectItemCTA: "Select Items",
    applyOfferCTA: "Apply Offer",
    offerText: "Offer",
    rewardText: "Reward",
    couponAlreadyTaken:
      "You already have taken coupon with your {currencyName}",
    dayValidationError: "{preText} applicable only on {applicableWeekdays}",
    timeValidationError:
      "{preText} is available only from {startTime} to {endTime}",
    dateValidationError: "{preText} is available from {activationTime}",
    rewardValidationTitle: "{preText} not applicable at the moment",
    trackOrder: "Track order",
    offerAlreadyAppliedTitle: "{preText} already applied",
    removeOfferCTA: "Remove {preText}",
    amountValidationError:
      "This {preText} is applicable on minimum order amount of {currencySymbol}{minOrderValue}",
    amountValidationErrorTitle: "Add More Items",
    expireValidationDateError: "This {preText} is expired on {expireDate}",
    expireValidationError: "This {preText} is expired",
    expireValidationErrorTitle: "Offer Expired",
    useRewardPointToGetDiscount:
      "Use {currencyName} to get discount on you bill",
    billAmountPaidWithPoints2: "Pay upto {billAmount}% with {currencyName}",
    howToRedeemTitle: "How to Redeem",
    applyPointsOnCart: "Apply {currencyName} on cart page",
    okCTA: "OK",
    itemNotAvailableTitle: "Item not available",
    itemNotAvailableDescription:
      "This item is not available at the moment. {br} Sorry for the inconvenience",
    couponAppliedText: "{displayTitle} offer applied on this order",
    appliedCouponCTAText: "YAY!",
    reviewOnSocialText:
      "Please review us on social channels and let the world know about your experience",
    reviewOnGoogeText: "REVIEW US ON GOOGLE",
    reviewOnTripadvisorText: "REVIEW US ON TRIPADVISOR",
    homeAddressTitle: "Home",
    workAddressTitle: "Work",
    otherAddressTitle: "Other",
    nearbyOutletsSize: "5",
    viewMoreOutlets: "View More",
    menuSearchPlaceholder: "Search in Menu",
    menuSearchTitle: "Search Menu",
    specialInstructions: "Add Cooking Requests",
    swipeToOrderCTAText: "SWIPE TO PLACE BOOKING",
    swipeToPayCTAText: "SWIPE TO PAY",
    emptyNameMessage: "Please enter your name",
    emptyGenderMessage: "Please select gender",
    emptyEmailMessage: "Please enter your email",
    emptyDOBMessage: "Please enter a date",
    emptyAnniversaryDateMessage: "Please enter a date",
    namePlaceHolder: "Your Name",
    emailPlaceHolder: "Your email id",
    otpPlaceHolder: "OTP",
    phoneNumberPlaceHolder: "Mobile no.",
    doaPlaceHolder: "dd-mm-yyyy",
    doaSecondaryPlaceHolder: "Your Anniversary date",
    dobPlaceHolder: "dd-mm-yyyy",
    dobSecondaryPlaceHolder: "Your Birth date",
    signUpRequiredFields: ["name"],
    pointPrice: "{pointPrice} Points",
    lockedItemDealCTA: "View Items",
    unlockedItemDealCTA: "Select Items",
    promoCodePlaceholder: "Enter promo code",
    applyPromoCodeCTA: "APPLY",
    promoCodeNotFoundDescription:
      "The code you have entered is incorrect or expired.",
    promoCodeNotFoundTitle: "Promo code not found",
    promoOfferTitle: "Promo Offer",
    tncTitle: "Terms & Conditions",
    promoCodeTitle: "Have a Promo Code?",
    loyaltyPassTitle: "Loyalty Pass",
    applyCTAText: "Apply",
    unlockYourReward:
      "{name}, You’re just one step away from unlocking {displayTitle}",
    unlockYourRewardDescrption: "Register Now to claim this offer",
    verifyAndUnlockOffer: "Unlock Offer",
    grabOfferTitle:
      "You are one step away from claiming the offer. Grab it now !",
    demoOfferTnC:
      "This offer is a demo, provided exclusively for visualization purposes",
    otpVerificationTitle: "OTP Verification",
    orderConfirmationDemoTitle: "Thank you for completing the demo!",
    orderConfirmationDemoDescription: "We hope you found it engaging.",
    orderNowCTA: "Order Now",
    rewardProgramSubtext: " ",
    dealListOrderPriority: ["loyalty", "deal", "promo"],
    enterReferralCode: "Got a referral Code? {cta}",
    referralCodeFieldLabel: "Referral Code",
    referralCodePlaceHolder: "Enter Referral Code",
    enterReferralCodeCTA: "Enter Code",
    invalidReferralCodeTitle: "Invalid Referral Code",
    invalidReferralCodeDescription:
      "The referral code you’ve entered is not valid. Please enter a valid code",
    referrals: "My Referrals",
    referralsTitle: "Referrals",
    referralTabTitle: "My Referrals",
    referralCardTitle: "Refer & Earn",
    referralPopupTitle: "Refer & Earn",
    howReferralWorksTitle: "How it works",
    referralCodeTnc: "Share your Referral code with your friends",
    referralPointCardRule:
      "Share your Referral code with your friends and {rewardPoints} points when they place their first order",
    referralCouponCardRule:
      "Share your Referral code with your friends and get {dealName} when they place their first order",
    referralPointRule:
      "You’ll receive ‘{rewardPoints}’ points when your friend places their first order",
    referralCouponRule:
      "You’ll receive ‘{dealName}’ reward when your friend places their first order",
    gainerPointRule:
      "They’ll receive ‘{rewardPoints}’ points on signing up with your referral link",
    gainerCouponRule:
      "They’ll receive ‘{dealName}’ reward on signing up with your referral link",
    referralMilestonePointRule:
      "Get {rewardPoints} points on {thresold} successful referrals",
    referralMilestoneCouponRule:
      "Get {dealName} on {thresold} successful referrals",
    referralMilestonePointMaxThresoldRule:
      "Get {rewardPoints} points on {thresold} successful referrals upto {maxThresold} referrals",
    referralMilestoneCouponMaxThresoldRule:
      "Get {dealName} on {thresold} successful referrals upto {maxThresold} referrals",
    referralRewardKnowMoreCTA: "Know More",
    referralCodewhatsappShareMessage:
      "Hey, I’m using {brandName} app. Use my referral code {referralCode}",
    referralCodewhatsappShareMessagNew:
      "Craving something amazing? I use {brandName} to order all my favorites. Use my referral code {referralCode} when you sign up and you'll get a special discount. Don't miss out on the best food deals! Get the app: {appLink}",
    signupDetailsTitle: "One Last Thing",
    unlockCouponTitle: "You’ve unlocked {br} {displayTitle} coupon",
    unlockFallbackCouponTitle:
      "{displayTitle} coupon is for new guests, we’re happy to treat you to a {fallbackDisplayTitle} coupon!",
    unlockCouponDescription:
      "We’ve DMed you this coupon. {br} Redeem it on your next order",
    couponCodeText: "Coupon Code - {couponCode}",
    noOfferApplicableTitle: "Sorry, this offer is not applicable",
    noOfferApplicableDescription:
      "However, we’ve got you covered with exciting rewards from our loyalty program on our App!",
    goBackCTA: "Go Back",
    changeCTA: "Change",
    referralMilestoneProgress: "{completed}/{total} Referrals completed",
    genderFields: ["MALE", "FEMALE", "OTHER"],
    unlockFallbackOfferTitle:
      "{displayTitle} is only for newly joined members. However, we have got you covered with a special treat!",
    unlockOfferTitle: "You’ve unlocked {br} {displayTitle}",
    getBrandAppCTA: "Go to {brandName} App",
    offerAlreadyRedeemed: "Offer Successfully Redeemed",
    unlockMoreOfferOnApp:
      "Unlock more offers and earn rewards {br} Get the app now!",
    getMoreOffers: "Get More Offers!",
    offerExpiredTitle: "Sorry, this offer has expired.",
    getDealTitleCTA: "Get {dealTitle}",
    rewardPointEarnedTextWithoutCurrency: `{rewardPointsText} {br} Earned on this order`,
    cartAdditionalSupportText:
      "Prices include container charges (not applicable to beverages & add-ons)",
    orderingAtTitle: "Ordering at",
    pleaseSelectAnOutlet: "Please select an outlet",
    searchForOutlet: "Search for Outlet",
    sessionExpiryLoginTitle: "Verify it’s you",
    sessionExpiryLoginDescription:
      "You’ve been logged out due to inactivity. Please log in again with your registered  mobile number",
    sessionExpiryPopoverTitle: "Your session has expired",
    sessionExpiryPopoverDescription:
      "Please log in again to continue securely.",
    sessionExpiryPopoverCTA: "Log in again",
    tierUpgradeBenefitText:
      "Climb up to higher tier levels and unlock even bigger benefits!",
    isExternalLoyaltyEnabled: false,
    applyOfferOnCart:
      "Apply this offer on the cart page while placing the order",
    viewOfferDetailsCTA: "View Details",
    runningOrderFetchStatuses: ["UNATTENDED", "CONFIRMED"],
    minOrderValueOfferTnc:
      "Offer available on min. order of {currencySymbol}{minOrderValue}",
    refundSupportInfo: "",
    displayMenuItemImages: true,
    referralRewardTitle: "Referral Reward",
    loginToViewPoints: "Login to view your{br}earned  points",
    emptyReferralCodeMessage: "Please enter a valid referral code",
    emptyReferralRewardMessage:
      "No referrals yet. Share your referral code to start earning rewards!",
    referredBytext: "Referred By",
    referredTotext: "Referred To",
    referralActivationOnGainerActivation:
      "when they sign up with your referral",
    referralActivationPostGainerPurchase: "on their first order",
    referralActivationTotalSpend: "on their first order of ₹{amount}",
    referralActivationTotalSpendDefault: "when they place their first order",
    referralRewardReceived: "Referral reward received - {rewardValue}",
    referralRewardReceivedPoints:
      "Referral reward received - {rewardTitle} {currencyName}",
    referralRewardReceivedOffer: "Referral reward received - {rewardTitle}",
    referralRewardReceivedDefault: "Referral reward received - {rewardTitle}",
    referralRewardPending: "You'll receive {rewardValue} {conditionText}",
    referralRewardPendingOnActivation:
      "You'll receive reward once they sign up on the app",
    referralRewardPendingPostPurchase:
      "You'll receive reward on their first order",
    referralRewardPendingTotalSpend:
      "You'll receive a reward on their first order of ₹{amount}",
    referralRewardPendingTotalSpendDefault:
      "You'll receive a reward when they place their first order",
    referralRewardPendingPurchaseN:
      "You'll receive reward once they spend ₹{amount} at {brandName}",
    accessDeniedPopoverTitle: "Access Denied",
    accessDeniedPopoverDescription:
      "You’re logged in with {guestMobileNo} mobile no. This account do not have access to this page.",
    accessDeniedPopoverCTA: "Go To Home",
    accessDeniedPopoverSecondaryCTA: "Log Out",
    aRewardText: "a reward",
    loginToViewEarnedPointsAndReward:
      "Login to view your earned points and reward",
    loginToPlaceOrder: "Login to place order",
    guestModeLoginRequired: "You need to login to proceed",
    loginButton: "Login",
    serviceTypeValidationErrorTitle: "Offer not applicable",
    searchAddressPlaceholder: "Search address or area",
    skipCTAText: "SKIP",
    geolocationText: "Current Location",
    proximityRadius: "500",
    reviewBooking: "Review Booking",
    subTotal: "Sub Total",
    gstAndCharges: "GST & Charges",
    editCTA: "Edit",
    deleteCTA: "Delete",
    identifyingLocation: "Identifying your location",
    addressBook: "Address Book",
    addNewAddress: "Add New Address",
    selectDate: "Select Date",
    selectDuration: "Select Duration",
    selectSlot: "Select Slot",
    chooseService: "Choose Service",
    swipeToPlaceBooking: "SWIPE TO PLACE BOOKING",
    noBookings: "No Bookings to show",
    bookingDetils: "Booking Details",
    slotBooked: "Slot Booked",
    OTP: "OTP : ",
    bookedFor: "Booked For",
    addressText: "Address",
    cleaning: "Cleaning",
    atYourDoorStep: "At your doorstep in {defaultDispatchTimeMinutes} mins",
    currentlyUnavailable: "Currently Unavailable",
    earliestAvailableSlot: "Show earliest available slot",
    prebook: "Pre Book",
    neayYouSoon: "We’ll be near you soon!",
    notifyMe: "Notify Me",
    tapLocalityChange: "Tap here to choose the serviceable area",
    bookingConfirmed: "Booking Confirmed",
    bookingDateAndTime: "Booking Date & Time",
    bookedSlot: "Booked Slot",
    totalText: "Total",
    recoverCTA: "Recover",
    refundAndCancellationPolicy: "Refund & Cancellation Policy",
    refundAndCancellationPolicyDescription:
      "Full refund if cancelled within 5 mins of booking. {br} Refund for partial cancellations shall be adjusted against discounts.",
    privacyPolicyUrl: "https://www.qwiky.in/privacy-policy",
    tncUrl: "https://www.qwiky.in/tnc",
    refundPolicyUrl: "https://www.qwiky.in/refund-policy",
    instagramUrl: "https://www.instagram.com/qwiky_official/",
    whatsIncludedExcluded: "What’s Included and Excluded?",
    underStoodCTA: "Understood",
    fewHandyThings: "Few things to keep handy",
    expertTrainedTo: "The expert is trained to",
    whatIsNotIncluded: "What is not included?",
    companionshipIncludesConversation:
      "Friendly conversation and attentive companionship",
    companionshipIncludesActivities:
      "Company for light activities such as reading, games, or listening to music",
    companionshipIncludesWalk:
      "Accompaniment for a short walk in a safe and accessible nearby area",
    companionshipIncludesRoutine:
      "Gentle reminders for the agreed daily routine and scheduled activities",
    companionshipIncludesFamilyUpdate:
      "A basic service update for the family after the scheduled visit",
    companionshipExcludesMedicalCare:
      "Medical care, nursing, physiotherapy, diagnosis, or clinical monitoring",
    companionshipExcludesMedication:
      "Administering medicines, injections, or making medical decisions",
    companionshipExcludesPersonalCare:
      "Bathing, toileting, feeding, grooming, or other personal-care assistance",
    companionshipExcludesMobility:
      "Lifting, transferring, or supporting mobility where there is a fall risk",
    companionshipExcludesErrands:
      "Financial transactions, transportation, shopping, or errands outside the agreed visit",
    companionshipExcludesEmergency:
      "Emergency response, overnight supervision, or leaving the person unattended",
    learnMore: "Learn More",
    defaultPaymentType: "PRE_PAYMENT",
    showEarliestAvailableSlot: "Show earliest available slot",
    availableFrom: "Available at {nextSlotStart}",
    cancelBookingMessage:
      "Hi, I want to cancel my booking. Booking ID: {bookingCode}",
    bookingCancelMessage: "Hi Team, I want to cancel my booking.",
    supportPhoneNumber: "7297970825",
    supportWhatsAppNumber: "7297970825",
    forAnyAssistance:
      "For any assistance regarding your booking, please contact our support team at  <phone>{countryCode} {phoneNumber}</phone>",
    chatWithSupportOnWhatsApp: "Chat with our support team on WhatsApp",
    bookNowCTA: "Book Now",
    policiesAndPermissions: "Policies & Permissions",
    permissions: "Permissions",
    showTopBanner: false,
    showBottomBanner: true,
    myBookings: "My Bookings",
    changeSlot: "Change Slot",
    changeAddress: "Change Address",
    instantServiceStartMessage:
      "Service will start {defaultDispatchTimeMinutes} minutes after booking",
    userConsentPopoverTitle: "Before You Continue",
    userConsentPopoverPrimaryCTA: "I Agree",
    consentAcknowledgedDescription:
      "You agreed to the Terms of Service, Privacy Policy and service monitoring for safety and quality purposes.",
    userConsentMessage:
      "I agree to the Terms of Service, Privacy Policy and consent to service monitoring for safety and quality purposes.",
    userPreferenceMessage:
      "Your preferences are saved. You can change them anytime from profile.",
    requiredConsentMessage: "(Required)",
    optionalConsentMessage: "(Optional)",
    serviceStartOTP: "Service Start OTP",
    serviceEndOTP: "Service End OTP",
    remainingTimeLabel: "Time remaining",
    secondsRemainingLabel: "seconds remaining",
    serviceInProgress: "Service in Progress",
    serviceEndsAt: "Ends at {time}",
    userConsentTerms: [
      {
        type: "PII",
        label: "Personal Information",
        description:
          "I agree to the processing of my personal data for booking fulfillment.",
        default: true,
        version: "v1.0",
        required: true,
      },
      {
        type: "SERVICE_UPDATES",
        label: "Service Updates",
        description:
          "Receive service-related and transactional updates via SMS, WhatsApp, Email, Push notifications and RCS.",
        default: true,
        version: "v1.0",
        required: true,
      },
      {
        type: "MARKETING_COMMUNICATION",
        label: "Marketing Communication",
        description:
          "Receive promotional offers, loyalty benefits and new launch updates.",
        default: true,
        version: "v1.0",
        required: false,
      },
    ],
    expertText: "Expert {expertName}",
    assignedExpert: "Assigned Expert",
    ourServices: "Our Services",
    showUserConsentPopup: 0,
    bookingFailedMessage:
      "Your booking failed due to an unexpected issue. If any amount was deducted, the same will be credited within 4–5 working days.",
    bookingCancellationMessage:
      "We apologise for the inconvenience. Your booking was cancelled due to an unexpected issue. You can expect your refund in 4–5 working days.",
    faqs: [
      {
        title: "How do I receive a new booking?",
        targets: ["helpAndSupport"],
        description:
          "Stay online and keep notifications enabled. New bookings appear on the home screen with an alert.",
      },
      {
        title: "How do I start or complete a service?",
        targets: ["helpAndSupport"],
        description:
          "Ask the customer for the start OTP when you arrive. Use the end OTP only after completing the service.",
      },
      {
        title: "What should I do if the customer is unavailable?",
        targets: ["helpAndSupport"],
        description:
          "Call the customer from the booking card. If they do not respond, contact Qwiky support before leaving.",
      },
      {
        title: "When should I use SOS?",
        targets: ["helpAndSupport"],
        description:
          "Use SOS when you need urgent assistance during a booking. You can call support or chat on WhatsApp.",
      },
      {
        title: "Why am I not hearing booking alerts?",
        targets: ["helpAndSupport"],
        description:
          "Enable notifications and sound for Qwiky Partner in phone settings and ensure Battery Saver is not restricting the app.",
      },
      {
        title: "How is the booking safety recording used?",
        targets: ["helpAndSupport"],
        description:
          "Recording starts after a valid start OTP and stops after the end OTP. It is stored privately on your device for safety.",
      },
    ],
    appDownloadOneLinkUrl: "https://onelink.to/ebc2zk",
    verificationDisclaimer: "Verified. Trained. Top-rated.",
    prebookLookupDays: 3,
    bookingFailedLabel: "Failure Reason",
    bookingCancelledLabel: "Cancellation Reason",
    offerDetailsTitle: "Offer Details",
    offerDetailsPromoCode: "Use Promo Code {promoCode} during checkout",
    allowLocationAccess: "Allow Location Access",
    proceedToSchedule: "Proceed to Schedule",
    subCategorySectionTitle: "Choose from our services",
    selectCategory: "Select a category",
    selectSubcategory: "Select a subcategory",
    cartSubcategoryMismatch:
      "Only services from one subcategory can be added to a booking.",
    noExpertWorking: "No expert working",
    fullyBooked: "Fully booked",
    slotUnavailable: "Unavailable",
    noSlotsToday: "No slots available today. Please select another date.",
    noSlotsLater: "No slots available. Please check later.",
    noSlotsOnDate: "No slots available on {date}.",
    nextSlotsOnDate: "Next available on {date}.",
    logoutAllDevices: "Logout from all devices",
    confirmLogoutAllDevices:
      "Choose whether to logout from this device or all devices.",
    servicesTitle: "Services",
    viewBookingDetails: "View booking details",
    languageCode: "en",
    languageName: "English",
    appMaxInactiveTimeToReloadInMNS: 30,
    expertBookingPollingTime: 30000,
    expertBookingBackgroundPollingTime: 10000,
    expertBookingPendingPollingTime: 60000,
    expertBookingMaxPollingTime: 300000,
    expertBookingPollingJitterRatio: 0.1,
    partnerWebViewScale: 1,
    bookingReminderIntervalInSeconds: 10,
    bookingReminderIntervalInMinutes: 1,
    partnerServiceOtpLength: 4,
    partnerKioskModeEnabled: true,
    partnerKioskUseLockTaskMode: true,
    partnerKioskAllowedPackages: [
      "com.whatsapp",
      "com.whatsapp.w4b",
      "com.google.android.apps.maps",
      "com.google.android.dialer",
      "com.android.dialer",
      "com.android.server.telecom",
      "com.android.incallui",
      "com.samsung.android.dialer",
      "com.samsung.android.incallui",
    ],
    supportCallTitle: "Call support",
    supportCallDescription: "Speak with our support team",
    supportWhatsAppTitle: "Chat on WhatsApp",
    supportWhatsAppDescription: "Usually replies within a few minutes",
    supportEmailTitle: "Email support",
    supportEmailDescription: "For non-urgent questions and documents",
    faqHeading: "Frequently asked questions",
    updateNameTitle: "Update name",
    updateEmailTitle: "Update email",
    addEmailTitle: "Add email",
    enterNamePlaceholder: "Enter name",
    enterEmailPlaceholder: "Enter email",
    statusOnline: "Online",
    statusOffline: "Offline",
    statusBreak: "On break",
    bookingHistoryTitle: "Booking history",
    completedBookingsTitle: "Completed bookings",
    completedBookingsSubtitle: "You have delivered great service experiences.",
    rateBookingExperienceCTA: "Rate booking experience",
    additionalServicesCount: "+{count} more",
    bookingDetailsTitle: "Booking details",
    bookingDetailsLoadErrorTitle: "Booking details could not be loaded",
    bookingDetailsFeedbackDescription: "Share feedback about this completed booking.",
    loadingFeedbackText: "Loading feedback…",
    bookingInformationTitle: "Booking information",
    createdLabel: "Created",
    slotEndsLabel: "Slot ends",
    serviceTrackingTitle: "Service tracking",
    serviceStartTimeLabel: "Service start time",
    expectedEndTimeLabel: "Expected end time",
    serviceEndTimeLabel: "Service end time",
    sessionStatusLabel: "Service status",
    partnerBookingFeedbackTitle: "Rate booking experience",
    partnerBookingFeedbackDescription: "Share your experience with {customerName}",
    bookingFeedbackThanksTitle: "Thank you for your feedback",
    bookingFeedbackAlreadyProvidedTitle: "Feedback already provided",
    bookingFeedbackAlreadyProvidedText: "You have already shared feedback for this booking.",
    partnerFeedbackSuccessText: "Your feedback helps us improve every booking experience.",
    doneCTA: "Done",
    submittingFeedbackText: "Submitting…",
    ratingAriaLabel: "Booking rating",
    starRatingAriaLabel: "{value} out of 5 stars",
    tapStarRatingPrompt: "Tap a star to rate the booking",
    loadingFeedbackOptionsText: "Loading choices…",
    bookingFeedbackOptionsError: "Feedback choices could not be loaded. Please try again.",
    bookingFeedbackSubmitError: "We could not submit your feedback. Please try again.",
    feedbackCommentsLabel: "Additional comments (optional)",
    feedbackCommentsPlaceholder: "Share any helpful details",
    partnerRatingHeading1: "We're sorry—tell us what went wrong",
    partnerRatingHeading2: "Help us do better",
    partnerRatingHeading3: "What could we improve?",
    partnerRatingHeading4: "Glad the experience went well",
    partnerRatingHeading5: "Great—tell us about your experience",
    bookingsLoadErrorTitle: "Bookings could not be loaded",
    bookingsLoadErrorDescription:
      "Check your internet connection and try again.",
    retryCTA: "Try again",
    loadingText: "Loading…",
    unavailableText: "Not available",
    addressUnavailableText: "Address not available",
    statusUnavailableText: "Status not available",
    customerFallback: "Customer",
    serviceFallback: "Service",
    serviceDetailsTitle: "Service details",
    serviceQuantityValue: "Quantity: {quantity}",
    serviceDurationValue: "{minutes} min",
    completedStatus: "Completed",
    cancelledStatus: "Cancelled",
    rejectedStatus: "Rejected",
    completeProfileTitle: "Complete your profile",
    mobileUnavailableText: "Mobile number not available",
    personalInformationTitle: "Personal information",
    personalInformationDescription:
      "Accurate details help booking updates reach you on time.",
    noRatingsYet: "No ratings yet",
    totalRatingsValue: "{count} ratings",
    serviceTimingsTitle: "Service timings",
    shiftTimingsTitle: "Shift Timings",
    todayShiftLabel: "Today's shift",
    todayShiftDescription: "Today's shift is highlighted with a purple border below.",
    shiftTimingsUnavailableTitle: "Shift timings are unavailable",
    shiftTimingsUnavailableDescription: "Your schedule will appear here once it is assigned.",
    serviceTimingsDescription: "Your weekly shift for each assigned work area.",
    serviceHoodLabel: "Assigned work area",
    assignedHoodFallback: "Work area {number}",
    onLeaveLabel: "Weekly off",
    mondayShort: "Mon",
    tuesdayShort: "Tue",
    wednesdayShort: "Wed",
    thursdayShort: "Thu",
    fridayShort: "Fri",
    saturdayShort: "Sat",
    sundayShort: "Sun",
    bookingAcceptedTitle: "Booking accepted",
    bookingAcceptedSubtitle: "Booking accepted. Please arrive on time.",
    bookingInfoTitle: "Booking information",
    bookingTimeLabel: "Booking time",
    closeMapCta: "Close map",
    confirmed: "Confirmed",
    customerNameLabel: "Customer",
    doa: "Anniversary date",
    forTodayLabel: "For today",
    gotIt: "Got it",
    invalidOtpMessage: "Enter a valid OTP",
    lastUpdated: "Last updated",
    myRewardsLink: "My rewards",
    newBookingLabel: "New booking",
    noBookingMessage: "No active booking right now",
    noBookingsDescription: "New bookings will appear here.",
    noBookingsTitle: "No bookings found",
    openInGoogleMaps: "Open in Google Maps",
    policies: "Policies",
    punchInLabel: "Punch-in",
    refresh: "Refresh",
    secondsLabel: "seconds",
    selectCityManually: "Select city manually",
    selectLocationManually: "Select location manually",
    serviceDate: "Service date",
    serviceLocation: "Service location",
    slotTime: "Time slot",
    stopped: "Stopped",
    timeElapsedLabel: "Time elapsed",
    unattended: "Unattended",
    viewAddressInMap: "View address on map",
    viewMapRoute: "View route",
    todaysBookingTitle: "Today's booking",
    bookingInProgressTitle: "Booking in progress",
    bookingCompletedTitle: "Booking completed",
    partnerBookingCompletedDescription: "The service was completed successfully.",
    partnerBookingConfirmedDescription: "The booking is confirmed and ready for service.",
    partnerBookingInProgressDescription: "The service is currently in progress.",
    partnerBookingCancelledDescription: "This booking is no longer active.",
    customerPhoneLabel: "Customer phone number",
    startServiceCta: "Start service",
    endServiceCta: "End service",
    startServiceOtpSubtitle:
      "Ask the customer for the OTP to start the service.",
    endServiceOtpSubtitle:
      "Ask the customer for the OTP to complete the service.",
    enterOtp: "Enter OTP",
    enterOtpPlaceholder: "Enter service OTP",
    minutesRemainingValue: "{minutes} min",
    hoursRemainingValue: "{hours} hr",
    serviceEndsInLabel: "Service ends in",
    supportUnavailableMessage: "The support number is currently unavailable.",
    sosWhatsAppMessage:
      "SOS: I need urgent assistance with my Qwiky Partner booking.",
    sosSupportTitle: "Contact support",
    sosSupportDescription:
      "Choose how you want to contact the Qwiky support team.",
    sosChatCta: "Chat on WhatsApp",
    sosCallCta: "Call support",
    partnerLocationTitle: "Turn on your location",
    partnerLocationDescription:
      "Location helps with navigation and service verification. Bookings and alerts will continue even when it is off.",
    partnerLocationEnable: "Turn on location",
    partnerLocationOpenSettings: "Open location settings",
    partnerLocationChecking: "Checking location…",
    partnerServiceAreaLabel: "Your service area",
    partnerLocationUnavailable: "Turn on location to view your service area",
    searchByBillPlaceholder: "Search by bill number",
    instantServiceLabel: "Instant service",
  },
};
export { resourcesConfig };
export const supportedLocales = {
  en: "en",
  hi: "hi",
  bn: "bn",
};

/**
 * Common resource contract. The API follows this same shape and Redux retains
 * the complete object so changing locale never requires another network call.
 */

export const normalizeLocale = (locale) => {
  const normalizedLocale = String(locale || "").trim().toLowerCase();
  return /^[a-z]{2}(?:-[a-z]{2})?$/.test(normalizedLocale)
    ? normalizedLocale
    : supportedLocales.hi;
};

const omitUnavailableResourceValues = (resources = {}) =>
  Object.keys(resources || {}).reduce((availableResources, key) => {
    const value = resources[key];
    if (value !== null && typeof value !== "undefined") {
      availableResources[key] = value;
    }
    return availableResources;
  }, {});

const normalizePartnerContactResources = (localizedResources) => {
  const supportPhoneNumber = localizedResources.supportPhoneNumber;
  const normalizedPhone = String(
    supportPhoneNumber === null || typeof supportPhoneNumber === "undefined"
      ? ""
      : supportPhoneNumber,
  ).replace(/\D/g, "");
  const nationalPhone =
    normalizedPhone.length === 12 && normalizedPhone.startsWith("91")
      ? normalizedPhone.slice(2)
      : normalizedPhone;
  if (nationalPhone !== "7297970825") {
    return {
      ...localizedResources,
      supportPhoneNumber: "7297970825",
      supportPhoneNumner: "7297970825",
      supportWhatsAppNumber: "7297970825",
    };
  }
  return localizedResources;
};

/**
 * Selects the active API resource branch. Flat resources and shared top-level
 * values remain supported while the API payload migrates to { hi, en }.
 */
export const getLocalizedResources = (apiResources = {}, locale = "hi") => {
  const selectedLocale = normalizeLocale(locale);
  const localeBranchKeys = Object.keys(apiResources || {}).filter(
    (key) => /^[a-z]{2}(?:-[a-z]{2})?$/.test(key) &&
      apiResources[key] &&
      typeof apiResources[key] === "object" &&
      !Array.isArray(apiResources[key]),
  );
  const hasLocaleBranches = localeBranchKeys.length > 0;
  const bundledResources = {
    ...(resourcesConfig[selectedLocale] || resourcesConfig.en),
  };
  if (!hasLocaleBranches) {
    return normalizePartnerContactResources({
      ...bundledResources,
      ...omitUnavailableResourceValues(apiResources),
    });
  }
  const sharedResources = Object.keys(apiResources).reduce((shared, key) => {
    if (!localeBranchKeys.includes(key)) shared[key] = apiResources[key];
    return shared;
  }, {});
  const selectedApiResources = apiResources[selectedLocale] || {};
  return normalizePartnerContactResources({
    ...bundledResources,
    ...omitUnavailableResourceValues(sharedResources),
    ...omitUnavailableResourceValues(selectedApiResources),
  });
};

// Existing components use this default object only for local fallback messages.
export default resourcesConfig.hi;
